import apisauce from "apisauce";

let idleVar = null;
let lastIdleTime = null;
let egwStatus = null;
let refreshHandler = null;

function idleHandler() {
  localStorage.removeItem("userId");
  localStorage.removeItem("token");
  localStorage.removeItem("idLeader");
  localStorage.removeItem("authStore");
  localStorage.setItem("isForcedLogout", true)
  sessionStorage.clear();
  window.location = "./";
}

function refreshTokenTimer() {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }
  const apiGet = apisauce.create({
    baseURL:
      process.env.REACT_APP_BACKEN_END_API_NAGAMAS +
      "nagamas-authentication/api/v1.0/UserAuthentication/refreshToken",
    headers: {
      "Cache-Control": "no-cache",
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 5000,
  });
  apiGet.get("").then((res) => {
    // console.log("----refresh -----"+(res.ok));
    if (res.ok) {
      if (res.data.data === null) {
        idleHandler();
      } else {
        let jwtToken = res.data.data;
        if (jwtToken && jwtToken !== null) {
          localStorage.setItem("token", jwtToken);
        }
      }
    } else {
      idleHandler();
    }
  }).catch(e=> {
      idleHandler();
  });
  return;
}

const idleTimeout = process.env.REACT_APP_EKSAD_IDLE_TIMEOUT;
const tokenTimer = process.env.REACT_APP_EKSAD_TOKEN_REFRESH_INTERVAL;

const create = (type = "") => {
  // console.log(".................APIjs2...................");

  let token = localStorage.getItem("token");
  let userId = localStorage.getItem("userId");
  let api;

  // let baseUrl = process.env.REACT_APP_HCIS_BE_API
  let baseUrlEksad = process.env.REACT_APP_BACKEN_END_API_EKSAD;
  let baseUrlNagamas = process.env.REACT_APP_BACKEN_END_API_NAGAMAS;
  // let baseUrlBinary = process.env.REACT_APP_HCIS_BINARY_API_EKSAD
  // let baseUrlEksadLocal = process.env.REACT_APP_HCIS_BE_API_EKSAD_LOCAL
  //let baseUrlFlow = process.env.REACT_APP_HCIS_FLOW_API_EKSAD

  if (!token && type.indexOf("EKSAD") > -1) {
    window.location = "./";
  }

  if (type !== "NOTIF_BELL") {
    if (token) {
      if (!refreshHandler) {
        refreshHandler = setInterval(refreshTokenTimer, tokenTimer);
      }
      // if (lastIdleTime != null) {
      //   let currentActivityTime = new Date();
      //   //delta in secs
      //   let deltaIdleTime =
      //     (currentActivityTime.getTime() - lastIdleTime.getTime()) / 1000;
      //   // console.log(deltaIdleTime + "==========" + lastIdleTime.getTime() + "------------" + currentActivityTime.getTime());
      //   if (deltaIdleTime <= 1) {
      //     // console.log(".................IGNORE IDLETIME................");
      //   } else {
      //     lastIdleTime = currentActivityTime;
      //     // console.log("========" + idleTimeout);
      //     if (idleVar) {
      //       clearTimeout(idleVar);
      //     }
      //     idleVar = setTimeout(idleHandler, idleTimeout);
      //     // console.log("-----------------token---"+token);
      //     const arrJwt = token.split(".");
      //     const encoded = arrJwt[1];
      //     // console.log(encoded);
      //     // console.log(egwStatus);
      //     // console.log(".................New IdleHAndler................");
      //   }
      // } else {
      //   lastIdleTime = new Date();
      //   // console.log("========" + idleTimeout);
      //   if (idleVar) {
      //     clearTimeout(idleVar);
      //   }
      //   idleVar = setTimeout(idleHandler, idleTimeout);
      //   // console.log("-----------------token---"+token);
      //   const arrJwt = token.split(".");
      //   // console.log(encoded);
      //   // console.log(egwStatus);
      //   // console.log(".................New IdleHAndler................");
      // }
    }
  }

  switch (type) {
    case "IDP":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-authentication",
        // baseURL: "http://localhost:8081/nagamas-authentication/",
        // baseURL: "http://192.168.19.113:8080/nagamas-authentication/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "AUTHLOG":
      console.log(token);
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-authentication",
        // baseURL: "http://localhost:8081/nagamas-authentication/",
        // baseURL: "http://192.168.19.113:8080/nagamas-authentication/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "LOCAL":
      api = apisauce.create({
        baseURL: "http://localhost:8081/api/webpush",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;

    case "MASTERDATA_EKSAD":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/master/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_SERIES":
      api = apisauce.create({
        baseURL: "http://localhost:8081/nagamas/api/segmen/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          // 'Content-Type': 'application/json',
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_DELIVERY":
      api = apisauce.create({
        baseURL: "http://localhost:8081/nagamas/api/delivery/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          // 'Content-Type': 'application/json',
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_RECEIVINGPART":
      api = apisauce.create({
        baseURL: "http://localhost:8081/nagamas/api/receivingPart/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          // 'Content-Type': 'application/json',
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_CABANG":
      api = apisauce.create({
        baseURL: "http://localhost:8081/nagamas/api/cabang/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          // 'Content-Type': 'application/json',
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_BANK":
      api = apisauce.create({
        baseURL: "http://localhost:8081/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "LOCAL_RECEIVINGUNIT":
      api = apisauce.create({
        baseURL: "http://localhost:8081/nagamas/api/receiveUnit/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          // 'Content-Type': 'application/json',
          // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
        },
        timeout: 80000,
      });
      break;
    case "MASTERDATA_EMPL_EKSAD":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/empl/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "MASTERDATA_SECURITY_EKSAD":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-authentication/api/security/",
        // baseURL: "http://localhost:8081/authentication/api/security/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "MASTERDATA_ADMIN":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/admin/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;

    case "EKSAD":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "API_USER_RESET":
      api = apisauce.create({
        baseURL: `${baseUrlEksad}api/user/`,
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        timeout: 80000,
      });
      break;
    case "NOTIF_BELL":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/trx/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;

    case "TEMPLATE_EKSAD":
      api = apisauce.create({
        baseURL: baseUrlEksad + "api/template/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;

    case "NAGAMAS_MASTER_DATA":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-masterdata/api/v1.0/",
        // baseURL: "http://localhost:8081/api/v1.0/",
        // baseURL: "http://192.168.19.113:8082/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;

    case "NAGAMAS_DEV":
      api = apisauce.create({
        baseURL: "http://localhost:8081/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;

    case "NAGAMAS_AUTH":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-authentication/api/v1.0/",
        // baseURL: "http://localhost:8081/nagamas-authentication/api/v1.0/",
        // baseURL: "http://192.168.19.113:8080/nagamas-authentication/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "NAGAMAS_TRANSACTION":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-transaction/api/v1.0/",
        // baseURL: "http://localhost:8081/api/v1.0/",
        // baseURL: "http://192.168.19.113:8081/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "NAGAMAS_TRANSACTION_MULTIPART":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-transaction/api/v1.0/",
        // baseURL: "http://localhost:8084/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "NAGAMAS_DGI":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-dgi/api/v1.0/",
        // baseURL: "http://192.168.19.131:8085/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json;charset=UTF-8",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "NAGAMAS_DGI_FILE":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-dgi/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "blob",
        timeout: 80000,
      });
      break;
    case "NAGAMAS_REPORT":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-report/api/v1.0/",
        // baseURL: "http://localhost:8083/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "blob",
        timeout: 80000,
      });
      break;
    case "NAGAMAS_REPORT_DTO":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-report/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        timeout: 80000,
      });
      break;
    case "NAGAMAS_MASTER_DATA_FILE":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-masterdata/api/v1.0/",
        // baseURL: "http://localhost:8082/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "blob",
        timeout: 80000,
      });
      break;
    case "NAGAMAS_TRANSACTION_FILE":
      api = apisauce.create({
        baseURL: baseUrlNagamas + "nagamas-transaction/api/v1.0/",
        // baseURL: "http://localhost:8084/api/v1.0/",
        headers: {
          "Cache-Control": "no-cache",
          Accept: "*/*",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        responseType: "blob",
        timeout: 80000,
      });
      break;

    default:
      break;
  }

  // NAGAMAS MASTER
  const getGenSeqWithoutSave = (body) =>
    api.post("GenericSeq/getGenSeqWithoutSave", body);
  const testAPIError = () => api.post("Test/testErrorLog");
  const getAllProvince = () => api.get("mst-province");
  const getProvinceById = (id) => api.get(`mst-province/${id}`);

  const getAllCity = (provinceId) =>
    api.post("KabKot/findByParam", {
      paramFilters: { idProvince: provinceId },
    });
  const getCityById = (id) => api.get(`KabKot/${id}`);

  const getAllKecamatan = (cityId) =>
    api.post("MasterKecamatan/findByParam", {
      paramFilters: { idKabKot: cityId },
    });

  const getKecamatanById = (id) => api.get(`MasterKecamatan/findById/${id}`);

  const getAllKelurahan = (kecamatanId) =>
    api.post("MasterKelurahan/findByParam", {
      paramFilters: { idKecamatan: kecamatanId },
    });

  const getKelurahanById = (id) => api.get(`MasterKelurahan/${id}`);

  const getAllMasterParamConfigByCategory = (body) =>
    api.post("paramConfig/getByCategory", body);

  const getAllBizpar = (body) => api.post("MasterBizpar/findByParam", body);

  const saveAllBizpar = (body) => api.post("MasterBizpar/saveAll", body);

  const getAllMasterUser = () => api.get("getAllMasterUser");

  const getAllMasterCabang = (body) =>
    api.post("MasterCabang/getDataTable", body);

  const findAllMasterCabang = () => api.get("MasterCabang/findAll");

  const getMasterCabangById = (id) =>
    api.post("MasterCabang/getDataDetail", { kodeCabang: id });

  const createMasterCabang = (body) =>
    api.post("MasterCabang/saveMasterCabang", body);

  const updateMasterCabang = (body) =>
    api.put("MasterCabang/updateMasterCabang", body);

  const deleteMasterCabang = (id) =>
    api.delete(
      "MasterCabang/deleteByKodeCabang",
      {},
      { data: { kodeCabang: id } }
    );

  const getDataCabangForManagementClaim = (body) =>
    api.get("MasterCabang/getDataCabangForManagementClaim", body);

  const getAllMasterSupplier = (body) => api.post("mstSupplier/findAll", body);

  const createMasterSupplier = (body) => api.post("mstSupplier", body);

  const updateMasterSupplier = (body) => api.put("mstSupplier", body);

  const updateStatusMasterSupplier = (body) =>
    api.put("mstSupplier/updateStatus", body);

  const deleteMasterSupplier = (id) => api.delete(`mstSupplier/${id}`);

  const getMasterSupplierById = (id) => api.get(`mstSupplier/${id}`);

  const getAllMasterKas = (body) => api.post("MasterKas/findByParam", body);

  const getMasterKasById = (id) => api.get(`MasterKas/${id}`);

  const createMasterKas = (body) => api.post("MasterKas", body);

  const updateMasterKas = (body) => api.put("MasterKas", body);

  const deleteMasterKas = (id) => api.delete(`MasterKas/${id}`);

  // AUTH
  const getAllMasterRole = () => api.get("MasterRole/findAllRoles");

  const getPagingMasterRole = (body) =>
    api.post("MasterRoleMenu/findAllPaging", body);

  const createMasterRole = (body) => api.post("MasterRole/saveRole", body);

  const createRoleMenu = (body) =>
    api.post("MasterRoleMenu/saveUpdateMasterRoleMenu", body);

  const deleteMasterRole = (id) =>
    api.delete("MasterRole/deleteRole", {}, { data: { id: id } });

  const checkDeleteMasterRole = (id) =>
    api.get("MasterRole/checkDeleteRole", id);

  const getAllMasterMenu = () => api.get("MasterMenu/getallmastermenu");

  const getMasterRoleMenuById = (id) =>
    api.get(`MasterRoleMenu/findMasterRoleMenuByRoleId/${id}`);

  const getMasterMenuById = (id) =>
    api.get(`MasterRoleMenu/findMasterRoleMenuByRoleId/${id}`);

  const getAllHirarki = async () => {
    return await api.get("MasterHirarki");
  };

  const getByIdHirarki = (body) => api.get("MasterHirarki/" + body);
  const saveHirarki = (body) => api.post("MasterHirarki", body);
  const updateHirarki = (body) => api.put("MasterHirarki", body);
  const deleteHirarki = (body) => api.delete("MasterHirarki/" + body);

  const getAllSegmen = () => api.get("Segmen/findAllSegmen");
  const getAllSegmenPaging = (body) =>
    api.post("Segmen/findSegmenByParam", body);
  const saveOrUpdateSegmen = (body) => api.post("Segmen/createSegmen", body);
  const updateStatusSegmen = (body) => api.put("Segmen/updateStatus", body);
  const deleteSegmen = (body) => api.delete("Segmen/" + body);
  const downloadVariantSegmenExcel = (body) => api.get("Variant/downloadVariantExcel")
  const downloadWarnaSegmentExcel = (body) => api.get("Warna/downloadWarnaExcel")

  const getAllSubSegmen = () => api.get("SubSegment/findAllSubSegmen");
  const getAllSubSegmenPaging = (body) =>
    api.post("SubSegment/findAllPaging", body);
  const getAllSubSegmenByParam = (body) =>
    api.post("SubSegment/findByParam", body);
  const getSubSegmenById = (body) => api.get("SubSegment/getById/" + body);
  const saveSubSegmen = (body) => api.post("SubSegment/saveSubSegment", body);
  const updateSubSegmen = (body) =>
    api.put("SubSegment/updateSubSegment", body);
  const updateStatusSubSegmen = (body) =>
    api.put("SubSegment/updateStatus", body);
  const deleteSubSegmen = (body) =>
    api.delete("SubSegment/deleteSubSegment/" + body);

  const getAllSeries = () => api.get("Series/findAllSeries");
  const getAllSeriesByParam = (body) => api.post("Series/findByParam", body);
  const getAllSeriesPaging = (body) => api.post("Series/findAllPaging", body);
  const getSeriesById = (body) => api.get("Series/getById/" + body);
  const saveSeries = (body) => api.post("Series/saveSeries", body);
  const updateSeries = (body) => api.put("Series/updateSeries", body);
  const updateStatusSeries = (body) => api.put("Series/updateStatus", body);
  const deleteSeries = (body) => api.delete("Series/deleteSeries/" + body);

  const getAllType = (body) => api.get("Type/findAllType", body);
  const getAllTypeByParam = (body) => api.post("Type/findTypeByParam", body);
  const getAllTypePaging = (body) => api.post("Type/findAllPaging", body);
  const getTypeById = (body) => api.get("Type/getById/" + body);
  const saveType = (body) => api.post("Type/saveType", body);
  const updateStatusType = (body) => api.put("Type/updateStatus", body);
  const deleteType = (body) => api.delete("Type/deleteType/" + body);

  const getAllVariant = () => api.get("Variant/findAll");
  const getAllVariantPaging = (body) => api.post("Variant/findByParam", body);
  const getVariantById = (body) => api.get("Variant/getById/" + body);
  const saveVariant = (body) => api.post("Variant/saveVariant", body);
  const updateVariant = (body) => api.put("Variant/updateVariant", body);
  const updateStatusVariant = (body) => api.put("Variant/updateStatus", body);
  const deleteVariant = (body) => api.delete("Variant/deleteVariant/" + body);
  const downloadTemplateVariant = () =>
    api.get("Variant/downloadExcelTemplate");
  const downloadErrorLogVariant = () => api.get("Variant/downloadLogExcel");
  const uploadExcelVariant = (body) => api.post("Variant/uploadExcel", body);
  const getVariantByCabang = (body) =>
    api.get("Variant/getVariantByCabang?kodeCabang=" + body);

  const getAllWarna = (params) => api.get("Warna/findAllWarna", params);
  const getAllWarnaByParam = (body) => api.post("Warna/findWarnaByParam", body);
  const getAllWarnaByListKodeVariant = (body) =>
    api.post("Warna/findAllWarnaByListKodeVariant", body);
  const getAllWarnaPaging = (body) => api.post("Warna/findAllPaging", body);
  const getWarnaById = (body) => api.get("Warna/getById/" + body);
  const saveWarna = (body) => api.post("Warna/saveWarna", body);
  const updateWarna = (body) => api.put("Warna/updateWarna", body);
  const updateStatusWarna = (body) => api.put("Warna/updateStatus", body);
  const deleteWarna = (body) => api.delete("Warna/deleteWarna/" + body);
  const downloadTemplateWarna = () => api.get("Warna/downloadExcelTemplate");
  const downloadErrorLogWarna = () => api.get("Warna/downloadLogExcel");
  const uploadExcelWarna = (body) => api.post("Warna/uploadExcel", body);

  const getAllKSU = () => api.get("MasterKSU/findAll");
  const getAllKSUPagingByParam = (body) =>
    api.post("MasterKSU/findByParam", body);
  const getKSUById = (body) => api.get("MasterKSU/getById/" + body);
  const saveKSU = (body) => api.post("MasterKSU/saveMasterKSU", body);
  const updateKSU = (body) => api.put("MasterKSU/updateMasterKSU", body);
  const updateStatusKSU = (body) => api.post("MasterKSU/updateStatus", body);
  const deleteKSU = (body) => api.delete("MasterKSU/deleteByKodeKSU/" + body);

  const getAllHadiah = () => api.get("MasterHadiah");
  const getAllHadiahPagingByParam = (body) =>
    api.post("MasterHadiah/findByParam", body);
  const getHadiahById = (body) => api.get("MasterHadiah/" + body);
  const saveHadiah = (body) => api.post("MasterHadiah", body);
  const updateHadiah = (body) => api.put("MasterHadiah", body);
  const updateStatusHadiah = (body) =>
    api.post("MasterHadiah/updateStatus", body);
  const deleteHadiah = (body) => api.delete("MasterHadiah/" + body);

  const getAllOtherItem = () => api.get("OtherItem");
  const getAllOtherItemPagingByParam = (body) =>
    api.post("OtherItem/findByParam", body);
  const getOtherItemById = (body) => api.get("OtherItem/getById/" + body);
  const saveOtherItem = (body) => api.post("OtherItem/submit", body);
  const updateOtherItem = (body) => api.put("OtherItem", body);
  const updateStatusOtherItem = (body) =>
    api.post("OtherItem/updateStatus", body);
  const deleteOtherItem = (body) => api.delete("OtherItem/deleteById/" + body);

  const getAllBizparByParam = (body) =>
    api.post("MasterBizpar/findByParam", body);

  const getAllMasterLocation = () => api.get("MasterLocation/findByAll");
  const getAllMasterLocationPagingByParam = (body) =>
    api.post("MasterLocation/findByParam", body);
  const getMasterLocationById = (body) =>
    api.get("MasterLocation/getById/" + body);
  const saveMasterLocation = (body) => api.post("MasterLocation/submit", body);
  const deleteMasterLocation = (body) =>
    api.delete("MasterLocation/deleteLocation/" + body);

  const getAllInventoryUnitByParam = (body) =>
    api.post("Inventory/Unit/findAll", body);
  const getInventoryUnitDetailByParam = (body) =>
    api.post("Inventory/Unit/getDetail", body);
  const getInventoryUnitDetailHistory = (body) =>
    api.get("Inventory/Unit/" + body);

  const getAllInventoryKSUByParam = (body) =>
    api.post("Inventory/KSU/getInventoryKSUByParam", body);
  const getDetailInventoryKSU = (body) =>
    api.post("Inventory/KSU/getDetailInventoryKSU", body);
  const getDetailHistoryInventoryKSU = (body) =>
    api.post("Inventory/KSU/getMutationInventoryKSU", body);
  const getHistoryUnitInventory = (id) =>
    api.get("Inventory/Unit/getHistoryUnitInventory?noSin=" + id);
  const getCardStockInventory = (body) =>
    api.post("Inventory/Unit/cardStockInventory", body);
  const getCardStockInventoryDetail = (body) =>
    api.post("Inventory/Unit/cardStockInventoryDetail", body);
  const getKSUStockCard = (body) =>
    api.post("Inventory/KSU/getKSUStockCard", body);
  const getKSUStockCardDetail = (body) =>
    api.post("Inventory/KSU/getKSUStockCardDetail", body);

  const getAllEmployee = (body) => api.post("Employee/getall", body);
  const generateUsername = (body) =>
    api.post("MasterUser/generateUsername", body);
  const modifyEmployee = (body) => api.post("Employee", body);
  const updateEmployeeStatus = (body) => api.put("Employee/status", body);
  const deleteEmployee = (id) => api.delete(`Employee/${id}`);
  const getEmployeeById = (id) => api.get(`Employee/getById/${id}`);

  const getAllStockOpnameByParam = (body) =>
    api.post("StockOpname/getDataTableHeader", body);
  const deleteStockOpname = (body) =>
    api.delete("StockOpname/deleteStockOpname" + body);
  const getDetailStockOpnameUnit = (body) =>
    api.post("StockOpnameUnit/getStockOpnameUnitByStockOpnameNo" + body);
  const getDetailStockOpnameKSU = (body) =>
    api.post("StockOpnameKSU/getDetailStockOpnameKSU" + body);
  const submitAddDataDetailUnit = (body) =>
    api.post("StockOpnameUnit/getTransactionUnitByIdType", body);
  const submitAddDataDetailKSU = (body) =>
    api.post("StockOpnameKSU/getBarcodeKsuByKodeKSU", body);
  const submitProcessStockOpnameUnit = (body) =>
    api.post("StockOpnameUnit/saveAndUpdate", body);
  const submitProcessStockOpnameKSU = (body) =>
    api.post("StockOpnameKSU/saveAndUpdate", body);
  const submitProcessStockOpnameGIFT = (body) =>
    api.post("StockOpnameGift/submit", body);
  const submitProcessStockOpnamePart = (body) =>
    api.post("StockOpnamePart/saveAndUpdate", body);
  const reportSO = (body) => api.get("StockOpnameResolve/ReportSO" + body);
  const dataKelebihanSO = (body) =>
    api.get("StockOpnameResolve/DataKelebihan" + body);
  const dataKekuranganSO = (body) =>
    api.get("StockOpnameResolve/DataKekurangan" + body);
  const saveKelebihanSO = (body) =>
    api.post("StockOpnameResolve/SaveDataKelebihan", body);
  const submitResolving = (body) =>
    api.post("StockOpnameResolve/submitResolving", body);
  const getListDataPartByQrCode = (body) =>
    api.get("Part/getListDataPartByQrCode?qrCode=" + body);
  const getListDropdownOtherItemSO = (body) =>
    api.post("OtherItem/findByParam", body);
  const printStockOpnameReportSO = (body) =>
    api.post("StockOpname/stockOpnameHandleReportPrintV2", body);
  const printStockOpnameReportKelebihan = (body) =>
    api.post("StockOpname/stockOpnameHandleOverPrintV2", body);
  const printStockOpnameReportKekurangan = (body) =>
    api.post("StockOpname/stockOpnameHandleMinustPrintV2", body);
  const printStockOpnameReportSummary = (body) =>
    api.post("StockOpname/stockOpnameHandleSummaryPrintV2", body);

  const getAllReceivingUnitNOSByParam = (body) =>
    api.post("ReceivingUnit/findAll", body);
  const getDetailReceivingUnitNOS = (body) =>
    api.get("ReceivingUnit/getById" + body);
  const submitReceivingUnitNOS = (body) =>
    api.post("ReceivingUnit/submit", body);
  const deleteReceivingUnitNOS = (body) =>
    api.delete("ReceivingUnit/deleteBySpbmNo" + body);
  const generateQRReceivingUnitNOS = (body) =>
    api.post("QRCode/generateQRPdfUnit", body);
  const updateNumberOfPrintQRCodeUnitNOS = (body) =>
    api.put("ReceivingUnit/updateNumberOfPrints", body);
  const checkingValidUnitNOS = (body) =>
    api.post("ReceivingUnit/checkNosin" + body);

  const getAllSupplierMainDealer = (kodeCabang) =>
    api.get("mstSupplier/getSupplierMainDealer" + kodeCabang);
  const getSupplierMainDealerBySourceCode = (kodeCabang) =>
    api.get("mstSupplier/getActiveSupplierByKodeCabang" + kodeCabang);
  const getSupplierNotExpedition = (kodeCabang) =>
    api.get("mstSupplier/getSupplierNotExpedition", kodeCabang);
  const getAllSupplierExpedition = (kodeCabang) =>
    api.get("mstSupplier/getSupplierExpedition" + kodeCabang);

  const getAllMasterLeasing = (body) => api.post("MasterLeasing/findAll", body);

  const getMasterLeasingById = (id) =>
    api.get(`MasterLeasing/findByLeasingId?leasingId=${id}`);

  const updateMasterLeasingStatus = (body) =>
    api.post("MasterLeasing/updateStatus", body);

  const deleteMasterLeasing = (id) =>
    api.delete(`MasterLeasing/delete?leasingId=${id}`);

  const modifyMasterLeasing = (body) =>
    api.post("MasterLeasing/saveAndUpdate", body);

  const getAllMasterSamsat = (body) => api.post("Samsat/findByParam", body);

  const getMasterSamsatById = (id) => api.get(`Samsat/findById/${id}`);

  const updateMasterSamsatStatus = (body) => api.put("Samsat/update", body);

  const deleteMasterSamsat = (id) => api.delete(`Samsat/delete/${id}`);

  const modifyMasterSamsat = (body) => api.post("Samsat/submit", body);

  const getAllReceivingDGI = (body) =>
    api.post("ReceivingUnit/getDataTable", body);

  const updateReceivingDGI = (body) => api.put("ReceivingUnit/update", body);

  const getReceivingDGIDetail = (kc, sl) =>
    api.get(
      `ReceivingUnit/findReceivingUnitAndDetail?kodeCabang=${kc}&slNo=${sl}`
    );

  const validateReceivingDGIDetail = (body) =>
    api.post("ReceivingUnit/listEditableDetail", body);

  const getAllReceivingKSUByParam = (body) =>
    api.post("ReceivingKsu/findAll", body);
  const getDetailBarcodeReceivingKSU = (body) =>
    api.get("ReceivingKsu/findKsuAndBarcode" + body);
  const getDetailReceivingKSU = (body) =>
    api.get("ReceivingKsu/findKsuAndDetail" + body);
  const submitReceivingKSU = (body) =>
    api.post("ReceivingKsu/saveAndUpdate", body);
  const generateQRReceivingUnitKSU = (body) =>
    api.post("QRCode/generateQRPdf", body);
  const updateNumberOfPrintQRCodeKSU = (body) =>
    api.post("ReceivingKsuBarcode/updateNumbersOfPrints", body);
  const deleteReceivingKSU = (body) => api.delete("ReceivingKsu/delete" + body);

  const getAllMasterBank = (body) => api.post("MasterBank/findAll", body);

  const saveMasterBank = (body) => api.post("MasterBank", body);

  const updateStatusMasterBank = (body) => api.put("MasterBank", body);

  const deleteMasterBank = (id) => api.delete(`MasterBank/deleteById/${id}`);

  const getMasterBankById = (id) => api.get(`MasterBank/findById/${id}`);

  const getAllMutation = (body) => api.post("MutationController/findAll", body);

  const getMutationById = (id) => api.get(`MutationController?id=${id}`);

  const deleteMutation = (body) => api.delete(`MutationController?id=${body}`);

  const createMutation = (body) => api.post("MutationController", body);

  const submitProcessMutationOut = (body) =>
    api.put("MutationController", body);

  const submitMutation = (body) =>
    api.post("MutationController/submitMutationIn", body);

  const rejectAllMutation = (body) =>
    api.put(`MutationController/rejectAll`, body);

  const getUnitList = (body) => api.post("TransactionUnit/getListUnit", body);

  const findBarcodeUnitMutation = (body) =>
    api.post("MutationController/findBarcodeUnit", body);

  const checkQtyMutasiHadiahDanBarangLain = (body) =>
    api.post("MutationController/checkAdjustQtyNonBarcode", body);

  const getNoSinByEncryptedBarcode = (id) =>
    api.get("TransactionUnit/getNoSinByEncryptedBarcode?encryptedBarcode=", id);

  const findBarcodeKsuBrlHdhMutation = (body) =>
    api.post("MutationController/findBarcodeKsuBrlHdh", body);

  const getAllPOUnit = (body) => api.post("POUnit/findByParam", body);

  const getPOUnitById = (id) => api.get(`POUnit/findById?poNo=${id}`);

  const getTempPOUnit = (kodeCabang, poMonth) =>
    api.get(`POUnit/getTemp?kodeCabang=${kodeCabang}&poMonth=${poMonth}`);

  const createPOUnit = (body) => api.post("POUnit/submit", body);

  const deletePOUnit = (id) => api.delete(`POUnit/delete?poNo=${id}`);

  const getAllMasterPart = (body) => api.post("Part/findByParam", body);
  const submitPart = (body) => api.post("Part/submit", body);
  const getByKodePart = (id) => api.get(`Part/findById/${id}`);
  const updateStatusPart = (body) => api.put("Part/updateStatus", body);
  const deletePart = (id) => api.delete(`Part/delete/${id}`);
  const downloadTemplateMasterPart = () => api.get("Part/exportTemplate");
  const downloadErrorLogMasterPart = () => api.get("Part/downloadLogExcel");
  const uploadMasterPart = (body) => api.post("Part/uploadExcel", body);

  const getAllMasterApprovalFindByParam = (body) =>
    api.post("MasterApproval/findAll", body);
  const getMasterApprovalById = (body) =>
    api.get("MasterApproval/findByApprovalId/" + body);
  const saveMasterApproval = (body) =>
    api.post("MasterApproval/saveAndUpdate", body);
  const updateStatusMasterApproval = (body) =>
    api.post("MasterApproval/updateStatus", body);
  const deleteMasterApproval = (body) =>
    api.delete("MasterApproval/deleteByApprovalId/" + body);

  const findAllClaimC1 = (body) => api.post("ClaimC1/findByParam", body);
  const findByClaimNo = (body) => api.get("ClaimC1/findById" + body);
  const submitClaimC1 = (body) => api.post("ClaimC1/submit", body);
  const deleteClaimC1 = (body) => api.delete("ClaimC1/delete?claimNo=" + body);
  const getEngineNumberByKodeLocator = (kodeLocator) =>
    api.get(`ClaimC1/getEngineNumberByKodeLocator`, kodeLocator);
  const getUnitDetailByEngineNumber = (engineNumber) =>
    api.get(`ClaimC1/getUnitDetail/${engineNumber}`);
  const generateSeqWithoutSave = (body) =>
    api.post("GenericSeq/getGenSeqWithoutSave", body);

  const getAllMasterUnitPrice = (body) =>
    api.post("MasterUnitPrice/findAll", body);

  const getMasterUnitPriceById = (id) => api.get(`MasterUnitPrice?id=${id}`);

  const createMasterUnitPrice = (body) => api.post("MasterUnitPrice", body);

  const deleteMasterUnitPrice = (id) => api.delete(`MasterUnitPrice?id=${id}`);
  const downloadTemplateMasaterUnitPrice = () =>
    api.get("MasterUnitPrice/exportTemplate");
  const uploadTemplateMasaterUnitPrice = (body) =>
    api.post("MasterUnitPrice/uploadExcel", body);
  const downloadLogErrorTemplateMasaterUnitPrice = () =>
    api.get("MasterUnitPrice/downloadLogExcel");

  const getPreviewBarcode = (body) =>
    api.post("GenericSeq/getGenSeqWithoutSave", body);

  const getBizparCategoryByParam = (body) =>
    api.post("paramConfig/getBizparCategoryByParam", body);
  const deleteAllBizparByCategory = (category) =>
    api.delete("MasterBizpar/deleteByBizparCategory", {}, { data: category });

  const generateMasterPackageId = (body) => api.get("Package/generateId");
  const getAllMasterPackageFindByParam = (body) =>
    api.post("Package/getAllPaging", body);
  const getMasterPackageById = (body) => api.get("Package/getById" + body);
  const saveMasterPackage = (body) => api.post("Package/submit", body);
  const updateStatusMasterPackage = (body) =>
    api.put("Package/updateStatus", body);
  const copyMasterPackage = (body) => api.post("Package/copy", body);

  const getAllSSU = (body) => api.post("SSU/findByParam", body);
  const getSubmissionSSU = (body) => api.post("SSU/getSubmissionSSU", body);
  const getReceivedSSU = (body) => api.post("SSU/getReceivedSSU", body);
  const getReceivedSSUByPeriod = (body) =>
    api.post("SSU/getReceivedSSUByPeriod", body);

  const createSSU = (body) => api.post("SSU/saveUpdate", body);

  const deleteSSU = (body) => api.post("SSU/uploadPhotoSSU", body);

  const getSSUById = (id) => api.get(`SSU/getSSUById?ssuId=${id}`);

  const uploadSSUPhoto = (body) => api.post("SSU/uploadPhotoSSU", body);

  const getAllMasterSales = (body) => api.post("Sales/findByParam", body);

  const getMasterSalesById = (id) => api.get(`Sales/findTeam/${id}`);

  const getMasterSalesByteam = (teamId) => api.get(`Sales/findTeam/${teamId}`);

  const createMasterSales = (body) => api.post("Sales/submit", body);

  const findSalesNotInSalesLead = (code) =>
    api.get(`Employee/findSalesNotInSalesLead/${code}`);

  const findSalesNotInSalesTeam = (code) =>
    api.get(`Employee/findSalesNotInSalesTeam/${code}`);

  const deleteSalesLead = (id) => api.delete(`Sales/deleteSalesLeadId/${id}`);

  const deleteSales = (id) => api.delete(`Sales/deleteSales/${id}`);

  const findAllBeforeSubmissionSamsat = (body) =>
    api.post("TransactionSamsat/getDataDraft", body);
  const findAllOnSubmissionSamsat = (body) =>
    api.post("TransactionSamsat/getDataSubmission", body);
  const findDetailOnSubmissionSamsat = (body) =>
    api.get("TransactionSamsat/getDetailSubmission" + body);
  const getDraftForSubmission = (body) =>
    api.post("TransactionSamsat/getDraftForSubmission", body);
  const saveSubmission = (body) =>
    api.post("TransactionSamsat/saveSubmission", body);
  const exportToExcelSubmission = (body) =>
    api.post("TransactionSamsat/exportSubmissionToExcel", body);
  const findAllReceivingSamsat = (body) =>
    api.post("TransactionSamsat/getDataReceiving", body);
  const findDetailReceivingSamsat = (body) =>
    api.get("TransactionSamsat/getDetailReceiving" + body);
  const saveReceivingSamsatSTNK = (body) =>
    api.post("TransactionSamsat/saveSTNK", body);
  const saveReceivingSamsatLembarPajak = (body) =>
    api.post("TransactionSamsat/saveLembarPajak", body);
  const saveReceivingSamsatBPKB = (body) =>
    api.post("TransactionSamsat/saveBPKB", body);
  const saveReceivingSamsatPlatKendaraan = (body) =>
    api.post("TransactionSamsat/savePlatKendaraan", body);

  const findAllPenyerahanBBNIndividu = (body) => api.post("Bbn/findAll", body);
  const findDetailPenyerahanBBNIndividu = (body) =>
    api.get("Bbn/findById/" + body);
  const savePenyerahanBBNIndividu = (body) =>
    api.post("Bbn/submitBbnDetail", body);
  const printBbnIndividu = (id) =>
    api.post("Bbn/generateCetakanBbnIndividu" + id);

  const findAllPenyerahanBBNLeasing = (body) =>
    api.post("BBNBPKBLeasing/findAllLeasingTab", body);
  const findDetailPenyerahanBBNLeasing = (body) =>
    api.get("BBNBPKBLeasing/getById" + body);
  const findBPKBReady = (body) => api.post("BBNBPKBLeasing/getBPKBReady", body);
  const savePenyerahanBBNLeasing = (body) =>
    api.post("BBNBPKBLeasing/submitLeasingBbn", body);
  const exportToExcelBBNLeasing = (body) =>
    api.post("BBNBPKBLeasing/exportDetailToExcel", body);

  const getAllMasterBBN = (body) => api.post("MasterBbn/findAll", body);
  const getDetailMasterBBN = (body) => api.get("MasterBbn/getById/" + body);
  const saveMasterBBN = (body) => api.post("MasterBbn/saveUpdate", body);
  const deleteMasterBBN = (body) => api.delete("MasterBbn/deleteById/" + body);
  const downloadTemplateBBN = () => api.get("MasterBbn/downloadExcelTemplate");
  const uploadTemplateBBN = (body) => api.post("MasterBbn/uploadExcel", body);
  const downloadLogErrorBBN = () => api.get("MasterBbn/downloadLogExcel");

  const getDeliveryData = (body) => api.post("Delivery/getDataDelivery", body);
  const submitDeliveryData = (body) =>
    api.post("Delivery/submitDataDelivery", body);
  const getDeliveryDetail = (id) =>
    api.get(`Delivery/getDetailDelivery?deliveryId=${id}`);
  const uploadDeliveryImage = (body) =>
    api.put("Delivery/uploadDeliveryPhoto", body);
  const updateDeliveryStatus = (id) =>
    api.get(`Delivery/updateDeliveryStatus?deliveryId=${id}`);

  const getAllPDI = (body) => api.post("PDI/getNotPDIYet", body);
  const getAllDonePDI = (body) => api.post("PDI/getPDI", body);
  const getPDIById = (id) => api.get(`PDI/getPDIById?pdiNo=${id}`);
  const modifyPDI = (body) => api.post("PDI/saveUpdate", body);
  const refreshPDIAndExpedition = (body) =>
    api.get(`PDI/refreshDetailPDI` + body);
  const checkPDIToDeliveryItem = (body) =>
    api.get(`PDI/checkPDIToDeliveryItem`, body);
  const checkStatusBarcodeBulk = (body) => api.post(`PDI/checkStatusBarcode`, body);

  const getAllLeasingPayment = (body) =>
    api.post("LeasingPayment/getLeasingPaymentData", body);
  const getDetailLeasing = (id) =>
    api.get(`LeasingPayment/getDetailLeasingPayment?leasingBillingID=${id}`);
  const submitLeasingPayment = (body) =>
    api.post("LeasingPayment/submitLeasingPayment", body);
  const getEmployeeForDDLLeasingPayment = (body) =>
    api.get("Employee/getUserForDropDownListLeasingPayment" + body);
  const getBBMForPaymentLeasing = (body) =>
    api.get(`PaymentBank/getBBMForPaymentLeasing`, body);

  const getPaymentCashStatus = (body) =>
    api.post("PaymentCash/getDataForStatusTab", body);
  const getBKKData = (body) => api.post("PaymentCash/getDataTabBKK", body);
  const getBKMData = (body) => api.post("PaymentCash/getDataBKM", body);
  const getBKKDetail = (id) => api.get(`PaymentCash/getDetailBKK/${id}`);
  const getBKMDetail = (id) => api.get(`PaymentCash/getDetailBKM/${id}`);
  const submitPaymentCash = (body) =>
    api.post("PaymentCash/submitPaymentCash", body);
  const printBKK = (body) => api.post("PaymentCash/generatePrintBKK", body);
  const printBKM = (body) => api.post("PaymentCash/generatePrintBKM", body);
  const getPaymentCashCancel = (body) =>
    api.post(`PaymentCash/getDataForTabCancelled`, body);
  const cancelPaymentCash = (body) =>
    api.put(`PaymentCash/cancelPaymentCash` + body);
  const updatePrintCountAndStatusCash = (body) =>
    api.get("PaymentCash/updatePrintCountAndStatus" + body);

  const getPaymentBankStatus = (body) =>
    api.post("PaymentBank/getDataTabStatus", body);
  const submitPaymentBank = (body) => api.post("PaymentBank/saveUpdate", body);
  const getBBMData = (body) => api.post("PaymentBank/getDataTabBBM", body);
  const getBBKData = (body) => api.post("PaymentBank/getDataTabBBK", body);
  const getBBMDetail = (id) => api.get(`PaymentBank/getDetailBBM/${id}`);
  const getBBKDetail = (id) => api.get(`PaymentBank/getDetailBBK/${id}`);
  const getReferenceFJ = (body) => api.post(`SalesOrder/getReferenceFJ`, body);
  const getReferenceSO = (body) => api.post(`StockOpname/getReferenceSO`, body);
  const getPaymentBankCancel = (body) =>
    api.post(`PaymentBank/getDataForTabCancelled`, body);
  const cancelPaymentBank = (body) =>
    api.put(`PaymentBank/cancelPaymentBank` + body);
  const printBBK = (body) => api.post("PaymentBank/generatePrintBBK", body);
  const printBBM = (body) => api.post("PaymentBank/generatePrintBBM", body);
  const updatePrintCountAndStatusBank = (body) =>
    api.get("PaymentBank/updatePrintCountAndStatus" + body);
  const verifyPoNumberLeasing = (body) =>
    api.get("SalesOrder/verifyPoNumberLeasing" + body);
  const printMainPageSalesOrderNos = (body) =>
    api.post("SalesOrder/exportSalesOrderTabNosToExcel", body);

  const getAllEkspedisi = (body) =>
    api.post("Expedition/getDataMainTable", body);
  const getDetailEkspedisi = (body) =>
    api.get("Expedition/getDetailExpedition" + body);
  const prosesEkspedisi = (body) =>
    api.post("Expedition/saveDataExpedition", body);
  const cetakBASTDealer = (body) =>
    api.post("CetakanEkspedisi/generateCetakanBASTDealer", body);
  const cetakBASTMainDealer = (body) =>
    api.post("CetakanEkspedisi/generateBASTMainDealer", body);
  const cetakBASTBukuService = (body) =>
    api.post("CetakanEkspedisi/generateBASTBukuService", body);
  const cetakBASTTemplate = (body) =>
    api.post("CetakanEkspedisi/generateBASTTemplate", body);
  const getDataForEkspedisi = (body) => api.get("Inventory/getDataForEkspedisi" + body);
  const getDataForEkspedisiPart = (body) => api.get("/InventoryH3/getDataForEkspedisi" + body);

  const getAllCDB = (body) => api.post("CustomerProfile/getDataMainPage", body);
  const getDetailCDB = (body) =>
    api.get("CustomerProfile/getCustomerProfile" + body);
  const getDataCabangHistoryCDB = (body) =>
    api.get("CustomerProfile/getDataCabangHistoryCDB", body);
  const getDetailHistoryServiceCDB = (body) =>
    api.get("CustomerProfile/getDetailHistoryService", body);
  const updateSpecialNoteCDB = (body) =>
    api.post("CustomerProfile/updateSpecialNote", body);
  const uploadProfilePictureCDB = (body) =>
    api.post("CustomerProfile/uploadProfilePicture", body);
  const getCustomerNonUUID = (body) =>
    api.get("CustomerProfile/getCustomerNonUUID", body);

  const getListSalesOrderNOS = (body) =>
    api.post("SalesOrder/getDataTabNos", body);
  const getListUnitForSalesOrder = (body) =>
    api.post("TransactionUnit/getListUnitForSalesOrder", body);
  const getListCustomerForSalesOrder = (body) =>
    api.get("CustomerProfile/getCustomerForSalesOrder" + body);
  const getDataHeaderSalesOrderNOS = (body) =>
    api.get("SalesOrder/Detail/getDataHeader" + body);
  const getDetailBuyerSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataBuyer" + body);
  const getDetailOwnerSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataOwner" + body);
  const getDetailPhotoSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getPhotos" + body);
  const getDetailUnitSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataUnit" + body);
  const getDetailPackageSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataPackage" + body);
  const getListPackageSalesOrder = (body) => api.post("Package/getForFJ", body);
  const getDetailTransactionSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataTransaction" + body);
  const getDetailDeliverySalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataDelivery" + body);
  const getDetailReferralSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataReferral" + body);
  const getDetailNoteSalesOrder = (body) =>
    api.get("SalesOrder/Detail/getDataNote" + body);
  const submitSalesOrder = (body) =>
    api.post("SalesOrder/submitSalesOrder", body);
  const checkNIKSalesOrder = (body) => api.get("SalesOrder/checkNIK" + body);
  const getProspectForSalesOrder = (body) =>
    api.get("Prospect/getForFJ" + body);
  const getIndentForSalesOrder = (body) =>
    api.get("TransactionIndentUnit/getForFJ" + body);
  const getPriceUnitSalesOrder = (body) =>
    api.get("MasterUnitPrice/findUnitDetailByKodeVarian" + body);
  const getMasterPromoSalesOrder = (body) =>
    api.get("MasterPromo/getForFj" + body);
  const getMasterPromoCreditSalesOrder = (body) =>
    api.get("MasterPromo/getForFjDetail" + body);
  const getDropDownListSalesForSalesOrder = (body) =>
    api.get("Employee/salesForDropDownList", body);
  const printSalesOrder = (body) =>
    api.post("SalesOrder/salesOrderPrint", body);
  const cancelOrderFJ = (id) => api.post(`SalesOrder/cancelSalesOrder?nomorFakturJual=${id}`)

  // master voucher
  const getTabMasterVoucher = (body) =>
    api.post("MasterVoucher/getDataTabMasterVoucher", body);
  const getByVoucherId = (id) =>
    api.get(`MasterVoucher/findByVoucherId?voucherId=${id}`);
  const deleteByVoucherId = (id) =>
    api.delete(`MasterVoucher/deleteByVoucherId?voucherId=${id}`);
  const saveAndUpdateVoucher = (body) =>
    api.post("MasterVoucher/saveAndUpdate", body);
  const checkExistingVoucherName = (name) =>
    api.get(`MasterVoucher/checkExistVoucherName?voucherName=${name}`);

  // crm - assign prospect
  const getDataTabAssignProspect = (body) =>
    api.post("Prospect/getDataTabAssignProspect", body);
  const getDetailProspect = (id) =>
    api.get(`Prospect/getDetail?prospectId=${id}`);
  const assignProspect = (body) => api.post("Prospect/assignProspect", body);
  const getEmployeeForCRM = (cabang) =>
    api.get(`Employee/getEmployeeForCRM?kodeCabang=${cabang}`);

  // crm - follow up prospect
  const deleteFollowUpProspect = (id) =>
    api.delete(`FollowUpProspect/deleteFollowUpProspect?prospectId=${id}`);
  const checkFUProspect = (body) =>
    api.get("FollowUpProspect/checkFUProspect", body);
  const findAllDataFU = (body) =>
    api.post("FollowUpProspect/findAllData", body);
  const saveFUProspect = (body) =>
    api.post("FollowUpProspect/saveFUProspect", body);
  const getDetailFU = (id) =>
    api.get(`FollowUpProspect/getDetail?noProspect=${id}`);
  const checkNIKForFU = (nik) =>
    api.get(`CustomerProfile/checkNIKForFUProspect?nik=${nik}`);
  const followUpWa = (body) => api.post(`FollowUpProspectH2/followUpWA`, body);

  // management notification
  const getDataNotificationTabCustomer = (body) =>
    api.post("NotificationManagement/getForTabCustomer", body);
  const getDetailNotification = (body) =>
    api.get("NotificationManagement/getDetail" + body);
  const submitNotificationCustomer = (body) =>
    api.post("NotificationManagement/submitNotificationCustomer", body);
  const getDataNotificationTabSystem = (body) =>
    api.post("NotificationManagement/getForTabSystem", body);
  const uploadExcelNotificationListCustomer = (body) =>
    api.post("NotificationManagement/uploadExcelForListCustomer", body);
  const deleteNotification = (id) =>
    api.delete(
      `NotificationManagement/softDeleteNotification?idNotifikasi=${id}`
    );

  // dgi - sales order
  const getDataSalesOrderDGI = (body) =>
    api.post("SalesOrderDGI/getDataSalesOrderDGI", body);
  const submitDataSalesOrderDGI = (body) =>
    api.post("SalesOrderDGI/submitSalesOrderDGI", body);
  const getDataOwnerSODGI = (body) =>
    api.get("SalesOrderDGI/Detail/getDataOwner" + body);
  const getDataUnitSODGI = (body) =>
    api.get("SalesOrderDGI/Detail/getDataUnit" + body);
  const getDataBuyerSODGI = (body) =>
    api.get("SalesOrderDGI/Detail/getDataBuyerDGI" + body);

  // dashboard - cashier
  const getCashierDailyCash = (body) =>
    api.post("DashboardCashier/DailyCash", body);
  const getCashierDailyBank = (body) =>
    api.post("DashboardCashier/DailyBank", body);
  const getMonitoringBBMCashier = (body) =>
    api.post("DashboardCashier/getMonitoringBankIn", body);
  const getMonitoringBBKCashier = (body) =>
    api.post("DashboardCashier/getMonitoringBankOut", body);
  const getMonitoringBKMCashier = (body) =>
    api.post("DashboardCashier/getMonitoringCashIn", body);
  const getMonitoringBKKCashier = (body) =>
    api.post("DashboardCashier/getMonitoringCashOut", body);
  const getCashierTotal = (body) => api.post("DashboardCashier/getTotal", body);

  // dashboard - accounting
  const getDataProfitUnitDailyAccounting = (body) =>
    api.post("DashboardAccountant/getDataProfitUnitDaily", body);
  const getDataProfitUnitMonthlyAccounting = (body) =>
    api.post("DashboardAccountant/getProfitUnitMonthly", body);

  // feature dashboard
  const getLaporanPenjualanPerVariantKacab = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerVariant", body);
  const getLaporanPenjualanPerTypeKacab = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerType", body);
  const getLaporanPenjualanPerSeriesKacab = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerSeries", body);
  const getLaporanPenjualanPerSubSegmentKacab = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerSubSegment", body);

  const getLaporanPenjualanPerTypeYTD = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerTypeYTD", body);
  const getLaporanPenjualanPerVariantYTD = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerVariantYTD", body);
  const getLaporanPenjualanPerSeriesYTD = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerSeriesYTD", body);
  const getLaporanPenjualanPerSubSegmentYTD = (body) =>
    api.post("Dashboard/getLaporanPenjualanPerSubSegmentYTD", body);

  const getListMasterPromo = (body) =>
    api.post("MasterPromo/getDataMainPage", body);
  const getByIdMasterPromo = (body) => api.get("MasterPromo/getDetail", body);
  const getPreviewIdMasterPromo = () => api.get("MasterPromo/getPreviewId");
  const getTemplateExcelMasterPromo = (body) =>
    api.get("MasterPromo/getTemplateExcel", body);
  const uploadExcelDataMasterPromo = (body) =>
    api.post("MasterPromo/uploadExcelData", body);
  const copyMasterPromo = (body) => api.get("MasterPromo/copy" + body);
  const deleteMasterPromo = (body) => api.delete("MasterPromo/delete" + body);
  const saveAndUpdateMasterPromo = (body) =>
    api.post("MasterPromo/saveAndUpdate", body);
  const getMasterPromoWilayahByUserId = (body) =>
    api.get("MasterCabang/getWilayahByUserId", body);
  const downloadLogErrorMasterPromo = (body) => api.get("MasterPromo/downloadErrorLogExcel", body)

  const getDataForCreateProspect = (body) =>
    api.post("CDBManagement/getDataForCreateProspect", body);
  const getDetailCDBManagement = (body) =>
    api.get("CDBManagement/getDetail" + body);
  const getDetailRequestUpdateCDBManagement = (body) =>
    api.get("CDBManagement/getDetailRequestUpdate" + body);
  const getDetailRequestUpdateById = (id) =>
    api.get("CDBManagement/getDetailRequestUpdateById", id);
  const submitToH1CDBManagement = (body) =>
    api.post("CDBManagement/submitToH1", body);
  const submitToH23CDBManagement = (body) =>
    api.post("CDBManagement/submitToH23", body);
  const getDataForRequestUpdate = (body) =>
    api.post("CDBManagement/getDataForRequestUpdate", body);
  const processToCustomerProfileCDMManagement = (body) =>
    api.post("CDBManagement/processToCustomerProfile", body);
  const submitRequestUpdateCDMManagement = (body) =>
    api.post("CDBManagement/submitRequestUpdate", body);
  const updateStatusRequestUpdateCDMManagement = (body) =>
    api.put("CDBManagement/updateStatusRequestUpdate" + body);
  const processFromRequestUpdateCDBManagement = (body) =>
    api.post("CDBManagement/processFromRequestUpdate", body);
  const checkEligibleNIKForProspect = (body) =>
    api.post("CDBManagement/checkEligibleNiks", body);

  const findAllTypeByListKodeSeries = (body) =>
    api.post("Type/findAllTypeByListKodeSeries", body);
  const findAllVariantByListKodeType = (body) =>
    api.post("Variant/findAllVariantByListKodeType", body);
  const findAllWarnaByListKodeVariant = (body) =>
    api.post("Warna/findAllWarnaByListKodeVariant", body);
  const getLaporanIndentMothly = (body) =>
    api.post("Dashboard/getLaporanIndentMothly", body);
  const getLaporanStrukturCSSalesmanLastThreeYear = (body) =>
    api.post("Dashboard/getLaporanStrukturCSSalesmanLastThreeYear", body);
  const getLaporanKontribusiFincoyPerCabangLastThreeYear = (body) =>
    api.post(
      "Dashboard/getLaporanKontribusiFincoyPerCabangLastThreeYear",
      body
    );
  const getLaporanStatistikCabang = (body) =>
    api.post("Dashboard/getLaporanStatistikCabang", body);
  const getLaporanStatistikTeamLead = (body) =>
    api.post("Dashboard/getLaporanStatistikTeamLead", body);
  const getLaporanStatistikSalesCS = (body) =>
    api.post("Dashboard/getLaporanStatistikSalesCS", body);
  const getLaporanIndenCabang = (body) =>
    api.post("Dashboard/getLaporanIndenCabang", body);
  const getLaporanGrowthFincoyMTDPercabang = (body) =>
    api.post("Dashboard/getLaporanGrowthFincoyMTDPercabang", body);
  const getLaporanKomposisiCashCredit3TahunTerakhir = (body) =>
    api.post("Dashboard/getLaporanKomposisiCashCredit3TahunTerakhir", body);
  const getLaporanKomposisiCashCreditTahunBerjalan = (body) =>
    api.post("Dashboard/getLaporanKomposisiCashCreditTahunBerjalan", body);
  const getLaporanStrukturCSSalesmanTahunBerjalan = (body) =>
    api.post("Dashboard/getLaporanStrukturCSSalesmanTahunBerjalan", body);
  const getLaporanKomposisiFincoyTigaTahunTerakhir = (body) =>
    api.post("Dashboard/getLaporanKomposisiFincoyTigaTahunTerakhir", body);
  const getLaporanKomposisiFincoyYTD = (body) =>
    api.post("Dashboard/getLaporanKomposisiFincoyYTD", body);
  const getLaporanJualan3TahunTerakhir = (body) =>
    api.post("Dashboard/getLaporanJualan3TahunTerakhir", body);
  const getLaporanStrukturDanKomposisiJualPerCabang = (body) =>
    api.post("Dashboard/getLaporanStrukturDanKomposisiJualPerCabang", body);
  const getLaporanPenjualanYTDMetodePembayaranDanLeasing = (body) =>
    api.post(
      "Dashboard/getLaporanPenjualanYTDMetodePembayaranDanLeasing",
      body
    );
  const getLaporanPenjualanMTD = (body) =>
    api.post("Dashboard/getLaporanPenjualanMTD", body);
  const getLaporanJualanMTDSalesmanCS = (body) =>
    api.post("Dashboard/getLaporanJualanMTDSalesmanCS", body);
  const getLaporanJualanHarian = (body) =>
    api.post("Dashboard/getLaporanJualanHarian", body);
  const getLaporanJualanHarianPerCabang = (body) =>
    api.post("Dashboard/getLaporanJualanHarianPerCabang", body);
  const getLaporanStatistikROCrossSellingYTDXOH21p = (body) =>
    api.post("Dashboard/getLaporanStatistikROCrossSellingYTDXOH21p", body);
  const getLaporanStatistikToday = (body) =>
    api.post("Dashboard/getLaporanStatistikToday", body);
  const getLaporanAppointmentFUToDay = (body) =>
    api.post("Dashboard/getLaporanAppointmentFUToDay", body);
  const getLaporanAppointmentOverdue = (body) =>
    api.post("Dashboard/getLaporanAppointmentOverdue", body);

  const getLaporanStatistikROCrossSelling = (body) =>
    api.post("Dashboard/getLaporanStatistikROCrossSelling", body);
  const getLaporanStatistikROCrossSellingYTDROH1 = (body) =>
    api.post("Dashboard/getLaporanStatistikROCrossSellingYTDROH1", body);
  const getLaporanStatistikROCrossSellingYTDROH23 = (body) =>
    api.post("Dashboard/getLaporanStatistikROCrossSellingYTDROH23", body);
  const getLaporanStatistikROCrossSellingYTDXOH21 = (body) =>
    api.post("Dashboard/getLaporanStatistikROCrossSellingYTDXOH21", body);

  const getListDataMotorByMemberId = (body) =>
    api.post("CDBManagement/getListDataMotorByMemberId", body);
  const exportToExcelManagementCDB = (body) =>
    api.post("CDBManagement/exportToExcel", body);

  // TEMPLATE
  const getTemplateMasterdataVendor = (body) =>
    api.post("template.document.get.masterdata.vendor", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplateMasterdataVendor = (body) =>
    api.post("template.document.post.masterdata.vendor", body, {
      method: "POST",
      headers: {
        "Content-Type": "text/csv",
      },
    });
  const getTemplateOutsourceAssignment = (body) =>
    api.post("template.document.get.outsource.assignment", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplateOutsourceAssignment = (body) =>
    api.post("template.document.post.outsource.assignment", body, {
      method: "POST",
      headers: {
        "Content-Type": "text/csv",
      },
    });
  const getTemplateOutsource = (body) =>
    api.post("template.document.get.outsource", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplateOutsource = (body) =>
    api.post("template.document.post.outsource", body, {
      method: "POST",
      headers: {
        "Content-Type": "text/csv",
      },
    });

  const postTemplateLoanInstallment = (body) =>
    api.post("template.document.post.loanevent.history", body);
  const getTemplateLoanInstallment = (body) =>
    api.post("template.document.get.loanevent.history", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplateLoan = (body) =>
    api.post("template.document.post.loan", body);
  const getTemplateLoan = (body) =>
    api.post("template.document.get.loan", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplateTraining = (body) =>
    api.post("template.document.post.training", body);
  const getTemplateTraining = (body) =>
    api.post("template.document.get.training", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });
  const postTemplatePayroll = (body) =>
    api.post("template.document.post", body, {
      method: "POST",
      headers: {
        "Content-Type": "text/csv",
      },
    });
  const getTemplatePayroll = (body) =>
    api.post("template.document.get", body, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
    });

  // const postGetTaxOffice = body => api.post('getTaxOffice', body, {
  // 	method: 'POST',
  // 	headers: {
  // 		"Accept": "application/json",
  // 		"Content-Type": "application/x-www-form-urlencoded"
  // 	}
  // })

  //way
  const postGetTaxOffice = (body) => api.post("getTaxOffice", body);
  const postGetCompany = (body) => api.post("getCompanyDdl", body);
  const postGetDistrict = (body) => api.post("getKabkot", body);
  const postGetOrgStructureTemplate = (body) =>
    api.post("getOrgStructureTemplate", body);
  const postGetOrgStructure = (body) => api.post("getOrgStructure", body);
  const postGetOrgStructureDetail = (body) =>
    api.post("getOrgStructureDetail", body);
  const postGetOrgStructureDetailJob = (body) =>
    api.post("getOrgStructureDetailJob", body);
  const postGetOrgParentStructureDdl = (body) =>
    api.post("getOrgParentStructureDdl", body);
  const postGetOrgParentSubStructureDdl = (body) =>
    api.post("getOrgParentSubStructureDdl", body);
  const postGetLeaveTypeDdl = (body) => api.post("getLeaveTypeDdl", body);

  const postSaveTaxOffice = (body) => api.post("tax-office/save", body);
  const postSaveOrgStructureTemplate = (body) =>
    api.post("org-structure-template/save", body);
  const postSaveOrgStructure = (body) => api.post("org-structure/save", body);
  const postSaveOrgStructureDetail = (body) =>
    api.post("org-structure-detail/save", body);
  const postSaveOrgStructureDetailJob = (body) =>
    api.post("org-structure-detail-job/save", body);

  const getOrganizationunit = (body) => api.post("getOrgUnit", body);
  const postOrganizationunit = (body) => api.post("org-unit/save", body);
  const postExportOrganizationTemplate = (body) =>
    api.post("organization/template", body);
  const postGetOrganizationStructureTemplate = (body) =>
    api.post("template/get/organizationStructure", body);

  const postTrxAttendanceGetLeave = (body) => api.post("getLeave", body);
  const postTrxAttendanceGetBusinessTrip = (body) =>
    api.post("getBusinessTrip", body);
  const postTrxPersonGetMovement = (body) =>
    api.post("person/getMovement", body);
  const postTrxPersonGetOffense = (body) => api.post("person/getOffense", body);
  const postAuthGetButtonAccess = (body) =>
    api.post("authorization/getButtonAccess", body);
  const postGetVendor = (body) => api.post("getVendor", body);
  const postSaveVendor = (body) => api.post("vendor/save", body);
  const getPeriodDdl = (body) => api.get("getPeriodDdl", body);
  const getPeriodAttDdl = (body) => api.post("getPeriodAttDdl", body);

  const postGetWorkShiftDdl = (body) => api.post("getWorkShiftDdl", body);
  const postGetExcelGenerator = (body) => api.post("get/excelGenerator", body);
  const postGetOrgUnitDdl = (body) => api.post("getOrgUnitDdl", body);
  const postTrxTasklistGetTaskList = (body) =>
    api.post("task-list/getTaskList", body);

  const postGetCoa = (body) => api.post("getCoa", body);
  const postCnbCoaSave = (body) => api.post("cnb-coa/save", body);
  const postGetCoaParentDdl = (body) => api.post("getCoaParentDdl", body);
  const postGetCnbComponent = (body) => api.post("getCnbComponent", body);
  const postCnbComponentSave = (body) => api.post("cnb-component/save", body);
  const postGetCnbComponentPercent = (body) =>
    api.post("getCnbComponentPercent", body);
  const postCnbComponentPercentSave = (body) =>
    api.post("cnb-component-percent/save", body);
  const postGetCnbComponentDdl = (body) => api.post("getCnbComponentDdl", body);
  const postGetCnbComponentAmount = (body) =>
    api.post("getCnbComponentAmount", body);
  const postCnbComponentAmountSave = (body) =>
    api.post("cnb-component-amount/save", body);
  const postGetCnbProcess = (body) => api.post("getCnbProcess", body);
  const postCnbProcessSave = (body) => api.post("cnb-process/save", body);
  const postGetCnbProcessComponent = (body) =>
    api.post("getCnbProcessComponent", body);
  const postCnbProcessComponentSave = (body) =>
    api.post("cnb-process-component/save", body);
  const postGetCnbCutOff = (body) => api.post("getCnbCutOff", body);
  const postCnbCutOffSave = (body) => api.post("cnb-cut-off/save", body);
  const postGetWorkTimeType = (body) => api.post("getWorkTimeType", body);
  const postWorkTimeTypeSave = (body) => api.post("work-time-type/save", body);
  const postGetWorkShift = (body) => api.post("getWorkShift", body);
  const postWorkShiftSave = (body) => api.post("work-shift/save", body);
  const postGetWorkShiftDtl = (body) => api.post("getWorkShiftDtl", body);
  const postGetWorkShiftAssignment = (body) =>
    api.post("getWorkShiftAssignment", body);
  const postWorkShiftAssignmentSave = (body) =>
    api.post("work-shift-assignment/save", body);
  const postGetWorkShiftSchedule = (body) =>
    api.post("getWorkShiftSchedule", body);
  const postWorkShiftScheduleSave = (body) =>
    api.post("work-shift-schedule/save", body);
  const postGetWorkShiftScheduleDtl = (body) =>
    api.post("getWorkShiftScheduleDtl", body);
  const postGetLevelDdl = (body) => api.post("getLevelDdl", body);
  const postGetApprovalFlow = (body) => api.post("getApprovalFlow", body);
  const postGetApproval = (body) => api.post("getApproval", body);
  const postApprovalMakerSave = (body) => api.post("approval-maker/save", body);
  const postGetApprovalMaker = (body) => api.post("getApprovalMaker", body);
  const postGetApprovalMakerReq = (body) =>
    api.post("getApprovalMakerReq", body);
  const postGetApprovalApprover = (body) =>
    api.post("getApprovalApprover", body);
  const postApprovalMakerReqSave = (body) =>
    api.post("approval-maker-req/save", body);
  const postApprovalApproverSave = (body) =>
    api.post("approval-approver/save", body);
  const postTrxCombenGetPayrollData = (body) =>
    api.post("getPayrollData", body);
  const postTrxCombenGetPayrollDataDtl = (body) =>
    api.post("getPayrollDataDtl", body);
  const postGetWorkShiftScheduleTemp = (body) =>
    api.post("getWorkShiftScheduleTemp", body);
  const postWorkShiftScheduleNewSave = (body) =>
    api.post("work-shift-schedule-new/save", body);
  const postGetBpmTrack = (body) => api.post("getBpmTrack", body);
  const postTemplateGetOrg = (body) => api.post("template/get/org", body);
  const postTemplateGetWorkShiftSchedule = (body) =>
    api.post("template/get/workShiftSchedule", body);
  const postUploadWorkshiftScheduleSave = (body) =>
    api.post("upload/work-shift-schedule/save", body);
  const postEmplGetPhoto = (body) => api.post("getPhoto", body);
  const postWorkflowGetAppRequest = (body) => api.post("getAppRequest", body);
  const postGetReportNameDdl = (body) => api.post("getReportNameDdl", body);
  const postCreateInstanceNonPersonal = (body) =>
    api.post("createInstanceNonPersonal", body);
  const postUploadOrgSave = (body) => api.post("upload/org/save", body);
  const getFlowTypeDdl = (body) => api.get("getFlowTypeDdl", body);
  const postGetMovement = (body) => api.post("getMovement", body);
  const getPeriodMonthDdl = (body) => api.get("getPeriodMonthDdl", body);
  const getPeriodYearDdl = (body) => api.get("getPeriodYearDdl", body);
  const postTemplateGetCoa = (body) => api.post("template/get/coa", body);
  const postUploadCoaSave = (body) => api.post("upload/coa/save", body);
  const postCreateInstanceNonPersonalBatch = (body) =>
    api.post("createInstanceNonPersonalBatch", body);
  const postTemplateGetCnbComponentAmount = (body) =>
    api.post("template/get/cnbComponentAmount", body);
  const postUploadCnbComponentSave = (body) =>
    api.post("upload/cnb-component-amount/save", body);
  const postPersonGetMovement = (body) => api.post("person/getMovement", body);
  const postClaimTask = (body) => api.post("claimTask", body);
  const postCompleteTask = (body) => api.post("completeTask", body);
  const postReportOffense = (body) => api.post("offense", body);
  const postReportAttendance = (body) => api.post("attendance", body);
  const postTrxPersonGetEmplBatchUpdate = (body) =>
    api.post("person/getEmplBatchUpdate", body);
  const postBatchUpdateSave = (body) => api.post("batch-update/save", body);
  const postCombenGetProcessTransaction = (body) =>
    api.post("getProcessTransaction", body);
  const postCombenCnbApProcessSave = (body) =>
    api.post("cnb-ap-process/save", body);
  const postCombenGetBpmTrack = (body) => api.post("getPayrollDataReq", body);
  const postGetProcessTrxDdl = (body) => api.post("getProcessTrxDdl ", body);
  const postGetPeriodTrxDdl = (body) => api.post("getPeriodTrxDdl ", body);
  const postGetPayrollDataHist = (body) => api.post("getPayrollDataHist", body);
  const postGetJobLocationDdl = (body) => api.post("getJobLocationDdl", body);
  const postCombenGetProcessTransactionDtl = (body) =>
    api.post("getProcessTransactionDtl", body);
  const postGetAttLocationPoint = (body) =>
    api.post("getAttLocationPoint", body);
  const postGetAttLocationPointDtl = (body) =>
    api.post("getAttLocationPointDtl", body);
  const postAttPointSave = (body) => api.post("att-point/save", body);
  const postAttPointDtlSave = (body) => api.post("att-point-dtl/save", body);
  const postGetOrgPosition = (body) => api.post("getPosition", body);
  const postTemplateGetPosition = (body) =>
    api.post("template/get/position", body);
  const postPositionSave = (body) => api.post("position/save", body);
  const postGetRuleDdl = (body) => api.post("getRuleDdl", body);
  const postGetOrgLevel = (body) => api.post("getOrgLevel", body);
  const postOrgStructureLevelSave = (body) =>
    api.post("org-structure-level/save", body);
  const postGetOrgLevelDdl = (body) => api.post("getOrgLevelDdl", body);
  const postGetEmplCnbComponent = (body) =>
    api.post("getEmplCnbComponent", body);
  const postEmplCnbComponentSave = (body) =>
    api.post("empl-cnb-component/save", body);
  const postGetOffenseTypeDdl = (body) => api.post("getOffenseTypeDdl", body);
  const postReportPkwt = (body) => api.post("pkwt", body);
  const postReportMvStatusChangePerm = (body) =>
    api.post("mv-status-change-perm", body);
  const postReportMvLevelPromotion = (body) =>
    api.post("mv-level-promotion", body);
  const postGetOrgTemplateLevel = (body) =>
    api.post("getOrgTemplateLevel", body);
  const postOrgTemplateLevelSave = (body) =>
    api.post("org-template-level/save", body);
  const postTemplateGetOrgTemplateUnit = (body) =>
    api.post("template/get/orgTemplateUnit", body);
  const postUploadOrgTemplateUnitSave = (body) =>
    api.post("upload/org-template-unit/save", body);
  const postGetOrgTemplateUnit = (body) => api.post("getOrgTemplateUnit", body);
  const postGetOrgTemplateUnitJob = (body) =>
    api.post("getOrgTemplateUnitJob", body);
  const postGetOrgTemplateUnitPosition = (body) =>
    api.post("getOrgTemplateUnitPosition", body);
  const postOrgTemplateUnitDelete = (body) =>
    api.post("org-template-unit/delete", body);
  const postOrgTemplateUnitJobDelete = (body) =>
    api.post("org-template-unit-job/delete", body);
  const postOrgTemplateUnitPositionDelete = (body) =>
    api.post("org-template-unit-position/delete", body);
  const postTemplateGetOrgTemplateJob = (body) =>
    api.post("template/get/orgTemplateUnitJob", body);
  const postTemplateGetOrgTemplatePosition = (body) =>
    api.post("template/get/orgTemplateUnitPosition", body);
  const postUploadOrgTemplateUnitJobSave = (body) =>
    api.post("upload/org-template-unit-job/save", body);
  const postUploadOrgTemplateUnitPositionSave = (body) =>
    api.post("upload/org-template-unit-position/save", body);
  const postReportMvRotation = (body) => api.post("mv-rotation", body);
  const postReportMvDemotion = (body) => api.post("mv-demotion", body);
  const postCombenGetPayrollDataSalaryHist = (body) =>
    api.post("getPayrollDataSalaryHist", body);
  const postCombenPrcApCalcSave = (body) => api.post("prc-ap-calc/save", body);
  const postCombenPrcApPublishSave = (body) =>
    api.post("prc-ap-publish/save", body);
  const getBatchNpwp = (body) => api.get("template/get/batchNpwp", body);
  const getBatchAccount = (body) => api.get("template/get/batchAccount", body);
  const getBatchBpjsTk = (body) => api.get("template/get/batchBpjsTk", body);
  const getBatchBpjsKs = (body) => api.get("template/get/batchBpjsKs", body);
  const getBatchOtherInsurance = (body) =>
    api.get("template/get/batchOtherInsurance", body);
  const postUploadBatchUpdateSave = (body) =>
    api.post("upload/batch-update/save", body);
  const postUploadBatchAccountSave = (body) =>
    api.post("upload/batch-account/save", body);
  const postUploadBatchBpjsTkSave = (body) =>
    api.post("upload/batch-bpjs-tk/save", body);
  const postUploadBatchBpjsKsSave = (body) =>
    api.post("upload/batch-bpjs-ks/save", body);
  const postUploadBatchOtherInsuranceSave = (body) =>
    api.post("upload/batch-other-insurance/save", body);
  const postTemplateGetChangeRequest = (body) =>
    api.post("template/get/payrollChangeRequest", body);
  const postUploadPayrollChangeRequestSave = (body) =>
    api.post("upload/payroll-change-request/save", body);
  const postCombenGetPayrollBatchHead = (body) =>
    api.post("getPayrollBatchHead", body);
  const postCombenGetPayrollBatchDtl = (body) =>
    api.post("getPayrollBatchDtl", body);
  const postReportPkwtt = (body) => api.post("pkwtt", body);
  const postReportPaklaring = (body) => api.post("paklaring", body);
  const postGetRoleUser = (body) => api.post("getRoleUser", body);
  const postTemplateGetMovement = (body) =>
    api.post("template/get/movement", body);
  const postUploadMovementSave = (body) =>
    api.post("upload/movement/save", body);
  const postPersonGetMovementBatchData = (body) =>
    api.post("person/getMovementBatchData", body);
  const postGetBpmStartPrinting = (body) =>
    api.post("getBpmStartPrinting", body);
  const postCreateBpmStartPrinting = (body) =>
    api.post("createBpmStartPrinting", body);
  const postOrgTemplateUnitSave = (body) =>
    api.post("org-template-unit/save", body);
  const postGetSeqLevelOrgDdl = (body) => api.post("getSeqLevelOrgDdl", body);
  const postGetTemplateUnitDdl = (body) =>
    api.post("getOrgTemplateUnitDdl", body);
  const postGetOrgTemplateUnitByParentCode = (body) =>
    api.post("getOrgTemplateUnitByParentCode", body);
  const postOrgTemplateUnitJobSave = (body) =>
    api.post("org-template-unit-job/save", body);
  const postGetOrgTemplateJobDdl = (body) =>
    api.post("getOrgTemplateJobDdl", body);
  const postGetOrgTemplateJobLevelDdl = (body) =>
    api.post("getOrgTemplateJobLevelDdl", body);
  const postOrgTemplateUnitPositionSave = (body) =>
    api.post("org-template-unit-position/save", body);
  const postGetOrgPositionJobDdl = (body) =>
    api.post("getOrgPositionJobDdl", body);
  const postGetOrgPositionLevelDdl = (body) =>
    api.post("getOrgPositionLevelDdl", body);
  const postGetOrgPositionLocationDdl = (body) =>
    api.post("getOrgPositionLocationDdl", body);
  const postReportBankSeal = (body) => api.post("bank-seal", body);
  const getTemplateGetBatchEmail = (body) =>
    api.get("template/get/batchEmail", body);
  const postUploadBatchEmailSave = (body) =>
    api.post("upload/batch-email/save", body);
  const postTrxTasklistGetTaskListFc = (body) =>
    api.post("task-list/getTaskListFc", body);
  const getTemplateGetBatchEmailOutsource = (body) =>
    api.get("template/get/batchEmailOutsource", body);
  const postUploadBatchEmailOutsourceSave = (body) =>
    api.post("upload/batch-email-outsource/save", body);
  const postGetTaskListCnb = (body) => api.post("getTaskListCnb", body);
  const postClaimTaskCnb = (body) => api.post("claimTaskCnb", body);
  const postCompleteTaskCnb = (body) => api.post("completeTaskCnb", body);
  const postCreateInstanceNonPersonalBatchCnb = (body) =>
    api.post("createInstanceNonPersonalBatchCnb", body);
  const postGetJsonRequestCnb = (body) => api.post("getJsonRequest", body);
  const getPeriodCompHistDdl = (body) => api.get("getPeriodCompHistDdl", body);
  const postGetEmplPayrollHist = (body) => api.post("getEmplPayrollHist", body);
  const postGetParamByEmpl = (body) => api.post("getParamByEmpl", body);
  const postGetExcelGeneratorByCompany = (body) =>
    api.post("get/excelGeneratorByCompany", body);
  const postGetCancelTypeDdl = (body) => api.post("getCancelTypeDdl", body);
  const postGetCancellationData = (body) =>
    api.post("person/getCancellationData", body);
  const postGetCancellation = (body) =>
    api.post("person/getCancellation", body);
  const postCancellationSave = (body) =>
    api.post("person/cancellation/save", body);
  const postGetEmplCnbComponentCalc = (body) =>
    api.post("getEmplCnbComponentCalc", body);
  const postGetStatusCalc = (body) => api.post("cnb/getStatusCalc", body);
  const postCnbApClosingCalc = (body) => api.post("cnb-ap-closing/calc", body);
  const postGetPayslipAdmin = (body) => api.post("payslip-admin", body);
  const getApprovalSum = (body) => api.get("notif/getApprovalSum", body);
  const postReportMvActing = (body) => api.post("mv-acting", body);
  const postGetCnbReimburseQuota = (body) =>
    api.post("getCnbReimburseQuota", body);
  const postReimburseQuotaSave = (body) =>
    api.post("cnb-reimburse-quota/save", body);
  const postGetCnbReimburseQuotaEmpl = (body) =>
    api.post("getCnbReimburseQuotaEmpl", body);
  const postGetCompanyBilling = (body) => api.post("getCompanyBilling", body);
  const postGetCompanyBillingDtl = (body) =>
    api.post("getCompanyBillingDtl", body);
  const postPayrollReferenceSave = (body) =>
    api.post("payroll-reference/save", body);
  const postGetEmplListAll = (body) => api.post("getEmplListAll", body);
  const postPersonMovementBatchDelete = (body) =>
    api.post("person/movement-batch/delete", body);
  const getBillingApp = (body) => api.post("billing-app", body);
  const postGetReimburseEmplHist = (body) =>
    api.post("getReimburseEmplHist", body);
  const getTemplateBatchCard = (body) =>
    api.get("template/get/batchCard", body);
  const getTemplateBatchAddress = (body) =>
    api.get("template/get/batchAddress", body);
  const getTemplateBatchInactiveEmplOutsource = (body) =>
    api.get("template/get/batchInactiveEmplOutsource", body);
  const getTemplateBatchPositionUpdateOutsource = (body) =>
    api.get("template/get/batchPositionUpdateOutsource", body);
  const getTemplateBatchBpjsFlag = (body) =>
    api.get("template/get/batchBpjsFlag", body);
  const postUploadBatchCardSave = (body) =>
    api.post("upload/batch-card/save", body);
  const postUploadBatchAddressSave = (body) =>
    api.post("upload/batch-address/save", body);
  const postUploadBatchInactiveOutsourceSave = (body) =>
    api.post("upload/batch-inactive-outsource/save", body);
  const postUploadBatchPositionUpdateOutsourceSave = (body) =>
    api.post("upload/batch-position-update-outsource/save", body);
  const postUploadBatchBpjsFlagSave = (body) =>
    api.post("upload/batch-bpjs-flag/save", body);
  const postGetIdpDuration = (body) => api.post("getIdpDuration", body);
  const postDurationSave = (body) => api.post("prf-idp-duration/save", body);
  const postGetIdpCompetence = (body) => api.post("getIdpCompetence", body);
  const postCompetenceSave = (body) =>
    api.post("prf-idp-competence/save", body);
  const postgetIdpJobCompetence = (body) =>
    api.post("getIdpJobCompetence", body);
  const postJobCompetenceSave = (body) =>
    api.post("prf-idp-job-competence/save", body);
  const postGetIdpJobCompetenceDtl = (body) =>
    api.post("getIdpJobCompetenceDtl", body);
  const postGetIdpActivityDev = (body) => api.post("getIdpActivityDev", body);
  const postActivityDevSave = (body) =>
    api.post("prf-idp-activity-dev/save", body);
  const postGetIdpJobCompetenceDdl = (body) =>
    api.post("getIdpJobCompetenceDdl", body);
  const postGetIdpCharacterDev = (body) => api.post("getIdpCharacterDev", body);
  const postCharacterDevSave = (body) =>
    api.post("prf-idp-character-dev/save", body);
  const postGetJournalTemplate = (body) => api.post("getJournalTemplate", body);
  const postJournalTemplateSave = (body) =>
    api.post("journal-template/save", body);
  const postGetJournal = (body) => api.post("getJournal", body);
  const postGetLocationTypeDdl = (body) => api.post("getLocationTypeDdl", body);
  const postGetCoaDetailDdl = (body) => api.post("getCoaDetailDdl", body);
  const postJournalSave = (body) => api.post("journal/save", body);

  //akbar
  const postGetCompanyGroup = (body) => api.post("getCompanyGroup", body);
  const postGetCompany2 = (body) => api.post("getCompany", body);
  const postGetCountry = (body) => api.post("getCountry", body);
  const postGetAdmCountry = (body) => api.post("getAdmCountry", body);
  const postGetAdmProvince = (body) => api.post("getAdmProvince", body);
  const postGetAdmKabkot = (body) => api.post("getAdmKabkot", body);
  const postGetAdmKecamatan = (body) => api.post("getAdmKecamatan", body);
  const postGetAdmKelurahan = (body) => api.post("getAdmKelurahan", body);
  const postGetParamValue = (body) => api.post("getParamValue", body);
  const postGetCompanyGroupDdl = (body) => api.post("getCompanyGroupDdl", body);
  const postGetCompanyDocument = (body) => api.post("getCompanyDocument", body);
  const postGetHoliday = (body) => api.post("getHoliday", body);
  const postGetHolidayLocation = (body) => api.post("getHolidayLocation", body);
  const postGetBizparCategoryDdl = (body) =>
    api.post("getBizparCategoryDdl", body);
  const postGetBizparDtl = (body) => api.post("getBizparDtl", body);
  const postGetBizparHu = (body) => api.post("getBizparHu", body);
  const postGetEmplList = (body) => api.post("getEmplList", body);
  const postGetGeneralInfo = (body) => api.post("getGeneralInfo", body);
  const postGetPtkp = (body) => api.post("getPtkp", body);
  const postGetLoginInfo = (body) => api.get("loginInfo", body);
  const postChangePass = (body) =>
    api.post("authorization/changePassword", body);
  const postGet = (body) => api.post("get", body);
  const postGetCareerTransition = (body) =>
    api.post("getCareerTransition", body);
  const postGetBpjsKetenagakerjaan = (body) =>
    api.post("getBpjsKetenagakerjaan", body);
  const postGetBpjsKesehatan = (body) => api.post("getBpjsKesehatan", body);
  const postGetOtherInsurance = (body) => api.post("getOtherInsurance", body);
  const postGetOffense = (body) => api.post("getOffense", body);
  const postGetAppreciation = (body) => api.post("getAppreciation", body);
  const postGetAddress = (body) => api.post("getAddress", body);
  const postGetFamily = (body) => api.post("getFamily", body);
  const postGetIdentity = (body) => api.post("getIdentity", body);
  const postGetLeaveReduceDdl = (body) => api.post("getLeaveReduceDdl", body);
  const postGetWorkExperience = (body) => api.post("getWorkExperience", body);
  const postGetLanguageSkill = (body) => api.post("getLanguageSkill", body);
  const postGetOrgExperience = (body) => api.post("getOrgExperience", body);
  const postGetFormalEducation = (body) => api.post("getFormalEducation", body);
  const postGetInformalEducation = (body) =>
    api.post("getInformalEducation", body);
  const postGetInstituteDdl = (body) => api.post("getInstituteDdl", body);
  const postGetMajorDdl = (body) => api.post("getMajorDdl", body);
  const postGetAbility = (body) => api.post("getAbility", body);
  const postGetDeficiency = (body) => api.post("getDeficiency", body);
  const postGetReference = (body) => api.post("getReference", body);
  const postGetEmergencyContact = (body) =>
    api.post("getEmergencyContact", body);
  const postGetPersonalCard = (body) => api.post("getPersonalCard", body);
  const postGetSocialMedia = (body) => api.post("getSocialMedia", body);
  const postGetTrainingSertification = (body) =>
    api.post("getTrainingSertification", body);
  const postGetDocument = (body) => api.post("getDocument", body);
  const postGetDocumentDtl = (body) => api.post("getDocumentDtl", body);
  const postGetBigReport = (body) => api.post("get/excelGenerator", body);
  const postGetEssReq = (body) => api.post("getEssReq", body);
  const postGetCompanyDocumentDetail = (body) =>
    api.post("getCompanyDocumentDetail", body);
  const postGetPersonnelReq = (body) => api.post("getPersonnelReq", body);
  const postGetBusinessFacility = (body) =>
    api.post("getBusinessFacility", body);
  const postGetJsonRequest = (body) => api.post("getJsonRequest", body);
  const postGetBpmDocumentDtl = (body) => api.post("getBpmDocumentDtl", body);
  const postGetCv = (body) => api.post("cv", body);
  const postGetGradeDdl = (body) => api.post("getGradeDdl", body);
  const postGetCareTaker = (body) => api.post("getCareTaker", body);
  const postGetPersonnelDataChange = (body) =>
    api.post("getPersonnelDataChange", body);
  const postGetPersonnelReqWf = (body) => api.post("getPersonnelReqWf", body);
  const postGetPhoto = (body) => api.post("getPhoto", body);
  const postGetCnbSchedule = (body) => api.post("getCnbSchedule", body);
  const postGetLoanSimulation = (body) =>
    api.post("person/getLoanSimulation", body);
  const postGetCnbScheduleDtl = (body) => api.post("getCnbScheduleDtl", body);
  const postGetLoanDocument = (body) => api.post("getLoanDocument", body);
  const postGetLoanDocumentDtl = (body) => api.post("getLoanDocumentDtl", body);
  const getLoanTypeDdl = (body) => api.post("getLoanTypeDdl", body);
  const postGetApprover = (body) => api.post("getApprover", body);
  const postGetNumbering = (body) => api.post("getNumbering", body);
  const postGetNumberingDtl = (body) => api.post("getNumberingDtl", body);
  const postGetNumberingPreview = (body) =>
    api.post("getNumberingPreview", body);
  const postGetCnbComponentTemplate = (body) =>
    api.post("getCnbComponentTemplate", body);
  const postGetLeaveCriteria = (body) => api.post("getLeaveCriteria", body);
  const postGetCnbComponentTemplateDtl = (body) =>
    api.post("getCnbComponentTemplateDtl", body);
  const postGetReportConfig = (body) => api.post("getReportConfig", body);
  const postGetReportHeader = (body) => api.post("getReportHeader", body);
  const postGetFormDdl = (body) => api.post("getFormDdl", body);
  const postGetReportTemplate = (body) => api.post("getReportTemplate", body);
  const postGetPositionJobDdl = (body) => api.post("getPositionJobDdl", body);
  const postGetPositionLevelDdl = (body) =>
    api.post("getPositionLevelDdl", body);
  const postGetPositionLocationDdl = (body) =>
    api.post("getPositionLocationDdl", body);
  const postGetReportNameCustomDdl = (body) =>
    api.post("getReportNameCustomDdl", body);
  const postGetBusinessTripSet = (body) => api.post("getBusinessTripSet", body);
  const postGetBusinessNeedSet = (body) => api.post("getBusinessNeedSet", body);
  const postTemplateGetEmpl = (body) => api.post("template/get/empl", body);
  const postGetNotifBell = (body) => api.get("notif/getNotifBell", body);
  const postGetPeriodByFormDdl = (body) => api.post("getPeriodByFormDdl", body);
  const postGetEduLevel = (body) => api.post("getEduLevel", body);
  const postGetEduInstitute = (body) => api.post("getEduInstitute", body);
  const postGetEduMajor = (body) => api.post("getEduMajor", body);
  const postGetEduLevelDdl = (body) => api.post("getEduLevelDdl", body);
  const postGetReportNameAllDdl = (body) =>
    api.post("getReportNameAllDdl", body);
  const postGetOrgStructureEmpl = (body) => api.post("getOrgStructure", body);
  const postGetEduInstitutionDdl = (body) =>
    api.post("getEduInstitutionDdl", body);
  const postGetEduMajorDdl = (body) => api.post("getEduMajorDdl", body);
  const postGetEmplDocument = (body) => api.post("getEmplDocument", body);
  const postGetEmplDocumentDtl = (body) => api.post("getEmplDocumentDtl", body);
  const postGetPersonnelDocReq = (body) => api.post("getPersonnelDocReq", body);
  const postGetAppPositionTemplate = (body) =>
    api.post("getAppPositionTemplate", body);
  const postGetAppPosition = (body) => api.post("getAppPosition", body);
  const postGetAppPositionDtl = (body) => api.post("getAppPositionDtl", body);
  const postGetAdmParamTax = (body) => api.post("getAdmParamTax", body);
  const postGetTasklistPrf = (body) => api.post("getTaskListPrf", body);
  const postGetClaimTaskPrf = (body) => api.post("claimTaskPrf", body);
  const postGetBpmTrackPrf = (body) => api.post("getBpmTrack", body);
  const postGetJsonRequestPrf = (body) => api.post("getJsonRequest", body);
  const postGetOrgTemplateJobSuperiorDdl = (body) =>
    api.post("getOrgTemplateJobSuperiorDdl", body);
  const postGetCycleTemplateDdl = (body) =>
    api.post("getCycleTemplateDdl", body);
  const postGetRepaymentCalculate = (body) =>
    api.post("getRepaymentCalculate", body);
  const postRepayment = (body) => api.post("repayment", body);
  const postGetFacility = (body) => api.post("getFacility", body);
  const postGetEmplOutsource = (body) => api.post("get/emplOutsource", body);
  const postGetTrainingExp = (body) => api.post("getTrainingExp", body);
  const postGetTraining = (body) => api.post("getTraining", body);
  const postGetTrainingDtl = (body) => api.post("getTrainingDtl", body);
  const postGetCnbReimburseType = (body) =>
    api.post("getCnbReimburseType", body);
  const postGetCnbReimburseAmount = (body) =>
    api.post("getCnbReimburseAmount", body);
  const postGetReimburseTypeDdl = (body) =>
    api.post("getReimburseTypeDdl", body);
  const postGetReimburse = (body) => api.post("getReimburse", body);
  const postGetJsonRequestReimburse = (body) =>
    api.post("getJsonRequestReimburse", body);
  const postGetReimburseItem = (body) => api.post("getReimburseItem", body);
  const postGetReimburseItemDdl = (body) =>
    api.post("getReimburseItemDdl", body);
  const postGetOvertimeSetting = (body) => api.post("getOvertimeSetting", body);
  const postGetOvertimeCriteria = (body) =>
    api.post("getOvertimeCriteria", body);
  const postGetOvertimeRounding = (body) =>
    api.post("getOvertimeRounding", body);
  const postGetOvertime = (body) => api.post("getOvertime", body);
  const postGetEmplWorkshiftDaily = (body) =>
    api.post("getEmplWorkshiftDaily", body);
  const postGetThrDate = (body) => api.post("getThrDate", body);
  const postGetIdpRatingQuestion = (body) =>
    api.post("getIdpRatingQuestion", body);
  const postGetIdpCompetenceDdl = (body) =>
    api.post("getIdpCompetenceDdl", body);
  const postGetIdpIndicator = (body) => api.post("getIdpIndicator", body);
  const postGetIdpRating = (body) => api.post("getIdpRating", body);
  const postGetIdpScore = (body) => api.post("getIdpScore", body);
  const postGetIdpScoreDtl = (body) => api.post("getIdpScoreDtl", body);
  const postGetIdpTemplate = (body) => api.post("getIdpTemplate", body);
  const postGetIdpTemplateQuest = (body) =>
    api.post("getIdpTemplateQuest", body);
  const postGetIdpTemplateValidation = (body) =>
    api.post("getIdpTemplateValidation", body);
  const postGetIdpIndicatorValidation = (body) =>
    api.post("getIdpIndicatorValidation", body);
  const postGetIdpAssessment = (body) => api.post("getIdpAssessment", body);
  const postGetIdpAssessmentCompetence = (body) =>
    api.post("getIdpAssessmentCompetence", body);
  const postGetIdpJobCompetenceGroup = (body) =>
    api.post("getIdpJobCompetenceGroup", body);
  const postGetIdpAssessmentCompDtl = (body) =>
    api.post("getIdpAssessmentCompDtl", body);
  const postGetBpmIdpDocument = (body) => api.post("getBpmIdpDocument", body);
  const postGetBpmIdpDocumentDtl = (body) =>
    api.post("getBpmIdpDocumentDtl", body);
  const postGetIdpReviewerDtl = (body) => api.post("getIdpReviewerDtl", body);
  const postGetIdpReviewerList = (body) => api.post("getIdpReviewerList", body);
  const postGetIdpReviewer = (body) => api.post("getIdpReviewer", body);
  const postGetIdpBpmTrack = (body) => api.post("getIdpBpmTrack", body);
  const postGetTaskListIdp = (body) => api.post("getTaskListIdp", body);
  const postGetAttDailyPhoto = (body) => api.post("getAttDailyPhoto", body);
  const postGetIdpPlan = (body) => api.post("getIdpPlan", body);
  const postGetIdpMentor = (body) => api.post("getIdpMentor", body);
  const postGetIdpMentoring = (body) => api.post("getIdpMentoring", body);
  const postGetIdpMentoringDtl = (body) => api.post("getIdpMentoringDtl", body);
  const postGetIdpMentoringActPlan = (body) =>
    api.post("getIdpMentoringActPlan", body);
  const postGetIdpBpmTrackMentoring = (body) =>
    api.post("getIdpBpmTrackMentoring", body);
  const postGetTaskListIdpReviewer = (body) =>
    api.post("getTaskListIdpReviewer", body);

  const postSaveCompanyGroup = (body) => api.post("company-group/save", body);
  const postSaveCompany = (body) => api.post("company/save", body);
  const postSaveCompanyDocument = (body) =>
    api.post("company-document/save", body);
  const postSaveHoliday = (body) => api.post("holiday/save", body);
  const postSaveHolidayLocation = (body) =>
    api.post("holiday-location/save", body);
  const postSaveBizpar = (body) => api.post("bizpar/save", body);
  const postSaveBizparDtl = (body) => api.post("bizpar-dtl/save", body);
  const postForgotPass = (body) => api.post("forgetPass", body);
  const postPassVerify = (body) => api.post("forgetPassVerification", body);
  const postPassFinal = (body) => api.post("forgetPassFinal", body);
  const postSaveAppreciation = (body) => api.post("appreciation/save", body);
  const postSaveBpjsTk = (body) => api.post("bpjs-tk/save", body);
  const postSaveBpjsKs = (body) => api.post("bpjs-ks/save", body);
  const postSaveOtherInsurance = (body) =>
    api.post("other-insurance/save", body);
  const postSaveGeneralInfo = (body) => api.post("general-info/save", body);
  const postSavePtkp = (body) => api.post("ptkp/save", body);
  const postSaveIdentity = (body) => api.post("identity/save", body);
  const postSaveAddress = (body) => api.post("address/save", body);
  const postSaveFamily = (body) => api.post("family/save", body);
  const postSaveWorkExp = (body) => api.post("work-exp/save", body);
  const postSaveLanguageSkill = (body) => api.post("language-skill/save", body);
  const postSaveOrgExp = (body) => api.post("org-exp/save", body);
  const postSaveEducationFormal = (body) =>
    api.post("education-formal/save", body);
  const postSaveEducationInformal = (body) =>
    api.post("education-informal/save", body);
  const postSaveAbility = (body) => api.post("ability/save", body);
  const postSaveDeficiency = (body) => api.post("deficiency/save", body);
  const postSaveReference = (body) => api.post("reference/save", body);
  const postSaveEmergencyContact = (body) =>
    api.post("emergency-contact/save", body);
  const postSavePersonalCard = (body) => api.post("personal-card/save", body);
  const postSaveSosmed = (body) => api.post("sosmed/save", body);
  const postSaveTraining = (body) => api.post("training/save", body);
  const postSaveDocument = (body) => api.post("document/save", body);
  const postSavePersonnelReq = (body) => api.post("personnel-req/save", body);
  const postCreateInstancePersonal = (body) =>
    api.post("createInstancePersonal", body);
  const postCreateInstanceAttendance = (body) =>
    api.post("createInstanceAttendance", body);
  const postSaveBusinessFacility = (body) =>
    api.post("business-facility/save", body);
  const postSaveEmplSave = (body) => api.post("empl/save", body);
  const postSaveCareTaker = (body) => api.post("care-taker/save", body);
  const postSavePhoto = (body) => api.post("photo/save", body);
  const postSaveCnbApSched = (body) => api.post("cnb-ap-sched/save", body);
  const postSaveCnbApSchedDtl = (body) =>
    api.post("cnb-ap-sched-dtl/save", body);
  const postSaveLoanDocument = (body) =>
    api.post("person/loan-document/save", body);
  const postSaveNumbering = (body) => api.post("numbering/save", body);
  const postSaveNumberingCfg = (body) => api.post("numbering-cfg/save", body);
  const postSaveNumberingDtl = (body) => api.post("numbering-dtl/save", body);
  const postSaveLeaveCriteria = (body) => api.post("leave-criteria/save", body);
  const postSaveCnbComponentTemplate = (body) =>
    api.post("cnb-component-template/save", body);
  const postSaveCnbComponentTemplateDtl = (body) =>
    api.post("cnb-component-template-dtl/save", body);
  const postSaveReportConfig = (body) => api.post("report-config/save", body);
  const postSaveUploadEmpl = (body) => api.post("upload/empl/save", body);
  const postNotifUserSeenSave = (body) =>
    api.post("notif/user-seen/save", body);
  const postSaveProvince = (body) => api.post("province/save", body);
  const postSaveKabkot = (body) => api.post("kabkot/save", body);
  const postSaveKecamatan = (body) => api.post("kecamatan/save", body);
  const postSaveKelurahan = (body) => api.post("kelurahan/save", body);
  const postSaveEduLevel = (body) => api.post("edu-level/save", body);
  const postSaveEduInstitute = (body) => api.post("edu-institute/save", body);
  const postSaveEduMajor = (body) => api.post("edu-major/save", body);
  const postSaveCountry = (body) => api.post("country/save", body);
  const postSavePersonnelDocReq = (body) =>
    api.post("personnel-doc-req/save", body);
  const postSaveAppPositionTemplate = (body) =>
    api.post("app-position-template/save", body);
  const postSaveAppPosition = (body) => api.post("app-position/save", body);
  const postSaveAppPositionDtl = (body) =>
    api.post("app-position-dtl/save", body);
  const postCompleteTaskPrf = (body) => api.post("completeTaskPrf", body);
  const postUpdateCnbApSchedDtl = (body) =>
    api.post("cnb-ap-sched-dtl/update", body);
  const postSaveFacility = (body) => api.post("facility/save", body);
  const postSaveEmplOutsource = (body) =>
    api.post("upload/empl-outsource/save", body);
  const postSaveTrainingExp = (body) => api.post("training-exp/save", body);
  const postSaveTrainingDtl = (body) => api.post("training-dtl/save", body);
  const postSaveCnbReimburseSave = (body) =>
    api.post("cnb-reimburse/save", body);
  const postSaveCnbReimburseAmountSave = (body) =>
    api.post("cnb-reimburse-amount/save", body);
  const postCreateInstancePersonalReimburse = (body) =>
    api.post("createInstancePersonalReimburse", body);
  const postSaveCnbReimburseItemSave = (body) =>
    api.post("cnb-reimburse-item/save", body);
  const postSaveReimburseValidation = (body) =>
    api.post("reimburse-validation/save", body);
  const postSaveOvertimeSetting = (body) =>
    api.post("overtime-setting/save", body);
  const postSaveOvertimeCriteria = (body) =>
    api.post("overtime-criteria/save", body);
  const postSaveOvertimeRounding = (body) =>
    api.post("overtime-rounding/save", body);
  const postSaveCnbThrDate = (body) => api.post("cnb-thr-date/save", body);
  const postSavePrfIdpRatingQuestion = (body) =>
    api.post("prf-idp-rating-question/save", body);
  const postSavePrfIdpIndicator = (body) =>
    api.post("prf-idp-indicator/save", body);
  const postSavePrfIdpRating = (body) => api.post("prf-idp-rating/save", body);
  const postSavePrfIdpScore = (body) => api.post("prf-idp-score/save", body);
  const postSavePrfIdpTemplate = (body) =>
    api.post("prf-idp-template/save", body);
  const postCreateInstanceNonPersonalIdp = (body) =>
    api.post("createInstanceNonPersonalIdp", body);
  const postSavePrfIdpAssessmentComp = (body) =>
    api.post("prf-idp-assessment-comp/save", body);
  const postCreateBpmIdpDocument = (body) =>
    api.post("createBpmIdpDocument", body);
  const postSavePrfIdpReviewer = (body) =>
    api.post("prf-idp-reviewer/save", body);
  const postSavePrfIdpReviewerDtl = (body) =>
    api.post("prf-idp-reviewer-dtl/save", body);
  const postCompleteTaskIdp = (body) => api.post("completeTaskIdp", body);
  const postSaveIdpMentor = (body) => api.post("idp-mentor/save", body);
  const postSavePrfIdpMentoringActPlan = (body) =>
    api.post("prf-idp-mentoring-act-plan/save", body);

  //ricky
  const postSaveLocation = (body) => api.post("location/save", body);
  const postSaveLocationGroup = (body) => api.post("location-group/save", body);
  const postSaveLocationGroupExcel = (body) =>
    api.post("upload/location-group/save", body);
  const postSaveLocationGroupDetail = (body) =>
    api.post("location-group-dtl/save", body);
  const postSaveLocationGroupTemplate = (body) =>
    api.post("location-group-template/save", body);
  const postSaveRole = (body) => api.post("role/save", body);
  const postSaveUser = (body) => api.post("user/save", body);
  const postSaveRoleCompanyAllowed = (body) =>
    api.post("role-company-allowed/save", body);
  const postSaveRoleCompanyBanned = (body) =>
    api.post("role-company-banned/save", body);
  const postSaveRoleMenuAllowed = (body) =>
    api.post("role-menu-allowed/save", body);
  const postSaveRoleMenuBanned = (body) =>
    api.post("role-menu-banned/save", body);
  const postSaveRoleFormAllowed = (body) =>
    api.post("role-form-allowed/save", body);
  const postSaveRoleFormBanned = (body) =>
    api.post("role-form-banned/save", body);
  const postSaveRoleDataAllowed = (body) =>
    api.post("role-data-allowed/save", body);
  const postSaveRoleDataBanned = (body) =>
    api.post("role-data-banned/save", body);
  const postSaveRoleMemberJob = (body) =>
    api.post("role-member-job/save", body);
  const postSaveRoleMemberUser = (body) =>
    api.post("role-member-user/save", body);
  const postCreateBpmDocument = (body) => api.post("createBpmDocument", body);

  const postGetLocationTemplate = (body) =>
    api.post("template/get/locationGroup", body);
  const postGetLocation = (body) => api.post("getLocation", body);
  const postGetLocationDetail = (body) => api.post("getLocationDetail", body);
  const postGetCompanyDdl = (body) => api.post("getCompanyDdl", body);
  const postGetLocationGroupDdl = (body) =>
    api.post("getLocationGroupDdl", body);
  const postGetBizpar = (body) => api.post("getBizpar", body);
  const postGetProvince = (body) => api.post("getProvince", body);
  const postGetCity = (body) => api.post("getKabkot", body);
  const postGetDistrict_ = (body) => api.post("getKecamatan", body);
  const postGetSubDistrict = (body) => api.post("getKelurahan", body);
  const postGetTaxOfficeDdl = (body) => api.post("getTaxOfficeDdl", body);
  const postGetLocationGroupTemplate = (body) =>
    api.post("getLocationGroupTemplate", body);
  const postGetLocationGroup = (body) => api.post("getLocationGroup", body);
  const postGetLocationGroupDetail = (body) =>
    api.post("getLocationGroupDtl", body);
  const postGetReportLocation = (body) => api.post("report/get/location", body);
  const postGetRole = (body) => api.post("getRole", body);
  const postGetRoleMemberJob = (body) => api.post("getRoleMemberJob", body);
  const postGetRoleMemberUser = (body) => api.post("getRoleMemberUser", body);
  const postGetRoleCompanyAllowed = (body) =>
    api.post("getRoleCompanyAllowed", body);
  const postGetRoleCompanyBanned = (body) =>
    api.post("getRoleCompanyBanned", body);
  const postGetRoleMenuAllowed = (body) => api.post("getRoleMenuAllowed", body);
  const postGetRoleMenuBanned = (body) => api.post("getRoleMenuBanned", body);
  const postGetRoleFormAllowed = (body) => api.post("getRoleFormAllowed", body);
  const postGetRoleFormBanned = (body) => api.post("getRoleFormBanned", body);
  const postGetRoleDataAllowed = (body) => api.post("getRoleDataAllowed", body);
  const postGetRoleDataBanned = (body) => api.post("getRoleDataBanned", body);
  const postGetJobRoleDdl = (body) => api.post("getJobRoleDdl", body);
  const postGetRoleUserDdl = (body) => api.post("getRoleUserDdl", body);
  const postGetUserRole = (body) => api.post("getUserRole", body);
  const postGetEmplOutList = (body) => api.post("getEmplOutList", body);
  const postGetBpmDocument = (body) => api.post("getBpmDocument", body);

  const postTemplatePayrollProses = (body) =>
    api.post("template.document.process", body);

  const postTemplateMasterdataVendorProses = (body) =>
    api.post("template.document.process.masterdata.vendor", body);
  const postTemplateOutsourceProses = (body) =>
    api.post("template.document.process.outsource", body);
  const postTemplateOutsourceAssingmentProses = (body) =>
    api.post("template.document.process.outsource.assignment", body);

  //Aryo - Master Data
  const postGetGrade = (body) => api.post("getGrade", body);
  const postSaveGrade = (body) => api.post("grade/save", body);
  const getLevelDdljob = (body) => api.post("getLevelDdl", body);
  // Aryo - Leave Config
  const getLeavemaster = (body) => api.post("getLeave", body);
  const getLeavequota = (body) => api.post("getLeaveQuota", body);
  const getLeavequotaDtl = (body) => api.post("getLeaveQuotaDtl", body);
  const getPeriodyear = () => api.get("getPeriodYearDdl");
  const getLeavetypeddl = (body) => api.post("getLeaveTypeDdl", body);
  const getLeaveHistory = (body) => api.post("getEmplLeaveHist", body);

  const postLeavemaster = (body) => api.post("leave/save", body);
  const postLeavequota = (body) => api.post("leave-quota/save", body);

  const getAttSummary = (body) => api.post("getAttSummary", body);
  const getAttSummaryReq = (body) => api.post("getAttendanceReq", body);
  const getAttSummaryReqESS = (body) => api.post("ess/getAttendanceReq", body);
  const postGetAttendanceReqWf = (body) =>
    api.post("ess/getAttendanceReqWf", body);
  const getAttDaily = (body) => api.post("getAttDaily", body);
  const getAttDailyEss = (body) => api.post("getAttDailyEss", body);
  const postAttendancesave = (body) => api.post("attendance/save", body);
  const postEssAttendancesave = (body) =>
    api.post("ess/attendance-req/save", body);
  const postEssAttGetDoc = (body) => api.post("ess/getAttendanceReqDoc", body);
  const postAttGetDoc = (body) => api.post("getAttDailyDoc", body);
  const postEssAttGetDocDtl = (body) =>
    api.post("ess/getAttendanceReqDocDtl", body);
  const postAttGetDocDtl = (body) => api.post("getAttDailyDocDtl", body);
  const postEssAttDocSave = (body) => api.post("ess/attendance-doc/save", body);
  const postAttDocSave = (body) => api.post("att-daily-doc/save", body);

  //willy
  const getUnit = (body) => api.get("getRecUnit", body);
  const getBank = (body) => api.get("getRecUnit", body);
  const getCabang = (body) => api.get("getCabang", body);
  const getDelivery = (body) => api.get("getdelivery", body);
  const getPart = (body) => api.get("getRecPart", body);
  const getSeries = (body) => api.get("getlist", body);
  const postGetUser = (body) => api.post("user/getUser", body);
  const postCreateSeries = (body) => api.post("create", body);
  const postGetReportStatus = (body) => api.post("get/reportStatus", body);
  const downloadBigReportExcel = (body) => api.post("get/downloadReport", body);
  const postTest = (body) => api.post("/test", body);

  // Aryo --Job  & Position ---
  const postSaveJobDocument = (body) => api.post("job-document/save", body);
  const postGetJobDocument = (body) => api.post("getJobDocument", body);
  const postGetJobDocumentDetail = (body) =>
    api.post("getJobDocumentDetail", body);
  const postSaveJobLevel = (body) => api.post("job-level/save", body);
  const postSaveJobLocation = (body) => api.post("job-location/save", body);
  const postGetJobLevel = (body) => api.post("getJobLevel", body);
  const postGetJob = (body) => api.post("getJob", body);
  const postGetLevel = (body) => api.post("getLevel", body);
  const postGetJobDetail = (body) => api.post("getJobDetail", body);
  const postSaveJob = (body) => api.post("grade/save", body);
  const postSaveJobPos = (body) => api.post("job/save", body);
  const postSaveJobPosUpload = (body) => api.post("upload/job/save", body);
  const postSavePositionUpload = (body) =>
    api.post("upload/job-position/save", body);
  const postGetPosition = (body) => api.post("getJobPosition", body);
  const postGetJobDdl = (body) => api.post("getJobDdl", body);
  const postGetLocationDdl = (body) => api.post("getLocationDdl", body);
  const postGetJobTemplete = (body) => api.post("template/get/job", body);
  const postGetPositionTemplete = (body) =>
    api.post("template/get/jobPosition", body);

  // Aryo Master Data - Cost Center
  const getCostCenter = (body) => api.post("getCostCenter", body);
  const getJobPositionDdl = (body) => api.post("getJobPositionDdl", body);
  const getCostTemplate = (body) => api.post("getCostTemplate", body);
  const getCostCenterDdl = (body) => api.post("getCostCenterDdl", body);
  const getCostTemplateDtl = (body) => api.post("getCostTemplateDtl", body);
  const getCostTemplateDtlPosition = (body) =>
    api.post("getCostTemplateDtlPosition", body);
  const postCostCenterSave = (body) => api.post("cost-center/save", body);
  const postCostTemplateSave = (body) => api.post("cost-template/save", body);
  const postCostTemplateDtlSave = (body) =>
    api.post("cost-template-dtl/save", body);
  const postCostTemplateDtlPositionSave = (body) =>
    api.post("cost-template-dtl-position/save", body);
  const getTemplateCost = (body) =>
    api.post("template/get/costCenterTemplate", body);
  const postUploadTemplateCost = (body) =>
    api.post("upload/cost-center/save", body);
  // Aryo - Master Data Level
  const postLeveljob = (body) => api.post("level/save", body);
  // Aryo Personnel - Outsource
  const postLeadout = (body) => api.post("empl-out-lead/save", body);
  const postDocumentout = (body) => api.post("empl-out-document/save", body);
  const getEmploutdtl = (body) => api.post("getEmplOutDtl", body);
  const getEmploutdirectlead = (body) => api.post("getEmplOutDirectLead", body);
  const getEmploutdocument = (body) => api.post("getEmplOutDocument", body);
  const getEmploutdocumentDtl = (body) =>
    api.post("getEmplOutDocumentDtl", body);
  const getEmploutsource = (body) => api.post("getEmplOutsource", body);
  const postEmplout = (body) => api.post("empl-out/save", body);
  const getVendor = (body) => api.post("getVendor", body);
  const getVendorDdl = (body) => api.post("getVendorDdl", body);
  // const udahada = body => api.post('getJobDdl', body)

  //Nadya
  const getPayslip = (body) => api.post("getPayslip", body);
  const getPayslipESS = (body) => api.post("getPayslipEss", body);
  const getPayslipReport = (body) => api.post("payslip", body);
  const getUserAuth = (body) => api.post("authentication/login", body);
  const getPph1721 = (body) => api.post("getPph1721", body);
  const getPph1721Ess = (body) => api.post("getPph1721Ess", body);
  const getPph1721Report = (body) => api.post("pph1721", body);
  const postGetSppd = (body) => api.post("sppd", body);
  const getQuestionType = (body) => api.post("getQuestionType", body);
  const getPph1721NonEmpl = (body) => api.post("pph1721-non-empl", body);

  //performance config
  const getPerfQuestion = (body) => api.post("getQuestion", body);
  const getIndicator = (body) => api.post("getIndicator", body);
  const getRating = (body) => api.post("getRating", body);
  const postSavePerfQuestion = (body) => api.post("prf-question/save", body);
  const postSaveIndicator = (body) => api.post("prf-indicator/save", body);
  const postSaveRating = (body) => api.post("prf-rating/save", body);
  const getIndicatorValidation = (body) =>
    api.post("/getIndicatorValidation", body);

  const getTplIPP = (body) => api.post("getTemplateIpp", body);
  const getTemplateWeightValidation = (body) =>
    api.post("getTemplateWeightValidation", body);
  const getTemplateQuest = (body) => api.post("getTemplateQuest", body);
  const postSaveIPPTpl = (body) => api.post("prf-template/save", body);

  // performance cycle
  const getCycleAssignment = (body) => api.post("getCycleAssignment", body);
  const getCAAssigneeCriteria = (body) => api.post("getAssigneeCriteria", body);
  const postCycleAssignment = (body) => api.post("cycle-assignment/save", body);
  const getAssignee = (body) => api.post("getAssignee", body);
  const postAssignEmpl = (body) => api.post("assignee-empl/save", body);
  const postAssignposting = (body) => api.post("assignee-posting/save", body);
  const postAssignUnposting = (body) =>
    api.post("assignee-empl-unpublish", body);
  const postAssignEmplUnposting = (body) =>
    api.post("assignee-empl-rev-unpublish", body);
  const getAssigneeEmplRev = (body) => api.post("getAssigneeEmplRev", body);
  const postAssignRev = (body) => api.post("assignee-empl-rev/save", body);
  const getReviewer = (body) => api.post("getReviewer", body);
  const postTemplateGetAsgn = (body) =>
    api.post("template/prf/cycleAssignment", body);
  const postSaveUploadAsgn = (body) =>
    api.post("upload/prf/cycle-assignment/save", body);
  const postAssigneeEmplRevPostingSave = (body) =>
    api.post("assignee-empl-rev-posting/save", body);

  const getCycleEvaluation = (body) => api.post("getCycleEvaluation", body);
  const getAssigneeEvaluation = (body) =>
    api.post("getAssigneeEvaluation", body);
  const getProcessEvaluationDtl = (body) =>
    api.post("getProcessEvaluationDtl", body);
  const getProcessEvaluationSum = (body) =>
    api.post("getProcessEvaluationSum", body);

  // performance plan
  const getIpp = (body) => api.post("getIpp", body);
  const getQuestionByEmplId = (body) =>
    api.post("performance/getQuestionByEmplId", body);
  const getIppRating = (body) => api.post("performance/getIppRating", body);
  const postIppRating = (body) => api.post("performance/ipp-rating/save", body);
  const getIppTarget = (body) => api.post("performance/getIppTarget", body);
  const postIppTarget = (body) => api.post("performance/ipp-target/save", body);
  const postBpmIppTarget = (body) =>
    api.post("bpm/prf-bpm-ipp-target/save", body);
  const postBpmIppRating = (body) =>
    api.post("bpm/prf-bpm-ipp-rating/save", body);
  const getBpmIpp = (body) => api.post("bpm/getBpmIpp", body);
  const getPrfBpmIppRating = (body) => api.post("bpm/getPrfBpmIppRating", body);
  const getPrfBpmIppTarget = (body) => api.post("bpm/getPrfBpmIppTarget", body);
  const postCreateInstancePersonalPrf = (body) =>
    api.post("bpm/createInstancePersonalPrf", body);
  const getSubmitValidation = (body) => api.post("getSubmitValidation", body);
  const getIppReview = (body) => api.post("getIppReview", body);

  //config Setting
  const getSetting = (body) => api.post("getSetting", body);
  const postSaveSetting = (body) => api.post("setting/save", body);

  // comben
  const getMonthlyClosing = (body) => api.post("getMonthlyClosing", body);
  const getMonthlyClosingDtl = (body) => api.post("getMonthlyClosingDtl", body);
  const postCNBCLosing = (body) => api.post("cnb-ap-closing/save", body);

  // dashboard
  const getNewDashboard = (body) => api.post("getDashboard", body);
  const getMonthlyAttMonitoring = (body) =>
    api.post("getMonthlyAttMonitoring", body);

  //wfhAssignment
  const postWFHTemplate = () => api.get("template/get/wfhSchedule");
  const postUploadWFHSave = (body) =>
    api.post("/upload/wfh-schedule/save", body);
  const getWfhSchedule = (body) => api.post("getWorkWfhSchedule", body);
  const getWfhDTLSchedule = (body) => api.post("getWorkWfhScheduleDtl", body);
  const postWFHHeadSave = (body) => api.post("wfh-schedule-head/save", body);
  const postWFHSave = (body) => api.post("wfh-schedule/save", body);

  // help
  const postGetHelpQuest = (body) => api.post("help/getHelpQuest", body);
  const postHelpQuestSave = (body) => api.post("help/help-quest/save", body);
  const postHelpQuestDocSave = (body) =>
    api.post("help/help-quest-doc/save", body);
  const postGetHelpDiscuss = (body) => api.post("help/getHelpDiscuss", body);
  const postHelpDiscussSave = (body) =>
    api.post("help/help-discuss/save", body);
  const postHelpDiscussDocSave = (body) =>
    api.post("help/help-discuss-doc/save", body);
  const postHelpDiscussGetDoc = (body) =>
    api.post("help/getHelpDiscussDoc", body);

  // OUTSOURCE_QUERY
  const getAllOutsourceAssignment = (body) =>
    api.post("query/get.all.outsource.assignment", body);
  const getAllOutsource = (body) => api.post("query/get.all.outsource", body);
  const getOutsourceByVendorID = (body) =>
    api.post("query/get.outsource.by.vendor.id", body);
  const getOutsourceAssignmentByEsid = (body) =>
    api.post("query/get.outsource.assignment.by.esid.and.osaname", body);
  const getNewOutsourceAssignmentByEsid = (body) =>
    api.post("query/get.all.outsource.assignment.web", body);
  const getCountOutsourceAssignmentByEsid = (body) =>
    api.get("query/get.count.outsource.assignment.by.esid/" + body);
  const getCountOutsourceAssignmentByEsidOsaname = (body) =>
    api.get("query/get.count.outsource.assignment.by.esid.and.osaname/" + body);

  // OUTSOURCE
  const postOutsource = (body) => api.post("command/post.outsource", body);
  const putOutsource = (body) => api.put("command/put.outsource", body);
  const deleteOutsource = (body) =>
    api.post("/delete.outsource", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postOutsourceAssignment = (body) =>
    api.post("command/post.outsource.assignment", body);
  const putOutsourceAssignment = (body) =>
    api.put("command/put.outsource.assignment", body);
  const deleteOutsourceAssignment = (body) =>
    api.post("/delete.outsource.assignment", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postOutsourceDocument = (body) =>
    api.post("api/outsource.document.post", body);
  const outsourcePhotoPost = (body) =>
    api.post("/api/outsource.photo.post", body);
  const getOutsourcebyID = (body) =>
    api.get("query/get.outsource.by.id/" + body);

  // IDP
  const forgotPass = (body) => api.post("/forgot.password", body);
  // const userAuth = (body) => api.post("/api/authentication/login", body);
  // const userAuth = body => api.post('/api/authentication/loginFull', body);
  const userAuth = (body) =>
    api.post("/api/v1.0/UserAuthentication/login", body);
  const userRefreshToken = () => api.get("refreshToken");
  const getUserAll = (body) => api.post("/get.all.user", body);
  const getUserByID = (body) => api.get("/get.user.by.id/" + body);
  const postUser = (body) => api.post("/post.user", body);
  const updateUser = (body) => api.put("/update.user", body);
  const updateUserPassword = (body) => api.put("/update.user.password", body);
  const updateUserMCP = (body) => api.put("/update.user.mcp", body);
  const updateUserPassword2 = (body) =>
    api.put("/update.user.password.with.no.checking", body);
  const deleteUser = (body) =>
    api.post("/delete.user", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getRoleAll = (body) => api.post("/get.all.role", body);
  const getRoleByStatus = (body) => api.post("/get.role.by.status", body);
  const getRoleByName = (body) => api.post("get.role.by.name", body);
  const getPrivilegeAll = (body) => api.post("/get.all.privilege", body);
  const updateRole = (body) => api.put("/update.role", body);
  const postRole = (body) => api.post("/post.role", body);
  const deleteRole = (body) =>
    api.post("/delete.role", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postUserRole = (body) => api.post("/post.user.role", body);
  const postUserRoleList = (body) => api.post("list.post.user.role", body);
  const deleteUserRoleList = (body) =>
    api.post("delete.list.user.role", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteUserRole = (body) =>
    api.post("/delete.user.role", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const addPrivilege = (body) =>
    api.get("role.privilege.assign/" + body.roleID + "/" + body.privilegeID);
  const deletePrivilege = (body) =>
    api.get("role.privilege.unassign/" + body.roleID + "/" + body.privilegeID);
  const getUserByName = (body) => api.post("get.user.by.name", body);
  const getCountUser = (body) => api.get("get.count.user.by.name/" + body);
  const getUserByEmployeeID = (body) =>
    api.get("get.user.by.employee.id/" + body);
  const getUserByEmployeeName = (body) => api.post("get.all.user.web", body);
  const getCountUserByEmployeeName = (body) =>
    api.get("get.count.user.by.employee.name/" + body);
  const getCountAllUser = () => api.get("get.count.all.user/");
  const getCountRoleAll = () => api.get("get.count.all.role");
  const getCountRoleName = (body) => api.get("get.count.role.by.name/" + body);

  const getAllIndentUnit = (body) =>
    api.post("TransactionIndentUnit/findAll", body);
  const cancelIndentUnit = (body) =>
    api.put("TransactionIndentUnit/cancelIndentUnit", body);
  const getIndentUnitDetail = (kodeCabang, indentNo) =>
    api.get(
      `TransactionIndentUnit/findIndentUnit?kodeCabang=${kodeCabang}&indentNo=${indentNo}`
    );
  const modifyIndentUnit = (body) =>
    api.post("TransactionIndentUnit/saveAndUpdate", body);
  const getIndentProspect = (params) =>
    api.get(`Prospect/getProspectForIndent`, params);
  const getIndentCustomer = (params) =>
    api.get("CustomerProfile/getCustomerForIndent", params);
  const generateExcelIndentUnit = (params) => api.get("IndentUnitPrint/generateMonitoringExcel", params)
  const printPDFIndentUnit = (params) => api.get("IndentUnitPrint/generateMonitoringPdf", params)

  // BIZPAR
  const getBizparWeb = (body) => api.post("get.all.bizpar.web", body);
  const getBizparByCategoryChild = (body) =>
    api.post("/get.bizpar.by.category.child", body);
  // const getBizparByCategory = (body) =>
  //   api.post("/get.bizpar.by.category", body);
  const getCountBizparByCategory = (body) =>
    api.get("/get.count.bizpar.by.bizpar.category/" + body);
  // const getAllBizpar = () => api.get("/get.all.bizpar.category");
  const getBizparByParentKey = (body) =>
    api.post("/get.bizpar.by.parentkey.and.category", body);
  const getBizparByStatus = (body) => api.post("/get.bizpar.by.status", body);
  const postBizpar = (body) => api.post("/post.bizpar", body);
  const updateBizpar = (body) => api.put("/update.bizpar", body);
  const deleteBizpar = (body) =>
    api.post("/delete.bizpar", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getBizparByParentKeyAndCategory = (body) =>
    api.post("get.bizpar.by.parentkey.and.category", body);
  const getBizparByValue = (body) => api.post("/get.bizpar.by.value", body);
  const getCountBizparByValue = (body) =>
    api.get("/get.count.bizpar.by.bizpar.value/" + body);
  const getCountBizparByStatus = (body) =>
    api.get("/get.count.bizpar.by.bizpar.status/" + body);
  const getAllBizparByParentKey = (body) =>
    api.post("get.all.bizpar.by.parentkey", body);
  const getCountBizparByParentKey = (body) =>
    api.get("get.count.bizpar.by.parentkey/" + body);

  // EMPLOYEE
  // const getAllEmployee = (body) => api.post("/query/get.all.employee", body);
  const getEmpZodiac = (body) =>
    api.get("query/get.employee.zodiac.by.birthdate/" + body);
  const getEmployeeBiodata = (body) =>
    api.get("/get.biodata.modification.by.requestid/" + body);
  const getEmployeeByStatus = (body) =>
    api.post("/query/get.employee.by.status", body);
  const getEmpBySubDir = (body) =>
    api.post("/query/get.all.employee.by.sub.directorate.key", body);
  const getEmployee360ById = (body) =>
    api.get("get.employee360.by.empid/" + body);
  const putEmployee = (body) => api.put("/command/put.employee", body);
  const putEmployeePGP = (body) => api.put("/command/put.employee.ppg", body);
  const putEmployeeAbility = (body) =>
    api.put("/command/put.employee.special.ability", body);
  const putEmployeWeakness = (body) =>
    api.put("/command/put.employee.weakness", body);
  const updateEmployeeWorkExperience = (body) =>
    api.put("/command/put.employee.work.experience", body);
  const updateEmployeeFormalEducation = (body) =>
    api.put("/command/put.employee.formal.education", body);
  const updateEmployeeInformalEducation = (body) =>
    api.put("/command/put.employee.informal.education", body);
  const updateEmployeeEmergencyContact = (body) =>
    api.put("/command/put.employee.emergency.contact", body);
  const updateEmployeeDocument = (body) =>
    api.put("/command/put.employee.document", body);
  const updateEmployeeSocialMedia = (body) =>
    api.put("/command/put.employee.social.media", body);
  const updateEmployeeLicense = (body) =>
    api.put("/command/put.employee.license", body);
  const updateEmployeeReference = (body) =>
    api.put("/command/put.employee.reference", body);
  const updateEmployeeOrgExp = (body) =>
    api.put("/command/put.employee.organization.experience", body);
  const updateEmployeeLanguSkill = (body) =>
    api.put("/command/put.employee.language.skill", body);
  const createAndUpdateFam = (body) =>
    api.put("/command/put.employee.family", body);
  const employeePhotoPost = (body) =>
    api.post("/api/employee.photo.post", body);
  const employeeFamPhotoPost = (body) =>
    api.post("/api/employee.family.photo.post", body);
  const uploadDocument = (body, config) =>
    api.post("/api/employee.document.post", body, config);
  const uploadMedicalDoc = (body, config) =>
    api.post("/api/applicant.medical.check.up.document.post", body, config);
  const updateEmployeeInsurance = (body) =>
    api.put("/command/put.employee.insurance", body);
  const updateEmployeeFacility = (body) =>
    api.put("/command/put.employee.facility", body);
  const updateEmployeeAppreciation = (body) =>
    api.put("/command/put.employee.appreciation", body);
  const updateEmployeePayment = (body) =>
    api.put("/command/put.employee.payment.method", body);
  const uploadDocumentAppreciation = (body, config) =>
    api.post("/api/appreciation.document.post", body, config);
  const getTrainingRequestById = (body) =>
    api.post("/query/get.training.request.by.employee.id", body);
  const getEmployeeByEsid = (body) =>
    api.post("/query/get.employee.by.esid", body);
  const getNewEmployeeByEs = (body) =>
    api.post("/query/get.all.employee.list", body);
  const getAllEmployeeTraining = (body) =>
    api.post("/query/get.all.employee.web.training", body);
  const getEmployeeByEsidEmpName = (body) =>
    api.post("/query/get.employee.by.esid.and.employeename", body);
  const getEmployeeByEsidOptimize = (body) =>
    api.post("/query/get.employee.optimize.by.esid", body);
  const getEmployeeKseCheckByEmpId = (body) =>
    api.post("query/get.employee.kse.checklist.by.employee.id", body);
  const getEmployeeByEsidOptimizeTalent = (body) =>
    api.post("query/get.employee.optimize.talent.by.esid", body);

  //Personal Management
  const getAllMovement = (body) => api.post("/query/get.all.movement", body);
  const getNewAllMovement = (body) =>
    api.post("/query/get.all.movement.web.personnel", body);
  const postMovement = (body) => api.post("/command/post.movement", body);
  const updateMovement = (body) => api.put("/command/put.movement", body);
  const uploadMovementDoc = (body, config) =>
    api.post("/api/movement.document.post", body, config);
  const updateMovementDataDoc = (body) =>
    api.put("/command/put.movement.document", body);
  const deleteMovementDoc = (body) =>
    api.post("api/movement.document.delete", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteMovement = (body) =>
    api.post("/delete.movement", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllTermination = (body) =>
    api.post("/query/get.all.termination", body);
  const postTermination = (body) => api.post("/command/post.termination", body);
  const updateTermination = (body) => api.put("/command/put.termination", body);
  const uploadTerminationDoc = (body, config) =>
    api.post("/api/termination.document.post", body, config);
  const updateTerminationDataDoc = (body) =>
    api.put("/command/put.termination.document", body);
  const deleteTerminationDoc = (body) =>
    api.post("api/termination.document.delete", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getTermExtSickByID = (body) =>
    api.get("/query/get.termination.sakitberkepanjangan.by.id/" + body);
  const getTermExtSickWeb = (body) =>
    api.post("/query/get.all.termination.sakitberkepanjangan.web", body);
  const postTermExtSick = (body) =>
    api.post("/command/post.termination.sakitberkepanjangan", body);
  const updateTermExtSick = (body) =>
    api.put("/command/put.termination.sakitberkepanjangan", body);
  const uploadTermExtSick = (body, config) =>
    api.post(
      "/api/termination.sakitberkepanjangan.document.post",
      body,
      config
    );
  const deleteTermExtSick = (body) =>
    api.post("/delete.termination.sakitberkepanjangan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const deleteTermination = (body) =>
    api.post("/delete.termination", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getEmployeeHead = (body) => api.post("query/get.employee.head", body);
  const getEmployeeByName = (body) =>
    api.post("query/get.employee.by.name", body);
  const getEmployeeTerm = (body) =>
    api.post("query/get.all.employee.list.for.termination", body);
  const getNewEmployee = (body) => api.post("query/get.all.employee.web", body);
  const getEmployeeByPPG = (body) =>
    api.post("query/get.all.employee.web.ppg", body);
  const getStatusPPG = (body) =>
    api.get("query/get.found.status.payroll.group.processing/" + body);
  const getCountEmployee = (body) =>
    api.get("query/get.count.employee.by.name/" + body);
  const getCountAllEmployee = () => api.get("query/get.count.all.employee");
  const getCountEmployeeByEsid = (body) =>
    api.get("query/get.count.employee.by.esid/" + body);
  const getCountEmployeeByEsidEmpName = (body) =>
    api.get("query/get.count.employee.by.esid.and.employeename/" + body);

  const getMovementByID = (body) =>
    api.get("/query/get.movement.by.id/" + body);
  const getMovByEmpCats = (body) =>
    api.post("/query/get.movement.by.employeeid.and.categories", body);
  const getCheckMovementStatus = (body) =>
    api.post("/query/check.movement.status.by.employee.id", body);

  const getTerminationByID = (body) =>
    api.get("/query/get.termination.by.id/" + body);
  const getTrainingByID = (body) =>
    api.get("/query/get.training.request.by.id/" + body);
  const getLeaveByID = (body) => api.get("/query/get.leave.by.id/" + body);
  const getCheckRemainingDaysOff = (body) =>
    api.get("/query/get.leave.outstanding.quota.by.paramsdate/" + body);
  const getAbsenceByID = (body) =>
    api.get("/query/get.hcis.request.by.id/" + body);
  const getOvertimeByOVID = (body) =>
    api.get("/query/get.overtime.by.id/" + body);

  const getAttendanceByEmpIDandDate = (body) =>
    api.get("/query/get.all.timesheet.by.employee.id.and.current.date/" + body);
  const getCalculateAttendaceEmployeeByMonthAndYear = (body) =>
    api.get("/query/get.calculate.attendence.employee.in.month/" + body);
  const submitAttendance = (body) => api.post("/command/fingerprint", body);
  const postAttendance = (body) => api.post("/command/post.timesheet", body);
  const putAttendance = (body) => api.put("/command/put.timesheet", body);
  const uploadAttendance = (body, config) =>
    api.post("/api/timesheet.photo.post", body, config);
  const postPersonalTask = (body) =>
    api.post("/command/post.timesheet.task", body);
  const putPersonalTask = (body) =>
    api.put("/command/put.timesheet.task", body);
  const deleteAttendance = (body) =>
    api.post("/delete.timesheet", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deletePersonalTask = (body) =>
    api.post("/delete.timesheet.task", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // CFG
  const getIppTplById = (body) => api.get("/get.ipp.tpl.by.id/" + body);
  const postIppTplComponentHeader = (body) =>
    api.post("post.ipp.tpl.component.header", body);
  const putIppTplComponentHeader = (body) =>
    api.put("update.ipp.tpl.component.header", body);
  const postIppTplComputeSection = (body) =>
    api.post("post.ipp.tpl.compute.section", body);
  const putIppTplComputeSection = (body) =>
    api.put("update.ipp.compute.section", body);
  const putIppTplProcessCriteria = (body) =>
    api.put("update.ipp.output.criteria.process", body);
  const putIppTplSignageSection = (body) =>
    api.put("update.ipp.signage.section", body);
  const putIppTplOutputCriteria = (body) =>
    api.put("update.ipp.output.criteria", body);
  const putIppTplAssignment = (body) =>
    api.put("update.ipp.output.criteria.assignment", body);
  const putIppTplDisipline = (body) =>
    api.put("update.ipp.output.criteria.discipline", body);
  const putIppTplPeople = (body) =>
    api.put("update.ipp.output.criteria.people", body);
  const putIppTplMovement = (body) =>
    api.put("update.ipp.output.criteria.movement", body);
  const getAllIPP = (body) => api.post("get.ipp.tpl", body);
  const postIppTpl = (body) => api.post("post.ipp.tpl", body);
  const putIppTpl = (body) => api.put("update.ipp.tpl", body);
  const deleteIppTpl = (body) =>
    api.post("/delete.ipp.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllCorporateTalent = (body) => api.post("get.all.talent.tpl", body);
  const getCorporateTalentByID = (body) =>
    api.get("get.corporate.talent.tpl.by.id/" + body);
  const postCorporateTalent = (body) =>
    api.post("post.corporate.talent.tpl", body);
  const putCorporateTalent = (body) =>
    api.put("update.corporate.talent.tpl", body);
  const deleteCorporateTalent = (body) =>
    api.post("delete.corporate.talent.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getAllMpp = (body) => api.post("/get.all.mpp", body);
  const getMppByEs = (body) => api.post("/get.all.mpp.web", body);
  const postMpp = (body) => api.post("/post.mpp", body);
  const updateMpp = (body) => api.put("/update.mpp", body);
  const deleteMpp = (body) =>
    api.post("/delete.mpp", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadDocMPP = (body, config) =>
    api.post("/api/mpp.photo.post", body, config);
  const getPositionMPP = (body) =>
    api.post("get.es.detail.children.flat.by.ouid/", body);
  const getCountMppByName = (body) => api.get("get.count.mpp.by.name/" + body);
  const getMppByName = (body) => api.post("get.mpp.by.name", body);
  const getMppByPositionName = (body) =>
    api.post("get.mpp.by.position.name", body);
  const getCountMppByPositionName = (body) =>
    api.get("get.count.mpp.by.position.name/" + body);
  const getCountAllMpp = () => api.get("get.all.count.mpp");
  const getCorporateHolidayByStatus = (body) =>
    api.post("get.corporate.holiday.by.status", body);
  const getCorporateHolidayByESID = (body) =>
    api.post("get.corporate.holiday.by.esid", body);
  const getAllCorporateHoliday = (body) =>
    api.post("get.all.corporate.holiday", body);
  const getCorporateHolidayByID = (body) =>
    api.get("get.corporate.holiday.by.id/" + body);
  const updateCorporateHoliday = (body) =>
    api.put("update.corporate.holiday", body);
  const postCorporateHoliday = (body) =>
    api.post("post.corporate.holiday", body);
  const postPhotoCorporateHoliday = (body) =>
    api.post("api/corporate.holiday.photo.post", body);
  const deleteCorporateHoliday = (body) =>
    api.post("/delete.corporate.holiday", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorporateOfficeHourByStatus = (body) =>
    api.post("get.corporate.office.hour.by.status", body);
  const getCorporateOfficeHourByESID = (body) =>
    api.post("get.corporate.office.hour.by.esid", body);
  const getAllCorporateOfficeHour = (body) =>
    api.post("get.all.corporate.office.hour", body);
  const getCorporateOfficeHourByID = (body) =>
    api.get("get.corporate.office.hour.by.id/" + body);
  const updateCorporateOfficeHour = (body) =>
    api.put("update.corporate.office.hour", body);
  const postCorporateOfficeHour = (body) =>
    api.post("post.corporate.office.hour", body);
  const postPhotoCorporateOfficeHour = (body) =>
    api.post("api/corporate.office.hour.photo.post", body);
  const deleteCorporateOfficeHour = (body) =>
    api.post("/delete.corporate.office.hour", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getPersonelOfficeHourByStatus = (body) =>
    api.post("get.personel.office.hour.by.status", body);
  const getPersonelOfficeHourByESID = (body) =>
    api.post("get.personel.office.hour.by.es.id", body);
  const getAllPersonelOfficeHour = (body) =>
    api.post("get.all.personel.office.hour", body);
  const updatePersonalOfficeHour = (body) =>
    api.put("update.personel.office.hour", body);
  const postPersonalOfficeHour = (body) =>
    api.post("post.personel.office.hour", body);
  const deletePersonalOfficeHour = (body) =>
    api.post("/delete.personel.office.hour", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getOfficeShiftHourByStatus = (body) =>
    api.post("get.office.shift.hour.by.status", body);
  const getOfficeShiftHourByESID = (body) =>
    api.post("get.office.shift.hour.by.es.id", body);
  const getAllShiftHour = (body) => api.post("get.all.office.shift.hour", body);
  const updateOfficeShiftHour = (body) =>
    api.put("update.office.shift.hour", body);
  const postOfficeShiftHour = (body) =>
    api.post("post.office.shift.hour", body);
  const deleteOfficeShiftHour = (body) =>
    api.post("/delete.office.shift.hour", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getMppByID = (body) => api.get("get.mpp.by.id/" + body);
  const getAllTax = (body) => api.post("get.all.corporate.tax.tpl", body);
  const getTaxByStatus = (body) =>
    api.post("get.corporate.tax.tpl.by.status", body);
  const getTaxWeb = (body) =>
    api.post("get.all.config.corporate.tax.web", body);
  const getCountTaxByStatus = (body) =>
    api.get("get.count.corporate.tax.tpl.by.status/" + body);
  const getTaxByID = (body) => api.get("get.corporate.tax.tpl.by.id/" + body);
  const postTax = (body) => api.post("post.corporate.tax.tpl", body);
  const updateTax = (body) => api.put("update.corporate.tax.tpl", body);
  const deleteTax = (body) =>
    api.post("delete.corporate.tax.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postPhotoTax = (body) =>
    api.post("api/corporate.tax.tpl.photo.post", body);
  const getAllCorporateTravelExpense = (body) =>
    api.post("get.all.corporate.travel.expense/", body);
  const getCorporateTravelExpenseByEs = (body) =>
    api.get("get.corporate.travel.expense.by.esid/" + body);
  const getCorporateTravelExpenseWeb = (body) =>
    api.post("get.all.config.travel.expense.web", body);
  const postCorporateTravelExpense = (body) =>
    api.post("post.corporate.travel.expense", body);
  const updateCorporateTravelExpense = (body) =>
    api.put("update.corporate.travel.expense", body);
  const deleteCorporateTravelExpense = (body) =>
    api.post("/delete.corporate.travel.expense", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorpTravExpBIDDWeb = (body) =>
    api.post("get.all.corporate.travel.expense.bidd.web", body);
  const postCorpTravExpBIDD = (body) =>
    api.post("post.corporate.travel.expense.bidd", body);
  const updateCorpTravExpBIDD = (body) =>
    api.put("update.corporate.travel.expense.bidd", body);
  const deleteCorpTravExpBIDD = (body) =>
    api.post("delete.corporate.travel.expense.bidd", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorporateDetaseringByEs = (body) =>
    api.get("get.corporate.detasering.by.esid/" + body);
  const getCorporateDsWeb = (body) =>
    api.post("get.all.corporate.detasering.web", body);
  const postCorporateDetasering = (body) =>
    api.post("post.corporate.detasering", body);
  const updateCorporateDetasering = (body) =>
    api.put("update.corporate.detasering", body);
  const deleteCorporateDetasering = (body) =>
    api.post("/delete.corporate.detasering", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorpDsBIDDWeb = (body) =>
    api.post("get.all.corporate.detaseringBIDD.web", body);
  const postCorpDsBIDDWeb = (body) =>
    api.post("post.corporate.detaseringBIDD", body);
  const updateCorpDsBIDDWeb = (body) =>
    api.put("update.corporate.detaseringBIDD", body);
  const deleteCorpDsBIDDWeb = (body) =>
    api.post("/delete.corporate.detaseringBIDD", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllPayrollTpl = (body) =>
    api.post("get.all.corporate.payroll.tpl", body);
  const getPayrollWeb = (body) =>
    api.post("get.all.config.corporate.payroll.web", body);
  const getAllPayroll = (body) =>
    api.post("get.corporate.payroll.tpl.by.status", body);
  const getPayrollByID = (body) =>
    api.get("get.corporate.payroll.tpl.by.id/" + body);
  const getAllCoaCategory = (body) => api.post("get.all.coa.category", body);
  const getCountAllCoaCategory = () => api.get("get.count.all.coa.category");
  const postPayroll = (body) => api.post("post.corporate.payroll.tpl", body);
  const updatePayroll = (body) => api.put("update.corporate.payroll.tpl", body);
  const deletePayroll = (body) =>
    api.post("delete.corporate.payroll.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllOrg = (body) =>
    api.post("get.corporate.orgstructure.tpl.by.status", body);
  const getDropdownOrgParent = (body) =>
    api.post("get.corporate.orgstructure.tpl.flat.by.id.paging.dropdown", body);
  const getOrg = (body) =>
    api.post("get.corporate.orgstructure.tpl.header.by.status", body);
  const getAllOrgTpl = (body) => api.post("get.all.orgstructure.tpl", body);
  const postOrg = (body) => api.post("post.orgstructure.tpl", body);
  const updateOrg = (body) =>
    api.put("update.corporate.orgstructure.tpl", body);
  const deleteOrg = (body) =>
    api.post("delete.corporate.orgstructure.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postPhotoPayroll = (body) =>
    api.post("api/corporate.payroll.tpl.photo.post", body);
  const postPhotoOrg = (body) =>
    api.post("api/corporate.orgstructure.tpl.photo.post", body);
  const getCorporateLeaveTypeByEsid = (body) =>
    api.post("get.corporate.leave.type.by.esid", body);
  const getCountCorporateLeaveTypeByEsid = (body) =>
    api.get("get.count.corporate.leave.type.by.esid/" + body);
  const getCorporateLeavePlafonByEsid = (body) =>
    api.post("get.corporate.leave.plafon.by.esid", body);
  const postCorporateLeaveType = (body) =>
    api.post("post.corporate.leave.type", body);
  const updateCorporateLeaveType = (body) =>
    api.put("update.corporate.leave.type", body);
  const deleteCorporateLeaveType = (body) =>
    api.post("delete.corporate.leave.type", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postCorporateLeavePlafon = (body) =>
    api.post("post.corporate.leave.plafon", body);
  const updateCorporateLeavePlafon = (body) =>
    api.put("update.corporate.leave.plafon", body);
  const deleteCorporateLeavePlafon = (body) =>
    api.post("delete.corporate.leave.plafon", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getParentOrgStruct = (body) =>
    api.get("get.corporate.orgstructure.tpl.flat.by.id/" + body);
  const getCorporateOrgStructByIdPaging = (body) =>
    api.post("get.corporate.orgstructure.tpl.flat.by.id.paging", body);
  const getCountCorporateOrgStruct = (body) =>
    api.get("get.count.corporate.orgstructure.tpl.flat/" + body);
  const getCorporateOrgStructByPost = (body) =>
    api.post("/get.corporate.orgstructure.tpl.flat.by.id.paging.filter", body);
  const getAllCorpPresencePointWeb = (body) =>
    api.post("/get.all.config.presence.point.web", body);
  const getCorporatePresenceByStatus = (body) =>
    api.post("get.corporate.presence.point.by.status", body);
  const getCorporatePresenceWeb = (body) =>
    api.post("get.all.config.presence.point.web", body);
  const getCountCorpPresenceByStatus = (body) =>
    api.get("get.count.corporate.presence.point.by.status/" + body);
  const getAllCorporatePresence = (body) =>
    api.post("get.all.corporate.presence.point", body);
  const postCorporatePresence = (body) =>
    api.post("post.corporate.presence.point", body);
  const updateCorporatePresence = (body) =>
    api.put("update.corporate.presence.point", body);
  const deleteCorporatePresence = (body) =>
    api.post("delete.corporate.presence.point", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorporateOrgStructureTplById = (body) =>
    api.get("/get.corporate.orgstructure.tpl.by.id/" + body);
  const getVisualCorporateOrgStructureTplById = (body) =>
    api.get("/get.corporate.orgstructure.detail.visualization/" + body);
  const getCorporateCnbTplByEsId = (body) =>
    api.post("get.corporate.cnb.tpl.by.es.id", body);
  const getCountCorporateCnbTplByEsId = (body) =>
    api.get("get.count.corporate.cnb.tpl.by.es.id/" + body);
  const postCorporateCnbTpl = (body) =>
    api.post("post.corporate.cnb.tpl", body);
  const updateCorporateCnbTpl = (body) =>
    api.put("update.corporate.cnb.tpl", body);
  const deleteCorporateCnbTpl = (body) =>
    api.post("delete.corporate.cnb.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postPhotoCorporateCnb = (body) =>
    api.post("api/corporate.cnb.tpl.photo.post", body);
  const getCorporateFacilityTplByEsId = (body) =>
    api.post("get.corporate.facility.tpl.by.esid", body);
  const getCountCorporateFacilityTplByEsId = (body) =>
    api.get("get.count.corporate.facility.tpl.by.esid/" + body);
  const postCorporateFacilityTpl = (body) =>
    api.post("post.corporate.facility.tpl", body);
  const updateCorporateFacilityTpl = (body) =>
    api.put("update.corporate.facility.tpl", body);
  const deleteCorporateFacilityTpl = (body) =>
    api.post("delete.corporate.facility.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postPhotoCorporateFacilityTpl = (body) =>
    api.post("api/corporate.facility.tpl.photo.post", body);

  const getCorporateOvertimeByEsId = (body) =>
    api.post("/get.corporate.overtime.type.by.esid", body);
  const getCorporateOvertimeWeb = (body) =>
    api.post("/get.all.config.overtime.type.web", body);
  const getCountCorporateOvertimeByEsId = (body) =>
    api.get("/get.count.corporate.overtime.type.by.esid/" + body);
  const postCorporateOvertimeType = (body) =>
    api.post("post.corporate.overtime.type", body);
  const updateCorporateOvertimeType = (body) =>
    api.put("update.corporate.overtime.type", body);
  const deleteCorporateOvertimeType = (body) =>
    api.post("delete.corporate.overtime.type", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllLoanRule = (body) => api.post("/get.all.loan.rule", body);
  const getLoanRuleByStatus = (body) =>
    api.post("/get.loan.rule.by.status", body);
  const getCountLoanRuleByStatus = (body) =>
    api.get("get.count.loan.rule.by.status/" + body);
  const getLoanRuleDummy = (body) => api.get("/get.loan.rule.dummy", body);
  const postLoanRule = (body) => api.post("/post.loan.rule", body);
  const updateLoanRule = (body) => api.put("/update.loan.rule", body);
  const deleteLoanRule = (body) =>
    api.post("/delete.loan.rule", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadDocLoan = (body) => api.post("/upload.document.loan", body);
  const uploadDocLoanFinalOffering = (body) =>
    api.post("/upload.document.loan.final.offering", body);
  const getAllFacility = (body) =>
    api.post("/get.all.corporate.facility.tpl", body);
  const getAllCNB = (body) => api.post("/get.all.corporate.cnb.tpl", body);
  const getFacilityByStatus = (body) =>
    api.post("/get.corporate.facility.tpl.by.status", body);
  const getGradeByPosition = (body) =>
    api.get(
      "/get.corporate.orgstructure.grade/" + body.strID + "/" + body.ouID
    );
  const getCNBbyStatus = (body) =>
    api.post("/get.corporate.cnb.tpl.by.status", body);
  const getCNBbyID = (body) => api.get("/get.corporate.cnb.tpl.by.id/" + body);
  const getFacilityByID = (body) =>
    api.get("/get.corporate.facility.tpl.by.id/" + body);

  const getGovernmentByStatus = (body) =>
    api.post("/get.government.policy.by.status", body);
  const getGovernmentWeb = (body) =>
    api.post("/get.all.config.government.policy.web", body);
  const getAllGovernment = (body) =>
    api.post("/get.all.government.policy", body);
  const postGovernment = (body) => api.post("post.government.policy", body);
  const updateGovernment = (body) => api.put("update.government.policy", body);
  const deleteGovernment = (body) =>
    api.post("delete.government.policy", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getCorGlobalByStatus = (body) =>
    api.post("/get.corporate.global.policy.by.status", body);
  const getAllCorGlobalPolicy = (body) =>
    api.post("/get.all.corporate.global.policy", body);
  const getGlobalPolicyByEs = (body) =>
    api.post("get.corporate.global.policy.by.esid", body);
  const getGlobalPolicyWeb = (body) =>
    api.post("get.all.config.global.policy.web", body);
  const getGlobalPolicyType = (body) =>
    api.post("get.corporate.global.policy.by.type", body);
  const getCountGlobalPolicyByEs = (body) =>
    api.get("get.count.corporate.global.policy.by.esid/" + body);
  const postCorGlobal = (body) =>
    api.post("post.corporate.global.policy", body);
  const updateCorGlobal = (body) =>
    api.put("update.corporate.global.policy", body);
  const deleteCorGlobal = (body) =>
    api.post("delete.corporate.global.policy", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getGroupProc = (body) =>
    api.post("/get.all.corporate.payroll.group.processing.tpl.paging", body);
  const getGroupProcWeb = (body) =>
    api.post("/get.all.config.group.processing.web", body);
  const getGroupProcByEmpID = (body) =>
    api.post(
      "/get.all.corporate.payroll.group.processing.tpl.by.employeeid",
      body
    );
  const getCountGroupProc = () =>
    api.get("/get.count.all.corporate.payroll.group.processing.tpl/");
  const postGroupProc = (body) =>
    api.post("post.corporate.payroll.group.processing.tpl", body);
  const updateGroupProc = (body) =>
    api.put("update.corporate.payroll.group.processing.tpl", body);
  const updateGroupProcMove = (body) =>
    api.put(
      "update.corporate.payroll.group.processing.tpl.move.employee",
      body
    );
  const deleteGroupProc = (body) =>
    api.post("delete.corporate.payroll.group.processing.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getCountCorpOSbyStatus = (body) =>
    api.get("get.count.corporate.orgstructure.tpl.by.status/" + body);
  const getCorpOrgbyName = (body) =>
    api.post("get.corporate.orgstructure.tpl.by.name", body);
  const getCountOrgbyStatusAndName = (body) =>
    api.get("get.count.corporate.orgstructure.tpl.by.status.and.name/" + body);
  const getAllComponentAllowance = (body) =>
    api.post("get.all.cnb.component.allowance", body);
  const getAllComponentAllowanceByStatus = (body) =>
    api.post("get.cnb.component.allowance.by.status", body);
  const getCountAllComponentAllowance = () =>
    api.get("get.count.all.cnb.component.allowance");
  const postComponentAllowance = (body) =>
    api.post("post.cnb.component.allowance", body);
  const getComponentAllowanceWeb = (body) =>
    api.post("get.cnb.component.allowance.web", body);
  const getComponentAllowanceByName = (body) =>
    api.post("get.cnb.component.allowance.by.name", body);
  const getCountComponentAllowanceByStatus = (body) =>
    api.get("get.count.cnb.component.allowance.status/" + body);
  const getCountComponentAllowanceByName = (body) =>
    api.get("get.count.cnb.component.allowance.by.name/" + body);
  const getAllCnBComponentAllowance = () =>
    api.get("get.all.cnb.component.allowance.type");
  const putComponentAllowance = (body) =>
    api.put("update.cnb.component.allowance", body);
  const deleteComponentAllowance = (body) =>
    api.post("delete.cnb.component.allowance", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCorpBankTrf = (body) =>
    api.post("get.corporate.split.bank.transfer.web", body);
  const putCorpBankTrf = (body) =>
    api.put("update.corporate.split.bank.transfer", body);
  const postCorpBankTrf = (body) =>
    api.post("post.corporate.split.bank.transfer", body);
  const deleteCorpBankTrf = (body) =>
    api.post("delete.corporate.split.bank.transfer", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllPaymentGroup = () =>
    api.get("get.all.corporate.payroll.group.processing.tpl.dropdown");
  const getAllPaymentGroupFilter = (body) =>
    api.post(
      "/get.all.corporate.payroll.group.processing.tpl.by.createdby",
      body
    );
  const getAllBPRole = (body) =>
    api.post("query/get.all.batch.payroll.role.employeeid", body);
  const getAllPaymentGroupCreatedByRole = (body) =>
    api.post(
      "/get.all.corporate.payroll.group.processing.tpl.by.createdby.role",
      body
    );
  const getCountAllPaymentGroup = () =>
    api.get("get.count.all.corporate.payroll.group.processing.tpl");
  const getPaymentByID = (body) =>
    api.get("get.corporate.payroll.group.processing.tpl.by.id/" + body);
  const getAllPaymentType = () => api.get("/get.all.payroll.type");

  // LOAN
  const getAllLoan = (body) => api.post("/get.all.loan", body);
  const postLoan = (data) => api.post("/command/post.loan", data);
  const putLoan = (body) => api.put("/command/put.loan", body);
  const putLoanComplete = (body) => api.put("/command/put.loan.close", body);
  const deleteLoan = (body) =>
    api.post("/delete.loan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitLoan = (data) => api.post("/submit.loan", data);
  const getAllLoanStatistic = (body) =>
    api.post("/get.all.loan.statistic", body);
  const getAllLoanStatisticByEmpid = (body) =>
    api.get("/get.loan.statistic.by.empid/" + body);
  const getLoanInstallment = (body) =>
    api.post("/get.all.loan.event.history", body);

  const getAllVendorByStatus = (body) =>
    api.post("/get.vendor.outsource.by.status", body);
  const postVendor = (body) => api.post("/post.vendor.outsource", body);
  const putVendor = (body) => api.put("/update.vendor.outsource", body);
  const deleteVendor = (body) =>
    api.post("delete.vendor.outsource", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postCountry = (body) => api.post("/post.country", body);
  const updateCountry = (body) => api.put("/update.country", body);
  const deleteCountry = (body) =>
    api.post("/delete.country", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getCountryMasterByCountryStatus = (body) =>
    api.post("/get.countrymaster.by.countrystatus", body);
  const getInstituteByStatus = (body) =>
    api.post("/get.institute.by.status", body);
  const postInstitute = (body) => api.post("/post.institute", body);
  const updateInstitute = (body) => api.put("/update.institute", body);
  const deleteInstitute = (body) =>
    api.post("/delete.institute", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAddressByRefObjectID = (body) =>
    api.post("/get.address.by.refobjectid", body);
  const getCountAddressByRefObjectID = (body) =>
    api.get("/get.count.address.by.refobjectid/" + body);
  const getProvinceByStatus = (body) =>
    api.post("/get.province.by.status", body);
  const getProvinceByCountryID = (body) =>
    api.get("/get.province.by.countryid/" + body);
  const getKabKotByProvinceID = (body) =>
    api.get("/get.kabupatenkota.by.provinceid/" + body);
  const getKabKotByCountryID = (body) =>
    api.get("/get.kabkot.by.countryid/" + body);
  const getKecamatanByKabKotID = (body) =>
    api.get("/get.kecamatan.by.kabkotid/" + body);
  const getKelurahanByKecID = (body) =>
    api.get("/get.kelurahan.by.kecamatanid/" + body);
  const postAddress = (body) => api.post("/post.address", body);
  const deleteAddress = (body) =>
    api.post("/delete.address", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const updateAddress = (body) => api.put("/update.address", body);
  const getEducationByStatus = (body) =>
    api.post("/get.education.configuration.by.status", body);
  const getEducationByEduID = (body) =>
    api.get("/get.education.configuration.by.id/" + body);
  const getInstituteByTypeAndLevel = (body) =>
    api.post("/get.institute.by.education.configuration.type.and.level", body);
  const getDepartmentByTypeAndLevel = (body) =>
    api.post(
      "/get.departement.by.education.configuration.type.and.level",
      body
    );
  const postEducation = (body) =>
    api.post("/post.education.configuration", body);
  const getAddressByStatus = (body) => api.post("/get.address.by.status", body);
  const updateEducation = (body) =>
    api.put("/update.education.configuration", body);
  const deleteEducation = (body) =>
    api.post("/delete.education.configuration", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getConstanta = (body) => api.post("get.all.cnb.offcietype", body);
  const getConstantaByStatus = (body) =>
    api.post("get.cnb.registry.by.status", body);
  const getRegistryWeb = (body) =>
    api.post("get.cnb.registry.by.status.web", body);
  const getRegistryByID = (body) =>
    api.get(
      "get.cnb.registry.by.gradeid.regionid.typeid/" +
        body.gradeID +
        "/" +
        body.esID +
        "/" +
        body.typeID
    );
  const postConstanta = (body) => api.post("post.cnb.officetype", body);
  const updateConstanta = (body) => api.put("update.cnb.officetype", body);
  const deleteConstanta = (body) =>
    api.post("/delete.cnb.officetype", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postProvince = (body) => api.post("/post.province", body);
  const updateProvince = (body) => api.put("/update.province", body);
  const getProvince = (body) => api.get("/get.province.by.countryid/" + body);
  const getKabkotByStatus = (body) =>
    api.post("/get.kabupatenkota.by.status", body);
  const getCountKabkotByStatus = (body) =>
    api.get("/get.count.kabupatenkota.by.status/" + body);
  const postKabupatenkota = (body) => api.post("/post.kabupatenkota", body);
  const updateKabupatenkota = (body) => api.put("/update.kabupatenkota", body);
  const postKecamatan = (body) => api.post("/post.kecamatan", body);
  const updateKecamatan = (body) => api.put("/update.kecamatan", body);
  const postKelurahan = (body) => api.post("/post.kelurahan", body);
  const updateKelurahan = (body) => api.put("/update.kelurahan", body);
  const deleteProvince = (body) =>
    api.post("/delete.province", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteKabupatenkota = (body) =>
    api.post("/delete.kabupatenkota", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteKecamatan = (body) =>
    api.post("/delete.kecamatan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteKelurahan = (body) =>
    api.post("/delete.kelurahan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllBank = (body) => api.post("/get.all.bank", body);
  const getCountAllBank = () => api.get("/get.all.count.bank");
  const postBank = (body) => api.post("/post.bank", body);
  const putBank = (body) => api.put("/update.bank", body);
  const deleteBank = (body) =>
    api.post("/delete.bank", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getCountryByIDCountry = (body) => api.get("/get.country.by.id/" + body);
  const getProvinceByIDProvince = (body) =>
    api.get("/get.province.by.id/" + body);
  const getKabKotByIDKabKot = (body) =>
    api.get("/get.kabupatenkota.by.id/" + body);

  // ES
  const getDirByEsid = (body) =>
    api.get(
      "/get.position.directorate.by.esid/" + body.company + "/" + body.position
    );
  const getParentByEsID = (body, ouid) =>
    api.get("/get.parent.by.ouid/" + body + "/" + ouid);
  const getPosistion = () => api.get("/get.tpljson/es-001");
  const getPostByLvlEs = (esid, lvl) =>
    api.get("get.position.in.perent.by.esid.position.id/" + esid + "/" + lvl);
  const getCorporateOrgStructDetail = (body) => api.get("/get.tpljson/" + body);
  const getCompanyAll = (body) => api.post("/get.es.all", body);
  const getCountCorporatebyName = (body) =>
    api.get("/get.count.es.by.esname/" + body);
  const deleteCompany = (body) =>
    api.post("/delete.es", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const postCompGeneral = (body) => api.post("/post.es", body);
  const updateCompGeneral = (body) => api.put("/update.es", body);
  const uploadCompanyDoc = (body, config) =>
    api.post("/api/org.legal.document.post", body, config);
  const getEsByOuid = (body) =>
    api.get("/get.es.by.ouid/" + body.esid + "/" + body.ouid);
  const getEsByLevel = (body) => api.post("get.es.by.esid.level", body);
  const getEsByStatus = (body) => api.post("get.es.by.status", body);
  const getEsById = (body) => api.get("/get.es.by.id/" + body);
  const getEsEMP = (body) => api.get("/get.es.with.employee.by.esid/" + body);
  const getEsByName = (body) => api.post("/get.es.all.by.name", body);
  const getEsByNameGrid = (body) => api.post("/get.es.all.by.name.grid", body);
  const getCompanyByStatus = (body) => api.post("/get.es.by.status", body);
  const getCountCompanyByStatus = (body) =>
    api.get("/get.count.es.by.status/" + body);
  const updateBankAccount = (body) => api.post("/update.bank.account", body);

  const getCorporateLeavePlafonByStatus = (body) =>
    api.post("/get.corporate.leave.plafon.by.status", body);
  const getCorporateLeavePlafonByESID = (body) =>
    api.post("/get.corporate.leave.plafon.by.esid", body);
  const getAllCorporateLeavePlafon = (body) =>
    api.post("/get.all.corporate.leave.plafon", body);
  const postBankCorporate = (body) => api.post("/post.bank.account", body);
  const putBankCorporate = (body) => api.put("/update.bank.account", body);
  const getBankCorporateById = (body) =>
    api.get("/get.all.bank.account/" + body);
  const deleteBankCorp = (body) => api.delete("delete.bank.account/" + body);
  const getTplById = (body) => api.get("/get.es.template.by.id/" + body);
  const getTPlDemosi = (body) =>
    api.get(
      "get.corporate.orgstructure.tpl.flat.demosi/" +
        body.strID +
        "/" +
        body.positionID
    );
  const getTPlPromosi = (body) =>
    api.get(
      "get.corporate.orgstructure.tpl.flat.promosi/" +
        body.strID +
        "/" +
        body.positionID
    );
  const getTPlRotasi = (body) =>
    api.get(
      "get.corporate.orgstructure.tpl.flat.rotasi/" +
        body.strID +
        "/" +
        body.positionID
    );

  // RECRUITMENT
  const getRecReqById = (body) =>
    api.get("/query/get.recruitment.request.by.id/" + body);
  const putRecReq = (body) => api.put("/command/put.recruitment.request", body);
  const putRecReqPos = (body) =>
    api.put("/command/put.recruitment.request.position", body);
  const putRecReqQua = (body) =>
    api.put("/command/put.recruitment.request.qualification", body);
  const putRecReqDoc = (body) =>
    api.put("command/put.recruitment.request.document", body);
  const putRecReqSel = (body) =>
    api.put("command/put.recruitment.request.selection", body);
  const putRecReqOth = (body) =>
    api.put("command/put.recruitment.request.other.clauses", body);
  const postRecReq = (body) =>
    api.post("/command/post.recruitment.request", body);
  const deleteRecReq = (body) =>
    api.post("/delete.recruitment.request", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getRecruitmentWeb = (body) =>
    api.post("/query/get.all.recruitment.request.web", body);
  const getRecruitmentReqAll = (body) =>
    api.post("/query/get.all.recruitment.request", body);
  const getRecruitmentReqAllFinal = (body) =>
    api.post("query/get.all.recruitment.request.final.approve.web", body);
  const getRecReqVac = (body) =>
    api.post("/query/get.all.recruitment.request.vacancy.all.web.new", body);
  const getCountRecruitmentReqAll = () =>
    api.get("/query/get.count.all.recruitment.request");
  const getRecruitmentReqBy = (body) =>
    api.post("/query/get.recruitment.request.by.recruitment.request.by", body);
  const getRecruitmentReqByName = (body) =>
    api.post("/query/get.recruitment.request.by.requestor.name", body);
  const getCountRecruitmentReqBy = (body) =>
    api.get(
      "query/get.count.recruitment.request.by.recruitment.request.by/" + body
    );
  const getCountRecruitmentReqByName = (body) =>
    api.get("query/get.count.recruitment.request.by.requestor.name/" + body);
  const updateApplicantWorkExperience = (body) =>
    api.put("/command/put.applicant.work.experience", body);
  const updateMedicalCheckup = (body) =>
    api.put("command/put.applicant.medical.check.up", body);
  const getApplicantAll = (body) => api.post("/query/get.all.applicant", body);
  const postApplicant = (body) => api.post("/command/post.applicant", body);
  const updateApplicant = (body) => api.put("/command/put.applicant", body);
  const deleteApplicant = (body) =>
    api.post("/delete.applicant", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const applicantPhotoPost = (body) =>
    api.post("/api/applicant.photo.post", body);
  const updateApplicantEmergencyContact = (body) =>
    api.put("/command/put.applicant.emergency.contact", body);
  const updateApplicantOrgExp = (body) =>
    api.put("/command/put.applicant.organization.experience", body);
  const createAndUpdate = (body) =>
    api.put("command/put.applicant.family", body);
  const updateApplicantSocialMedia = (body) =>
    api.put("/command/put.applicant.social.media", body);
  const updateApplicantDocument = (body) =>
    api.put("/command/put.applicant.document", body);
  const updateApplicantFileDocument = (body, config) =>
    api.post("/api/applicant.document.post", body, config);
  const updateApplicantFormalEducation = (body) =>
    api.put("/command/put.applicant.formal.education", body);
  const updateApplicantInformalEducation = (body) =>
    api.put("/command/put.applicant.informal.education", body);
  const updateApplicantReference = (body) =>
    api.put("/command/put.applicant.reference", body);
  const updateApplicantWeekness = (body) =>
    api.put("/command/put.applicant.weakness", body);
  const updateApplicantAbility = (body) =>
    api.put("/command/put.applicant.special.ability", body);
  const updateApplicantLanguageSkill = (body) =>
    api.put("/command/put.applicant.language.skill", body);
  const getAllRecruitmentVacancy = (body) =>
    api.post("query/get.all.recruitment.vacancy", body);
  const getNewAllRecruitmentVacancy = (body) =>
    api.post("query/get.all.vacancy.web", body);

  const getNewAllRecVacancy = (body) =>
    api.post("query/get.all.vacancy.web.new", body);
  const getNewCountAllRecVacancy = () => api.get("query/get.count.all.vacancy");
  const getVacByID = (body) => api.get("query/get.vacancy.by.id/" + body);
  const postVacancy = (body) => api.post("command/post.vacancy", body);
  const updateVacancy = (body) => api.put("command/put.vacancy", body);
  const deleteVacancy = (body) =>
    api.post("/delete.vacancy", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getCountRecruitmentVacancy = () =>
    api.get("query/get.count.job.vacancy");
  const getRecVacancyByPosition = (body) =>
    api.post("query/get.job.vacancy.by.position.name", body);
  const getCountRecVacancyByPosition = (body) =>
    api.get("query/get.count.job.vacancy.by.position.name/" + body);
  const postJobVacany = (body) => api.post("command/post.job.vacancy", body);
  const getRecruitmentPsikotestByAppNumber = (body) =>
    api.post("query/get.recruitment.psikotest.by.applicant.number", body);
  const getCountRecruitmentPsikotestByAppNumber = (body) =>
    api.get(
      "query/get.count.recruitment.psikotest.by.applicant.number/" + body
    );
  const postDocumentPsikotest = (body, config) =>
    api.post("api/recruiment.psikotest.document.post", body, config);
  const getRecPsikotestById = (body) =>
    api.get("query/get.recruitment.psikotest.by.id/" + body);
  const getRecInterviewByInterviewId = (body) =>
    api.get("query/get.recruitment.interview.by.interview.id/" + body);
  const getApplicantByName = (body) =>
    api.post("query/get.applicant.by.name", body);
  const getNewApplicant = (body) =>
    api.post("query/get.all.applicant.web", body);
  const getNewCandidate = (body) =>
    api.post("query/get.all.candidate.web", body);
  const getCountApplicantName = (body) =>
    api.get("query/get.count.applicant.by.name/" + body);
  const getCountApplicant = () => api.get("query/get.count.all.applicant");
  const getApplicantById = (body) =>
    api.get("query/get.applicant.by.id/" + body);
  const putRequestMethodology = (body) =>
    api.put("/command/put.recruitment.request.methodology.id", body);

  const getKPKByID = (body) =>
    api.get("/query/get.recruitment.kpk.by.id/" + body);
  const putPKWTNumber = (body) =>
    api.put("/command/put.recruitment.kpk.pkwt.number/", body);

  // TIME & MANAGEMENT
  const getAllLeave = (body) => api.post("/query/get.all.leave", body);
  const getNewAllLeave = (body) =>
    api.post("/query/get.all.leave.web.personnel", body);
  const getCountAllLeave = () => api.get("/query/get.all.count.leave");
  const getLeaveByEmpName = (body) =>
    api.post("/query/get.all.leave.by.employee.name", body);
  const getCountLeaveByEmpName = (body) =>
    api.get("/query/get.all.count.leave.by.employee.name/" + body);

  const getAllSppd = (body) => api.post("/query/get.all.sppd", body);
  const getNewAllSppd = (body) =>
    api.post("/query/get.all.sppd.web.personnel", body);
  const getDetaseringPersonal = (body) =>
    api.post("query/get.all.detasering.web.personnel", body);
  const getSppdRes = (body) =>
    api.post("/query/get.sppd.responsibility.by.sppd.id", body);
  const getCountSppdRes = (body) =>
    api.get("/query/get.all.count.sppd.responsibility.by.sppd.id/" + body);

  const getAllOvertime = (body) => api.post("/query/get.all.overtime", body);
  const getNewAllOvertime = (body) =>
    api.post("/query/get.all.overtime.web.personnel", body);
  const getCountAllOvertime = () => api.get("/query/get.all.count.overtime");
  const getOvertimeByEmp = (body) =>
    api.post("/query/get.all.overtime.by.employee.name", body);
  const getCountOvertimeByEmp = (body) =>
    api.get("/query/get.all.count.overtime.by.employee.name/" + body);

  const getAllTimesheet = (body) => api.post("/query/get.all.timesheet", body);
  const getNewAllTimesheet = (body) =>
    api.post("/query/get.all.timesheet.web.personnel", body);
  const getCountAllTimesheet = () => api.get("/query/get.all.count.timesheet");
  const getAllTSByEMP = (body) =>
    api.post("/query/get.all.timesheet.by.employee.name", body);
  const getCountAllTSByEMP = (body) =>
    api.get("/query/get.all.count.timesheet.by.employee.name/" + body);

  const getTimesheetByID = (body) =>
    api.get("/query/get.timesheet.by.id/" + body);
  const getAllTimeSheetTask = (body) =>
    api.post("query/get.all.timesheet.task", body);
  const getTimesheetTaskById = (body) =>
    api.post("query/get.timesheet.task.by.employee.id", body);
  const getTimesheetTaskByIdDate = (body) =>
    api.post("query/get.timesheet.task.by.employee.id.and.date", body);
  const getCountTimesheetTaskByIdDate = (body) =>
    api.get(
      "query/get.all.count.timesheet.task.by.employee.id.and.date/" + body
    );

  const getTplJson = (body) => api.get("/get.tpljson/" + body);
  const getMppByPosition = (body) => api.post("/get.mpp.by.position", body);
  const getSearchMPP = (body) =>
    api.post(
      "/get.mpp.position.by.company.id.and.mpp.status.and.mpp.state",
      body
    );

  const postSppdResponsibility = (body) =>
    api.post("command/post.sppd.responsibility", body);
  const updateSppdResponsibility = (body) =>
    api.put("command/put.sppd.responsibility", body);
  const getSppdResponsibilityByID = (body) =>
    api.get("query/get.sppd.responsibility.by.id/" + body);

  const submitSPPDBIDD = (body) => api.post("/submit.sppd.bidd", body);
  const submitSPPDBIDDKKSOKL = (body) =>
    api.post("/submit.approval.sppd.bidd.kk.sokl", body);
  const submitSPPDBIDDKCPSOKL = (body) =>
    api.post("/submit.approval.sppd.bidd.kcp.sokl", body);
  const submitSPPDBIDDKCPEO = (body) =>
    api.post("/submit.approval.sppd.bidd.kcp.eo", body);
  const submitSPPDBIDDKCISOKL = (body) =>
    api.post("/submit.approval.sppd.bidd.kci.sokl", body);
  const submitSPPDBIDDKCIEO = (body) =>
    api.post("/submit.approval.sppd.bidd.kci.eo", body);
  const submitSPPDBIDDKPOSOKL = (body) =>
    api.post("/submit.approval.sppd.bidd.kpo.sokl", body);
  const submitSPPDBIDDKPOEO = (body) =>
    api.post("/submit.approval.sppd.bidd.kpo.eo", body);
  const submitSPPDBIDDKPNOEO = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.eo", body);
  const submitSPPDBIDDKPNODD = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.dd", body);
  const submitSPPDBIDDKPNOSTFPEMBUKUAN = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.stfpembuk", body);
  const submitSPPDBIDDKPNORESDIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.presdir", body);
  const submitSPPDBIDDKPNODEPPRESDIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.deputy.presdir", body);
  const submitSPPDBIDDKPNOASSDIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.assdir", body);
  const submitSPPDBIDDKPNODIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.dir", body);
  const submitSPPDBIDDKPNOASSDIRDIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.assdirdir", body);
  const submitSPPDBIDDKPNOEOPAYROLL = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.eopy", body);
  const submitSPPDBIDDKPNOBIRODIR = (body) =>
    api.post("/submit.approval.sppd.bidd.kpno.biro.direksi", body);
  const submitSPPDSET = (body) => api.post("/submit.sppd.settlement", body);
  const submitSPPDSETKKSOKL = (body) =>
    api.post("/submit.approval.sppd.settlement.kk.sokl", body);
  const submitSPPDSETKCPSOKL = (body) =>
    api.post("/submit.approval.sppd.settlement.kcp.sokl", body);
  const submitSPPDSETKCPEO = (body) =>
    api.post("/submit.approval.sppd.settlement.kcp.eo", body);
  const submitSPPDSETKCISOKL = (body) =>
    api.post("/submit.approval.sppd.settlement.kci.sokl", body);
  const submitSPPDSETKCIEO = (body) =>
    api.post("/submit.approval.sppd.settlement.kci.eo", body);
  const submitSPPDSETKPOSOKL = (body) =>
    api.post("/submit.approval.sppd.settlement.kpo.sokl", body);
  const submitSPPDSETKPOEO = (body) =>
    api.post("/submit.approval.sppd.settlement.kpo.eo", body);
  const submitSPPDSETKPNOEO = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.eo", body);
  const submitSPPDSETKPNODD = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.dd", body);
  const submitSPPDSETKPNOSTFPEMBUKUAN = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.stfpembuk", body);
  const submitSPPDSETKPNORESDIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.presdir", body);
  const submitSPPDSETKPNODEPPRESDIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.deputy.presdir", body);
  const submitSPPDSETKPNOASSDIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.assdir", body);
  const submitSPPDSETKPNODIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.dir", body);
  const submitSPPDSETKPNOASSDIRDIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.assdirdir", body);
  const submitSPPDSETKPNOEOPAYROLL = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.eopy", body);
  const submitSPPDSETKPNOBIRODIR = (body) =>
    api.post("/submit.approval.sppd.settlement.kpno.biro.direksi", body);

  const submitSPPDApproval = (body) =>
    api.post("/submit.business.trip.approval.level1", body);
  const submitSPPDApprovalLvl2 = (body) =>
    api.post("/submit.business.trip.approval.level2", body);
  const submitSPPDApprovalLvl3 = (body) =>
    api.post("/submit.business.trip.approval.level3", body);
  const submitSPPDApprovalLvl4 = (body) =>
    api.post("/submit.business.trip.approval.level4", body);
  const submitSPPDSetApproval = (body) =>
    api.post("/submit.business.trip.responsibility.level1.approval", body);
  const submitSPPDSetApprovalLvl2 = (body) =>
    api.post("/submit.business.trip.responsibility.level2.approval", body);
  const submitTrainingApproval = (body) =>
    api.post("/submit.training.approval", body);
  const submitBlacklist = (body) => api.post("submit.blacklist", body);
  const submitBlacklistAppEmp = (body) =>
    api.post("/submit.blacklist.approval.employee", body);
  const submitBlacklistAppDD = (body) =>
    api.post("/submit.blacklist.approval.deputy.directorate", body);
  const submitBlacklistAppDDSDM = (body) =>
    api.post("/submit.blacklist.approval.deputy.directorate.sdm", body);
  const submitBlacklistDocUpload = (body) =>
    api.post("/submit.blacklist.document.upload", body);
  const submitTraining = (body) => api.post("/submit.training", body);
  const submitTimesheet = (body) => api.post("/submit.absence", body);
  const submitClaim = (body) => api.post("submit.claim", body);
  const submitClaimApproval = (body) => api.post("submit.claim.approval", body);
  const submitLoanApproval = (body) => api.post("submit.loan.approval", body);
  const submitPKWT = (body) => api.post("submit.pkwt", body);
  const submitOfferingLetter = (body) =>
    api.post("submit.offering.letter", body);
  const submitKPKEO = (body) => api.post("submit.kpk.eo.recruitment", body);
  const submitKPKDDSDM = (body) => api.post("submit.kpk.ddsdm", body);
  const submitKPKDIR = (body) => api.post("submit.kpk.dir", body);
  const submitKPKDEPPRESDIR = (body) => api.post("submit.kpk.deppresdir", body);
  const submitKPKPRESDIR = (body) => api.post("submit.kpk.presdir", body);
  const resubmitMovement = (body) => api.post("/resubmit.movement", body);
  const resubmitTermination = (body) => api.post("/resubmit.termination", body);
  const resubmitSPPD = (body) => api.post("/resubmit.business.trip", body);
  const resubmitLeave = (body) => api.post("/resubmit.leave", body);
  const resubmitAbsence = (body) => api.post("/resubmit.absence", body);
  const resubmitTraining = (body) => api.post("/resubmit.training", body);
  const resubmitBlacklist = (body) => api.post("/resubmit.blacklist", body);
  const resubmitOvertime = (body) => api.post("/resubmit.overtime", body);
  const submitPayrollBatch = (body) => api.post("submit.payroll.batch", body);
  const resubmitRequest = (body) => api.post("/resubmit.request", body);
  const submitPayrollBatchApproval = (body) =>
    api.post("submit.payroll.batch.approval", body);
  const submitTerminationChecklist = (body) =>
    api.post("submit.termination.checklist", body);
  const resubmitClaim = (body) => api.post("resubmit.claim", body);
  const resubmitMPP = (body) => api.post("/resubmit.mpp", body);
  const submitTrainingBudget = (body) =>
    api.post("submit.training.budget", body);
  const submitTrainingBudgetApproval = (body) =>
    api.post("submit.training.budget.approval", body);
  const resubmitTrainingBudget = (body) =>
    api.post("resubmit.training.budget", body);
  const submitTrainingPlan = (body) => api.post("submit.training.plan", body);
  const submitTrainingPlanApproval = (body) =>
    api.post("submit.training.plan.approval", body);
  const resubmitTrainingPlan = (body) =>
    api.post("resubmit.training.plan", body);
  const ippApproval = (body) => api.post("submit.ipp.approval", body);
  const submitIPP = (body) => api.post("submit.ipp", body);
  const submitTrainingExecution = (body) =>
    api.post("submit.training.execution", body);
  const submitTrainingExecutionApproval = (body) =>
    api.post("submit.training.execution.approval", body);

  const submitClAllowance = (body) =>
    api.post("submit.cnb.claim.allowance", body);
  const submitClAllowanceKPNOEMPHead = (body) =>
    api.post("submit.approval.cnb.claim.allowance.employee.head", body);
  const submitClAllowanceKPNOStfPayroll = (body) =>
    api.post("submit.approval.cnb.claim.allowance.kpno.staff.payroll", body);
  const submitClAllowanceKPNOEOPayroll = (body) =>
    api.post("submit.approval.cnb.claim.allowance.kpno.eo.payroll", body);
  const resubmitClAllowance = (body) =>
    api.post("submit.approval.cnb.claim.allowance.resubmit", body);

  const submitBiodata = (body) => api.post("submit.biodata", body);
  const submitApprovalKKSO = (body) =>
    api.post("bpm.approve.biodata.kk.sokl", body);
  const submitApprovalKCPSO = (body) =>
    api.post("bpm.approve.biodata.kcp.sokl", body);
  const submitApprovalKCPEO = (body) =>
    api.post("bpm.approve.biodata.kcp.eo", body);
  const submitApprovalKCIEO = (body) =>
    api.post("bpm.approve.biodata.kci.eo", body);
  const submitApprovalKCISO = (body) =>
    api.post("bpm.approve.biodata.kci.sokl", body);
  const submitApprovalKPOEO = (body) =>
    api.post("bpm.approve.biodata.kpo.eo", body);
  const submitApprovalKPOSO = (body) =>
    api.post("bpm.approve.biodata.kpo.sokl", body);
  const submitApprovalKPNOSTAFF = (body) =>
    api.post("bpm.approve.biodata.kpno.staff.bpo", body);
  const submitApprovalKPNOEO = (body) =>
    api.post("bpm.approve.biodata.kpno.eo", body);
  const submitApprovalKPNODD = (body) =>
    api.post("bpm.approve.biodata.kpno.dd", body);
  const submitApprovalKPNOASSDIR = (body) =>
    api.post("bpm.approve.biodata.kpno.assdir", body);
  const submitApprovalKPNOPRESDIR = (body) =>
    api.post("bpm.approve.biodata.kpno.presdir", body);

  const submitSKAK = (body) => api.post("submit.skak", body);
  const submitSKAKKKSOKL = (body) =>
    api.post("bpm.approval.skak.kk.sokl", body);
  const submitSKAKKKSDM = (body) => api.post("bpm.approval.skak.kk.sdm", body);
  const submitSKAKKCIEO = (body) => api.post("bpm.approval.skak.kci.eo", body);
  const submitSKAKKCISOKL = (body) =>
    api.post("bpm.approval.skak.kci.sokl", body);
  const submitSKAKKCISDM = (body) =>
    api.post("bpm.approval.skak.kci.sdm", body);
  const submitSKAKKCPEO = (body) => api.post("bpm.approval.skak.kcp.eo", body);
  const submitSKAKKCPSOKL = (body) =>
    api.post("bpm.approval.skak.kcp.sokl", body);
  const submitSKAKKCPSDM = (body) =>
    api.post("bpm.approval.skak.kcp.sdm", body);
  const submitSKAKKPOEO = (body) => api.post("bpm.approval.skak.kpo.eo", body);
  const submitSKAKKPOSOKL = (body) =>
    api.post("bpm.approval.skak.kpo.sokl", body);
  const submitSKAKKPOSDM = (body) =>
    api.post("bpm.approval.skak.kpo.sdm", body);
  const submitSKAKKPNOEO = (body) =>
    api.post("bpm.approval.skak.kpno.eo", body);
  const submitSKAKKPNODD = (body) =>
    api.post("bpm.approval.skak.kpno.dd", body);
  const submitSKAKKPNOSTAFFHI = (body) =>
    api.post("bpm.approval.skak.kpno.stf.hi", body);
  const submitSKAKKPNOASSDIR = (body) =>
    api.post("bpm.approval.skak.kpno.assdir", body);
  const submitSKAKKPNOPRESDIR = (body) =>
    api.post("bpm.approval.skak.kpno.presdir", body);

  const submitFPTK = (body) => api.post("submit.fptk", body);
  const submitFPTKKCISOKL = (body) =>
    api.post("bpm.approve.fptk.kci.sokl", body);
  const submitFPTKKCIEO = (body) => api.post("bpm.approve.fptk.kci.eo", body);
  const submitFPTKKCPEO = (body) => api.post("bpm.approve.fptk.kcp.eo", body);
  const submitFPTKKPNOEO = (body) => api.post("bpm.approve.fptk.kpno.eo", body);
  const submitFPTKKPNODEP = (body) =>
    api.post("bpm.approve.fptk.kpno.depskai", body);
  const submitFPTKKPNODD = (body) => api.post("bpm.approve.fptk.kpno.dd", body);
  const submitFPTKKPNOASSDIR = (body) =>
    api.post("bpm.approve.fptk.kpno.assdir", body);
  const submitFPTKKPNODEPPRESDIR = (body) =>
    api.post("bpm.approve.fptk.kpno.deppresdir", body);
  const submitFPTKKPNOPRESDIR = (body) =>
    api.post("bpm.approve.fptk.kpno.presdir", body);
  const submitFPTKKPNOSTFSDM = (body) =>
    api.post("bpm.approve.fptk.kpno.stfsdm", body);
  const submitFPTKKPNOEODIKLAT = (body) =>
    api.post("bpm.approve.fptk.kpno.eodiklat", body);
  const submitFPTKKPNOEOREC = (body) =>
    api.post("bpm.approve.fptk.kpno.eorec", body);
  const submitFPTKKPNODDSDM = (body) =>
    api.post("bpm.approve.fptk.kpno.ddsdm", body);

  const submitDsMemo = (body) => api.post("submit.detasering.memo", body);
  const submitDsMemoEO = (body) =>
    api.post("submit.approval.detasering.memo.eodiklat", body);
  const submitDsMemoSTFBPO = (body) =>
    api.post("submit.approval.detasering.memo.stfbpo", body);
  const submitDsMemoDDSDM = (body) =>
    api.post("submit.approval.detasering.memo.ddsdm", body);

  const submitDsSTL = (body) => api.post("submit.detasering.settlement", body);
  const submitDsNewSTL = (body) =>
    api.post("submit.detasering.settlement.new", body);

  // new detasering settlement
  const submitDsSTLKKSOKL = (body) =>
    api.post("submit.approval.detasering.settlement.new.kk.sokl", body);
  const submitDsSTLKCPSOKL = (body) =>
    api.post("submit.approval.detasering.settlement.new.kcp.sokl", body);
  const submitDsSTLKCPEO = (body) =>
    api.post("submit.approval.detasering.settlement.new.kcp.eo", body);
  const submitDsSTLKCISOKL = (body) =>
    api.post("submit.approval.detasering.settlement.new.kci.sokl", body);
  const submitDsSTLKCIEO = (body) =>
    api.post("submit.approval.detasering.settlement.new.kci.eo", body);
  const submitDsSTLKPNOEO = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.eo", body);
  const submitDsSTLKPNODD = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.dd", body);
  const submitDsSTLKPNOASSDIRDIR = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.assdirdir", body);
  const submitDsSTLKPNOSTFPEMBUKUAN = (body) =>
    api.post(
      "submit.approval.detasering.settlement.new.kpno.stfpembukuan",
      body
    );
  const submitDsSTLKPNOEOPAYROLL = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.eopayroll", body);
  const submitDsSTLKPNOBIRODIR = (body) =>
    api.post(
      "submit.approval.detasering.settlement.new.kpno.birodireksi",
      body
    );
  const submitDsSTLKPNOASSDIR = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.assdir", body);
  const submitDsSTLKPNODIR = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.dir", body);
  const submitDsSTLKPNOPRESDIR = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.presdir", body);
  const submitDsSTLKPNODEPUTYPRESDIR = (body) =>
    api.post("submit.approval.detasering.settlement.new.kpno.deppresdir", body);

  const submitDs = (body) => api.post("submit.detasering.request", body);
  const submitDsKKSOKL = (body) =>
    api.post("submit.approval.detasering.request.kk.sokl", body);
  const submitDsKCPSOKL = (body) =>
    api.post("submit.approval.detasering.request.kcp.sokl", body);
  const submitDsKCPEO = (body) =>
    api.post("submit.approval.detasering.request.kcp.eo", body);
  const submitDsKCISOKL = (body) =>
    api.post("submit.approval.detasering.request.kci.sokl", body);
  const submitDsKCIEO = (body) =>
    api.post("submit.approval.detasering.request.kci.eo", body);
  const submitDsKPNOEO = (body) =>
    api.post("submit.approval.detasering.request.kpno.eo", body);
  const submitDsKPNODD = (body) =>
    api.post("submit.approval.detasering.request.kpno.dd", body);
  const submitDsKPNOASSDIRDIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.assdirdir", body);
  const submitDsKPNOSTFPEMBUKUAN = (body) =>
    api.post("submit.approval.detasering.request.kpno.stfpembukuan", body);
  const submitDsKPNOEOPAYROLL = (body) =>
    api.post("submit.approval.detasering.request.kpno.eopayroll", body);
  const submitDsKPNOBIRODIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.birodireksi", body);
  const submitDsKPNOASSDIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.assdir", body);
  const submitDsKPNODIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.dir", body);
  const submitDsKPNOPRESDIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.presdir", body);
  const submitDsKPNODEPUTYPRESDIR = (body) =>
    api.post("submit.approval.detasering.request.kpno.deppresdir", body);

  const submitCNBPayroll = (body) => api.post("submit.cnb.payroll", body);
  const submitCNBKPNOEOPayroll = (body) =>
    api.post("submit.approval.cnb.payroll.kpno.eo.payroll", body);
  const submitCNBKPNODDSDM = (body) =>
    api.post("submit.approval.cnb.payroll.kpno.dd.sdm", body);

  const submitCNBClaimMedical = (body) =>
    api.post("submit.cnb.claim.medical", body);
  const submitCNBClaimBatch = (body) =>
    api.post("submit.cnb.claim.medical.summary", body);
  const submitCNBCMKCPEO = (body) =>
    api.post("submit.approval.cnb.claim.medical.kcp.eo", body);
  const submitCNBCMKCIEO = (body) =>
    api.post("submit.approval.cnb.claim.medical.kci.eo", body);
  const submitCNBCMKPNOEO = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.eo", body);
  const submitCNBCMKPNOSTFMEDICAL = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.staff.medical", body);
  const submitCNBCMKPNOSOBenefit = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.so.benefit", body);
  const submitCNBCMKPNOEOPayroll = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.eo.payroll", body);
  const submitCNBCMKPNODDSDM = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.dd.sdm", body);
  const submitCNBCMKPNOSTFPEMBUKUAN = (body) =>
    api.post("submit.approval.cnb.claim.medical.kpno.staff.pembukuan", body);

  const submitMassSalary = (body) =>
    api.post("submit.cnb.kenaikan.gaji.masal", body);
  const submitMSSTFPayroll = (body) =>
    api.post("submit.approval.cnb.kenaikan.gaji.masal.staff.payroll", body);
  const submitMSKPNODDSDM = (body) =>
    api.post("submit.approval.cnb.kenaikan.gaji.masal.kpno.dd.sdm", body);
  const submitMSKPNOEOPAYROLL = (body) =>
    api.post("submit.approval.cnb.kenaikan.gaji.masal.kpno.eo.payroll", body);

  const submitPerformanceKPNOBIRODIREKSI = (body) =>
    api.post("submit.approval.performance.kpno.biro.direksi", body);
  const submitPerformanceKPNODEPUTYPRESDIR = (body) =>
    api.post("submit.approval.performance.kpno.deputy.presdir", body);
  const submitPerformanceKPNOPRESDIR = (body) =>
    api.post("submit.approval.performance.kpno.presdir", body);
  const submitPerformanceKPNODIR = (body) =>
    api.post("submit.approval.performance.kpno.dir", body);
  // BRMS
  const ExecRules = (body) => api.post("api/execute.rules", body);
  const ExecCNBRules = (body) => api.post("api/execute.cnb.rules", body);

  //ESS
  const getAllTaxPPH = (body) => api.post("/query/get.all.tax.pph", body);
  const getPayrollByEmployeeId = (body) =>
    api.post("/query/get.payroll.by.employee.id", body);
  const getCountPayrollByEmployee = (body) =>
    api.get("/query/get.all.count.payroll.by.employee.id/" + body);
  const getAllPayrollByEmployeeIdAndYear = (body) =>
    api.post("/query/get.by.employee.id.payroll.year.new", body);
  const getCountAllPayrollByEmployeeIdAndYear = (body) =>
    api.post(
      "/query/get.all.count.payroll.by.employee.id.payroll.year/" + body
    );

  const getPayrollByEmployeeIdAndYear = (body) =>
    api.post("/query/get.by.employee.id.payroll.year.payslip", body);

  const getLeaveByTypeDateNew = (body) =>
    api.get("/query/get.leave.period.by.leavetype.and.paramsdate.new/" + body);
  const getCalcLeaveByID = (body) =>
    api.get("/query/get.calculate.leave.by.leaveid/" + body);
  const getLeavePeriodByType = (body) =>
    api.get("/query/get.leave.period.by.leavetype.and.paramsdate/" + body);
  const getLeaveByStatus = (body) =>
    api.post("/query/get.leave.by.leave.status", body);
  const postLeaveEss = (body) => api.post("/command/post.leave", body);
  const getLeaveByEmployeeId = (body) =>
    api.post("/query/get.leave.by.employee.id", body);
  const getLeaveAllApproved = (body) =>
    api.get(
      "/query/get.all.leave.approved.by.employeeid.and.leavecategory.and.paramsdate/" +
        body
    );
  const getCountLeaveByEmployeeId = (body) =>
    api.get("/query/get.all.count.leave.by.employee.id/" + body);
  const getLeaveBystartDate = (body) =>
    api.get("/query/get.all.leave.by.employee.id.and.leave.start.date/" + body);
  const getCountLeaveBystartDate = (body) =>
    api.get(
      "/query/get.all.count.leave.by.employee.id.and.leave.start.date/" + body
    );
  const updateLeaveEss = (body) => api.put("/command/put.leave", body);
  const deleteLeaveEss = (body) =>
    api.post("/delete.leave", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadLeaveDoc = (body, config) =>
    api.post("/api/leave.document.post", body, config);
  const getAbsLetterByEmployeeId = (body) =>
    api.post("query/get.absence.letter.by.employee.id", body);
  const getAbsLetterCountByEmpId = (body) =>
    api.get("query/get.all.count.absence.letter.by.employee.id/" + body);
  const postAbsLetter = (body) =>
    api.post("/command/post.absence.letter", body);
  const updateAbsLetter = (body) =>
    api.put("/command/put.absence.letter", body);
  const deleteAbsLetter = (body) =>
    api.post("/delete.absence.letter", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadAbsLetter = (body, config) =>
    api.post("/api/absence.letter.document.post", body, config);
  const getCountAllSppd = () => api.get("/query/get.all.count.sppd");
  const getSppdByID = (body) => api.get("/query/get.sppd.by.id/" + body);
  const getSppdRef = (body) =>
    api.get("/query/get.sppd.for.dropdown.list.reference/" + body);
  const getSppdWebESS = (body) => api.post("/query/get.all.sppd.web.ess", body);
  const getSppdByName = (body) =>
    api.post("/query/get.all.sppd.by.employee.name", body);
  const getCountSppdByName = (body) =>
    api.get("/query/get.all.count.sppd.by.employee.name/" + body);
  const postSppd = (body) => api.post("/command/post.sppd", body);
  const updateSppd = (body) => api.put("/command/put.sppd", body);
  const deleteSppd = (body) =>
    api.post("/delete.sppd", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const deleteSppdRes = (body) =>
    api.post("/delete.sppd.responsibility", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getAllReqCertificate = (body) =>
    api.post("query/get.all.request.certificate", body);
  const getAllReqCertificateByID = (body) =>
    api.get("/query/get.request.certificate.by.id/" + body);
  const getRequestByType = (body) =>
    api.post("/query/get.request.by.hcis.request.by", body);
  const getCountAllRequestByType = (body) =>
    api.get("/query/get.all.count.request.by.hcis.request.by/" + body);
  const getRequestByDateBetween = (body) =>
    api.post("/query/get.all.hcis.request.date.between", body);
  const getCountRequestByDateBetween = (body) =>
    api.get("/query/get.all.count.hcis.request.date.between/" + body);
  const uploadHcisReq = (body, config) =>
    api.post("/api/hcis.request.document.post", body, config);

  const getDsByMovID = (body) =>
    api.get("query/get.detasering.by.movementid/" + body);
  const getDsFacility = (body) =>
    api.get(
      "get.corporate.detasering.by.gradeid.esid.triptype.traveltype/" + body
    );
  const getDsBIDDFacility = (body) =>
    api.get(
      "get.corporate.detaseringBIDD.by.gradeid.esid.triptype.traveltype/" + body
    );
  const getDetaseringByEmpId = (body) =>
    api.post("/query/get.detasering.by.employee.id", body);
  const getCountDsByEmpId = (body) =>
    api.get("/query/get.all.count.detasering.by.employee.id/" + body);
  const getDsByStartDate = (body) =>
    api.get(
      "/query/get.all.detasering.by.employee.id.and.detasering.start.date/" +
        body
    );
  const getCountDsByStartDate = (body) =>
    api.get(
      "/query/get.all.count.detasering.by.employee.id.and.detasering.start.date/" +
        body
    );
  const postDs = (body) => api.post("/command/post.detasering", body);
  const updateDs = (body) => api.put("/command/put.detasering", body);
  const updateMemo = (body) => api.put("/command/put.memo.detasering", body);
  const updateSK = (body) => api.put("/command/put.sk.detasering", body);
  const deleteDs = (body) =>
    api.post("/delete.detasering", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadDsDoc = (body, config) =>
    api.post("/api/Detasering.document.post", body, config);
  const getDsByID = (body) => api.get("/query/get.detasering.by.id/" + body);
  const postDsSettlement = (body) =>
    api.post("/command/post.settlement.detasering", body);
  const updateDsSettlement = (body) =>
    api.put("/command/put.settlement.detasering", body);
  const deleteDsSettlement = (body) =>
    api.post("/delete.settlement.detasering", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadDsSettlementDoc = (body, config) =>
    api.post("/api/detasering.settlement.cost.document.post", body, config);

  const postTimesheet = (body) => api.post("/command/post.hcis.request", body);
  const updateTimesheet = (body) => api.put("/command/put.hcis.request", body);
  const deleteTimesheet = (body) =>
    api.post("/delete.hcis.request", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadSppdDoc = (body, config) =>
    api.post("/api/sppd.document.post", body, config);
  const uploadSppdResDoc = (body, config) =>
    api.post("/api/sppd.responsibility.document.post", body, config);
  const getTrainingByStatus = (body) =>
    api.post("/query/get.training.plan.by.status", body);
  const getAllTrainingRegis = (body) =>
    api.post("/query/get.all.training.registration", body);
  const postTrainingReq = (body) =>
    api.post("/command/register.training.plan", body);
  const getOvertimeByEMPID = (body) =>
    api.post("/query/get.overtime.by.employee.id", body);
  const getOvertimeByID = (body) =>
    api.get("/query/get.overtime.by.id/" + body);
  const getSPKLWebPersonel = (body) =>
    api.post("/query/get.all.overtime.web.personnel", body);
  const getCountOvertimeByID = (body) =>
    api.get("/query/get.all.count.overtime.by.employee.id/" + body);
  const getOvertimeByCurrentDate = (body) =>
    api.post("/query/get.all.overtime.by.current.date", body);
  const getCountOverByCurrentDate = (body) =>
    api.get("/query/get.all.count.overtime.by.current.date/" + body);
  const postOvertime = (body) => api.post("/command/post.overtime", body);
  const updateOvertime = (body) => api.put("/command/put.overtime", body);
  const updateOvertimeRes = (body) =>
    api.put("/command/put.overtime.responsibility", body);
  const deleteOvertime = (body) =>
    api.post("/delete.overtime", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadOvertimeDoc = (body, config) =>
    api.post("/api/overtime.document.post", body, config);
  const uploadOvertimeResDoc = (body, config) =>
    api.post("/api/overtime.responsibility.document.post", body, config);

  const getRKLWeb = (body) =>
    api.post(
      "/query/get.all.overtime.work.plan.by.requestor.employee.id",
      body
    );
  const getRKLWebPersonel = (body) =>
    api.post("/query/get.all.overtime.work.plan.web.personnel", body);
  const getRKLByID = (body) =>
    api.get("query/get.overtime.work.plan.by.id/" + body);
  const postRKL = (body) => api.post("/command/post.overtime.work.plan", body);
  const updateRKL = (body) => api.put("/command/put.overtime.work.plan", body);
  const deleteRKL = (body) =>
    api.post("/delete.overtime.work.plan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadRKLDoc = (body, config) =>
    api.post("/api/overtime.work.plan.document.post", body, config);

  // IPP
  const getMidFullYearIppTrx = (body) => api.get("performance.value/" + body);
  const getIppTrxByID = (body) =>
    api.get("/query/get.performance.ipp.by.id/" + body);
  const getIppEssAll = (body) =>
    api.post("/query/get.performance.ipp.all", body);
  const postIppEss = (body) => api.post("/command/post.performance.ipp", body);
  const updateIppEss = (body) => api.put("/command/put.performance.ipp", body);
  const deleteIppEss = (body) =>
    api.post("/delete.performance.ipp", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // TALENT
  const getTalentEssAll = (body) =>
    api.post("/query/get.performance.talent.all", body);
  const postTalentEss = (body) =>
    api.post("/command/post.performance.talent", body);
  const updateTalentEss = (body) =>
    api.put("/command/put.performance.talent", body);
  const deleteTalentEss = (body) =>
    api.post("/delete.performance.talent", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getTalentTrxAll = (body) => api.post("/query/get.talent.all", body);
  const postTalentTrx = (body) => api.post("/command/post.talent", body);
  const updateTalentTrx = (body) => api.put("/command/put.talent", body);
  const deleteTalentTrx = (body) =>
    api.post("/delete.talent", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getCncTrxByID = (body) =>
    api.get("/query/get.performance.cnc.by.id/" + body);
  const getCncEssAll = (body) =>
    api.post("/query/get.performance.cnc.all", body);
  const postCncEss = (body) => api.post("/command/post.performance.cnc", body);
  const updateCncEss = (body) => api.put("/command/put.performance.cnc", body);
  const deleteCncEss = (body) =>
    api.post("/delete.performance.cnc", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //blacklist
  const getAllBlacklistWeb = (body) =>
    api.post("query/get.all.blacklist.web", body);
  const getAllBlacklist = (body) => api.post("/get.all.blacklist", body);
  const getCountAllBlacklist = () => api.get("/get.count.all.blacklist");
  const getBlByEmpName = (body) =>
    api.get("/get.blacklist.by.employee.name/" + body);
  const getBlCountByEmpName = (body) =>
    api.get("/get.count.blacklist.by.employee.name/" + body);
  const postBlacklist = (body) => api.post("/post.blacklist", body);
  const putBlacklist = (body) => api.put("/update.blacklist", body);
  const deleteBlacklist = (body) =>
    api.post("/delete.blacklist", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getBlacklistbyEmployeeId = (body) =>
    api.post("/get.blacklist.by.employee.id", body);
  const getCountBlacklistbyEmployeeId = (body) =>
    api.get("/get.count.blacklist.by.employee.id/" + body);
  const getBlacklistByID = (body) => api.get("/get.blacklist.by.id/" + body);
  const uploadDocBlacklist = (body, config) =>
    api.post("/api/blacklist.document.post", body, config);

  // training
  const getAllTrainingByStatus = (body) =>
    api.post("query/get.training.by.status", body);
  const getAllTrainingPlan = (body) => api.post("query/get.all.training", body);
  const getTrainingPlanById = (body) =>
    api.get("query/get.training.by.id/" + body);
  const postTrainingPlan = (body) => api.post("command/post.training", body);
  const putTrainingPlan = (body) => api.put("command/put.training", body);
  const deleteTrainingPlan = (body) =>
    api.post("command/delete.training", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getAllTrainingEvaluation = (body) =>
    api.post("query/get.all.training.evaluation", body);
  const postTrainingEvaluation = (body) =>
    api.post("command/post.training.evaluation", body);
  const putTrainingEvaluation = (body) =>
    api.put("command/put.training.evaluation", body);
  const deleteTrainingEvaluation = (body) =>
    api.post("command/delete.training.evaluation", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getAllTrainingEvaluationTrainer = (body) =>
    api.post("query/get.training.trainer.evaluation", body);
  const postTrainingEvaluationTrainer = (body) =>
    api.post("command/post.training.trainer.evaluation", body);
  const putTrainingEvaluationTrainer = (body) =>
    api.put("command/put.training.trainer.evaluation", body);
  const deleteTrainingEvaluationTrainer = (body) =>
    api.post("/delete.training.trainer.evaluation", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // CNB
  const getAllBatchPayroll = (body) => api.post("get.all.batchpayroll", body);
  const getCountAllBatchPayroll = () => api.get("get.all.count.batchpayroll");
  const postBatchPayroll = (body) =>
    api.post("command/post.batchpayroll", body);
  const putBatchPayroll = (body) => api.put("command/put.batchpayroll", body);
  const calculateBatchPayroll = (body) =>
    api.put("command/calculate.batch.payroll", body);
  const getBatchPayrollWeb = (body) =>
    api.post("query/get.all.batch.payroll.web.personnel", body);
  const getBatchPayrollWebFilter = (body) =>
    api.post("query/get.all.batch.payroll.By.esID.month.year.createdBy", body);
  const getBatchPayrollById = (body) =>
    api.get("get.batchpayroll.by.id/" + body);
  const getAllClaimWeb = (body) =>
    api.post("query/get.all.claim.web.personnel.cnb", body);
  const getAllClaim = (body) => api.post("query/get.all.claim", body);
  const getCountAllClaim = () => api.get("query/get.all.count.claim/");
  const getClaimDocument = (body) => api.get("api/claim.document.get/" + body);
  const postClaimDocument = (body, config) =>
    api.post("api/claim.document.post", body, config);
  const getComponentClaimByEmpCompPosition = (body) =>
    api.get("query/get.component.claim.by.employee.id/" + body);
  const getMedicalHistoryByEmp = (body) =>
    api.post("query/get.employee.medical.history", body);
  const getClaimByEmpIdTypeYear = (body) =>
    api.post("query/get.claim.by.employeeid.type.and.year", body);
  const getClaimById = (body) => api.get("query/get.claim.by.id/" + body);
  const getPayrollCorrectionWeb = (body) =>
    api.post("query/get.all.payroll.correction.web.personnel", body);
  const getPayrollCorrectionRoleWeb = (body) =>
    api.post("query/get.all.payroll.correction.role.web.personnel", body);
  const getAllPayrollCorrectionByStatus = (body) =>
    api.post("get.all.correction.payroll.by.status", body);
  const getAllCorrectionPayrollByGroupId = (body) =>
    api.post("get.all.correction.payroll.by.groupid.year.month", body);
  const postPayrollCorrection = (body) =>
    api.post("command/post.payroll.correction", body);
  const notifyPayrollCorrection = (body) =>
    api.post("command/notify.payroll.correction", body);
  const putPayrollCorrection = (body) =>
    api.put("command/put.payroll.correction", body);
  const deletePayrollCorrection = (body) =>
    api.post("command/delete.payroll.correction", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const getClaimMonitoring = (body) =>
    api.post("query/get.all.claimmonitoring.web.personnel", body);
  const getEmpClaim = (body) =>
    api.post("query/get.all.claim.web.search", body);
  const getAllClaimSearch = (body) =>
    api.post(
      "query/get.all.claim.by.employee.name.and.claim.type.search",
      body
    );
  const getListClaimIDs = (body) =>
    api.post("query/get.all.claim.by.claimid.list.search", body);
  const postClaimMonitoring = (body) =>
    api.post("command/post.claim.monitoring", body);
  const putClaimMonitoring = (body) =>
    api.put("command/put.claim.monitoring", body);
  const deleteClaimMonitoring = (body) =>
    api.post("command/delete.claim.monitoring", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getMassSalaryWeb = (body) =>
    api.post("query/get.all.kenaikan.gaji.masal.web.personnel.cnb", body);
  const getMassSalaryByID = (body) =>
    api.get("/query/get.claim.kenaikan.gaji.masal.by.id/" + body);
  const uploadMassSalary = (body, config) =>
    api.post("/api/kenaikan.gaji.masal.document.post", body, config);
  const postMassSalaryWeb = (body) =>
    api.post("command/post.kenaikan.gaji.masal", body);
  const putMassSalaryWeb = (body) =>
    api.put("command/put.kenaikan.gaji.masal", body);
  const deleteMassSalaryWeb = (body) =>
    api.post("command/delete.kenaikan.gaji.masal", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getDataClaimBatchStartEndDate = (body) =>
    api.post(
      "/query/get.all.claim.by.employee.name.and.claim.type.and.claimdate.between.startdate.and.enddate.search",
      body
    );
  const getClAllowanceWEB = (body) =>
    api.post("/query/get.all.claim.allowance.web.personnel.cnb", body);
  const getClAllowanceByEmpID = (body) =>
    api.post("/query/get.all.claim.allowance.by.employeeid", body);
  const getClAllowanceByID = (body) =>
    api.get("query/get.claim.allowance.by.id/" + body);
  const getClAllowanceTypeYear = (body) =>
    api.post(
      "/query/get.all.claim.allowance.by.employeeid.type.and.year",
      body
    );
  const postClAllowance = (body) =>
    api.post("command/post.claim.allowance", body);
  const putClAllowance = (body) => api.put("command/put.claim.allowance", body);
  const deleteClaimAllowence = (body) =>
    api.post("command/delete.claim.allowance", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const uploadClAllowance = (body, config) =>
    api.post("/api/claim.allowance.document.post", body, config);

  const getPDLWEB = (body) => api.post("/query/get.pdl.web", body);
  const postPDL = (body) =>
    api.post("command/post.payroll.definition.language", body);
  const putPDL = (body) =>
    api.put("command/put.payroll.definition.language", body);
  const deletePDL = (body) =>
    api.post("command/delete.payroll.definition.language", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // DASHBOARD
  const getAverageLeaveBalance = () => api.get("get.average.leave.balance");
  const getStaffPerformance = () => api.get("get.staff.performance");
  const getTotalCostPerHire = () => api.get("get.total.cost.per.hire");
  const getTotalEmployeePerHire = () => api.get("get.total.employee.per.hire");
  const getStatusEmployee = () => api.get("get.status.employee");
  const getAgeDemographicPerDepartment = () =>
    api.get("get.age.demographic.per.department");
  const getOpenPositionByDepartment = () =>
    api.get("get.open.position.by.department");
  const getEmployeeScore = () => api.get("get.employee.score");
  const getAverageLeaveBalanceDays = () =>
    api.get("get.average.leave.balance.days");
  const getIncomeBreakdown = () => api.get("get.income.breakdown");
  const getEksadStrategyMatrix = () => api.get("get.eksad.strategy.matrix");
  const getTotalEmployee = () => api.get("get.total.employee");
  const getEksadAverageSpendPerHire = () =>
    api.get("get.eksad.average.spend.per.hire");
  const getDashboard = () => api.get("get.dashboard");
  const getAverageCostHire = (body) =>
    api.post("get.all.average.cost.per.hire", body);
  const getBudgetPlanning = (body) =>
    api.post("get.all.total.budget.planning.per.year", body);
  const getApplicantDivision = (body) =>
    api.post("get.all.total.applicant.per.division", body);
  const getAverageTimeDuration = (body) =>
    api.post("get.all.average.time.duration.execution.task.per.employee", body);
  const getMaxTime = (body) =>
    api.post("get.all.maximum.time.duration.execution.task.per.employee", body);
  const getEmployeeWorkflow = (body) =>
    api.post(
      "get.all.total.employee.involved.within.corporate.work.flow",
      body
    );
  const getAveragePayroll = (body) =>
    api.post("get.all.average.payroll.per.month", body);
  const getExecutedPayroll = (body) =>
    api.post("get.all.total.executed.payroll", body);
  const getAverageTax = (body) =>
    api.post("get.all.average.tax.per.month.of.the.year", body);
  const getExecutedTax = (body) => api.post("get.all.total.executed.tax", body);
  const getAverageCom = (body) =>
    api.post("get.all.average.compensation.per.month.of.the.year", body);
  const getExecutedCom = (body) =>
    api.post("get.all.total.executed.compensation", body);
  const getAverageBenefit = (body) =>
    api.post("get.all.average.benefit.per.month.of.the.year", body);
  const getExecutedBenefit = (body) =>
    api.post("get.all.total.executed.benefit", body);
  const getLoanFinished = (body) =>
    api.post("get.all.total.employee.finished.loan.type", body);
  const getTotalEmployeeGender = (body) =>
    api.post("get.all.total.employee.gender", body);
  const getTotalEmployeeGenderPerDivision = (body) =>
    api.post("get.all.total.employee.gender.per.division", body);
  const getEmployeeOvertimePerDivision = (body) =>
    api.post("get.all.employee.overtime.per.division", body);
  const getEmployeeBusinessTrip = (body) =>
    api.post("get.all.employee.business.trip", body);
  const getAverageBiztripPerEmployee = (body) =>
    api.post("get.all.average.amount.business.trip.cost.per.employee", body);
  const getTotalEmployeeDashboard = (body) =>
    api.post("get.all.total.employee", body);
  const getAllEmployeeOnBirthday = (body) =>
    api.post("get.all.employee.on.birthday", body);
  const getCurrentTraining = (body) =>
    api.post("get.all.current.available.training", body);
  const getCanceledTraining = (body) =>
    api.post("get.all.current.cancelled.training", body);
  const getEmployeeTraining = (body) =>
    api.post("get.all.total.current.employee.training", body);
  const getAverageCorporate = (body) =>
    api.post("get.all.average.corporate.per.training", body);
  const getEmployeeComply = (body) =>
    api.post("get.all.total.employee.comply.with.criteria.x", body);
  const getAveragePerformance = (body) =>
    api.post("get.all.total.employee.with.average.performance", body);
  const getAverageLoan = (body) =>
    api.post("get.all.average.corporate.loan", body);
  const getAvailableTraining = (body) =>
    api.post("get.all.available.training", body);
  const getCandidateDivision = (body) =>
    api.post("get.all.total.candidate.per.division", body);
  const getProcessingApplicant = (body) =>
    api.post("get.all.total.processing.applicant.per.division", body);
  const getPosistionDepartment = (body) =>
    api.post("get.all.total.open.position.per.department", body);
  const getLateEmployee = (body) =>
    api.post("get.all.employee.late.per.division", body);
  const getCommitedLoan = (body) =>
    api.post("get.all.total.employee.commited.loan.per.loan.type", body);
  const getAverageBiztripPerDivision = (body) =>
    api.post("get.all.average.amount.business.trip.cost.per.division", body);
  const getLeavePerDivision = (body) =>
    api.post("get.all.employee.leave.per.division", body);
  const getGenderPerDivision = (body) =>
    api.post("get.all.total.employee.gender.per.division", body);
  const getEmployeeNotComply = (body) =>
    api.post("get.all.total.employee.not.comply.with.criteria.x", body);
  const getEmployeeStatus = (body) =>
    api.post("get.all.total.employee.by.status", body);
  const getEmployeeMovement = (body) =>
    api.post("get.all.total.employee.movement.by.type", body);
  const getEmployeeTermination = (body) =>
    api.post("get.all.total.employee.termination.by.type", body);
  const getEmployeeBlacklist = (body) =>
    api.post("get.all.total.employee.blacklist.by.type", body);
  const getListTask = (body) =>
    api.post("get.all.list.personal.task.per.type", body);
  const getRemainingDays = (body) =>
    api.post("get.all.remaining.days.off", body);
  const getAvgAmount = (body) =>
    api.post("get.all.average.amount.business.trip.cost.per.employee", body);
  const getEmployeeByAge = (body) =>
    api.post("get.all.total.employee.by.age.per.division", body);
  const getNotification = (body) => api.post("get.all.list.notification", body);
  const getBlacklistPerDivision = (body) =>
    api.post("get.all.total.employee.blacklist.by.type.per.division", body);
  const getEmployeeTerminationPerDivision = (body) =>
    api.post("get.all.total.employee.termination.by.type.per.division", body);
  const getEmployeeMovementPerDivision = (body) =>
    api.post("get.all.total.employee.movement.by.type.per.division", body);
  const getMovementByType = (body) =>
    api.post("get.all.total.employee.movement.by.type", body);
  const getTotalAttendance = (body) =>
    api.post("get.all.total.attendance.per.month", body);
  const getEmployeeNotPresent = (body) =>
    api.post("get.all.total.employee.no.present.by.type", body);
  const getWorkflowSum = (body) =>
    api.post("get.dashboard.workflow.summary", body);
  const getWorkflowPerEmp = (body) =>
    api.post("get.dashboard.workflow.per.employee", body);
  const getWorkflowPerDiv = (body) =>
    api.post("get.dashboard.workflow.per.position", body);
  const getWorkflowPerTask = (body) =>
    api.post("get.dashboard.workflow.per.taskname", body);
  const getTrainingBudget = (body) =>
    api.post("query/get.all.training.budget", body);
  const getTrainingBudgetById = (body) =>
    api.get("query/get.training.budget.by.id/" + body);
  const postTrainingBudget = (body) =>
    api.post("command/post.training.budget", body);
  const putTrainingBudget = (body) =>
    api.put("command/update.training.budget", body);
  const deleteTrainingBudget = (body) =>
    api.post("command/delete.training.budget", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //PAGINATION
  const getCountCorporateHolidayByStatus = (body) =>
    api.get("/get.count.corporate.holiday.by.status/" + body);
  const getCountCorporateHolidayByName = (body) =>
    api.post("/get.count.corporate.holiday.by.name/", body);
  const getCountFacilityByIdAndName = (body) =>
    api.get(
      "/get.count.corporate.facility.tpl.by.esid.and.facility.name/" + body
    );
  const getCountFacilityByStatus = (body) =>
    api.get("/get.count.corporate.facility.tpl.status/" + body);
  const getCountAllFacility = (body) =>
    api.get("/get.count.all.corporate.facility.tpl");
  const getFacilityByIdAndName = (body) =>
    api.post("/get.corporate.facility.tpl.by.esid.and.facility.name", body);
  const getCountCorpOfficeHourByStatus = (body) =>
    api.get("/get.count.corporate.office.hour.by.status/" + body);
  const getCountCorpOfficeHourByESID = (body) =>
    api.get("/get.count.corporate.office.hour.by.esid/" + body);
  const getAllCountCorpOfficeHour = (body) =>
    api.get("/get.count.all.corporate.office.hour");
  const getCountCorpOfficeHourByName = (body) =>
    api.get("/get.count.corporate.office.hour.by.name/" + body);
  const getAllCorpOfficeHourByName = (body) =>
    api.post("/get.corporate.office.hour.by.name", body);
  const getCountPersonalOfficeHourByStatus = (body) =>
    api.get("/get.count.personel.office.hour.by.status/" + body);
  const getCountPersonalOfficeHourByESID = (body) =>
    api.get("/get.count.personel.office.hour.by.es.id/" + body);
  const getAllCountPersonalOfficeHour = (body) =>
    api.get("/get.count.all.personel.office.hour");
  const getAllPersonalOfficeHourByStatusAndName = (body) =>
    api.post("/get.personel.office.hour.by.status.and.employee.name", body);
  const getCountPersonalOfficeHourByStatusAndName = (body) =>
    api.get(
      "/get.count.personel.office.hour.by.status.and.employee.name/" + body
    );
  const getCountShiftHourByStatus = (body) =>
    api.get("/get.count.office.shift.hour.by.status/" + body);
  const getCountShiftHourByESID = (body) =>
    api.get("/get.count.office.shift.hour.by.es.id/" + body);
  const getCountShiftHourByStatusAndName = (body) =>
    api.get("/get.count.office.shift.hour.by.status.and.employee.name/" + body);
  const getAllCountShiftHour = (body) =>
    api.get("/get.count.all.office.shift.hour");
  const getAllShiftHourByStatusAndName = (body) =>
    api.post("/get.office.shift.hour.by.status.and.employee.name", body);
  const getCountCorpPayrollByStatus = (body) =>
    api.get("/get.count.corporate.payroll.tpl.status/" + body);
  const getAllCountCorpPayroll = (body) =>
    api.get("/get.count.all.corporate.payroll.tpl");
  const getAllCorpPayrollByStatusAndName = (body) =>
    api.post("/get.corporate.payroll.tpl.by.name", body);
  const getCountCorpPayrollByStatusAndName = (body) =>
    api.get(
      "/get.count.corporate.payroll.tpl.status.and.payroll.tpl.name/ACTIVE/" +
        body
    );
  const getCountLeavePlafonByStatus = (body) =>
    api.get("/get.count.corporate.leave.plafon.by.status/" + body);
  const getCountLeavePlafonByESID = (body) =>
    api.get("/get.count.corporate.leave.plafon.by.esid/" + body);
  const getAllCountLeavePlafon = (body) =>
    api.get("/get.all.count.corporate.leave.plafon");
  const getCountLeavePlafonByIdAndName = (body) =>
    api.get(
      "/get.count.corporate.leave.plafon.by.esid.and.position.name/" + body
    );
  const getAllLeavePlafonByIdAndName = (body) =>
    api.post("/get.corporate.leave.plafon.by.esid.and.position.name", body);
  const getCountLeaveTypeByStatus = (body) =>
    api.get("/get.count.corporate.leave.type.by.status/" + body);
  const getCountLeaveTypeByStatusES = (body) =>
    api.get(
      "/get.count.corporate.leave.type.by.status/" +
        body.esID +
        "/" +
        body.status
    );
  const getCountLeaveTypeByIdAndName = (body) =>
    api.get(
      "/get.count.corporate.leave.type.by.esid.and.leave.type.name/" + body
    );
  const getAllLeaveTypeByIdAndName = (body) =>
    api.post("/get.corporate.leave.type.by.esid.and.leave.type.name", body);

  const getCountCNBbyIdAndName = (body) =>
    api.get("/get.count.corporate.cnb.tpl.by.es.id.and.cnb.tpl.name/" + body);
  const getCNBByIdAndName = (body) =>
    api.post("/get.corporate.cnb.tpl.by.es.id.and.cnb.tpl.name", body);
  const getCountCNBByStatus = (body) =>
    api.get("/get.count.corporate.cnb.tpl.status/" + body);
  const getCountAllCNB = (body) => api.get("/get.count.all.corporate.cnb.tpl");
  const getCountHolidayByStatus = (body) =>
    api.get("/get.count.corporate.holiday.by.status/" + body);
  const getCountHolidayByESID = (body) =>
    api.get("/get.count.corporate.holiday.by.esid/" + body);
  const getCountAllHoliday = (body) =>
    api.get("/get.count.all.corporate.holiday");
  const getCountHolidayByName = (body) =>
    api.get("/get.count.corporate.holiday.by.name/" + body);
  const getHolidayByName = (body) =>
    api.post("/get.corporate.holiday.by.name", body);
  const getHolidayWeb = (body) => api.post("/get.corporate.holiday.web", body);

  const getCountCountryByStatus = (body) =>
    api.get("/get.count.country.by.status/" + body);
  const getCountCountryByName = (body) =>
    api.get("/get.count.country.by.name/" + body);
  const getCountryByName = (body) =>
    api.post("/get.countrymaster.by.countryname", body);
  const getCountInstituteByStatus = (body) =>
    api.get("/get.count.institute.by.status/" + body);
  const getCountInstituteByName = (body) =>
    api.get("/get.count.institute.by.name/" + body);
  const getInstituteByName = (body) => api.post("/get.institute.by.name", body);
  const getCountEducationByStatus = (body) =>
    api.get("/get.count.education.configuration.by.status/" + body);
  const getCountEducationByLevel = (body) =>
    api.get("/get.count.education.configuration.by.level.name/" + body);
  const getAllEducationByLevel = (body) =>
    api.post("/get.education.configuration.by.level.name", body);

  const getCountAllMovement = (body) =>
    api.get("query/get.count.all.movement", body);
  const getAllMovementByName = (body) =>
    api.post("query/get.movement.by.employee.name", body);
  const getAllMovementSKWEB = (body) =>
    api.post("/query/get.all.movement.sk.web", body);
  const getAllMovementSKESS = (body) =>
    api.post("/query/get.all.movement.sk.by.employeeid.and.sk.number", body);
  const getAllMovementMemoWEB = (body) =>
    api.post("/query/get.all.movement.memo.web", body);
  const getCountMovementByName = (body) =>
    api.get("query/get.count.movement.by.employee.name/" + body);
  const getAllMovementByStatus = (body) =>
    api.post("query/get.movement.by.status", body);
  const getCountMovementByStatus = (body) =>
    api.get("query/get.count.movement.by.status/" + body);
  const getAllMovementByCategory = (body) =>
    api.post("query/get.movement.by.category", body);
  const getCountAllMovementByCategory = (body) =>
    api.get("query/get.count.movement.by.category/" + body);
  const getMovementByEmpIDByCategoryByStatus = (body) =>
    api.get("query/get.all.movement.by.employeeid.category.and.status/" + body);

  const getAllTerminationWeb = (body) =>
    api.post("query/get.all.termination.web", body);
  const getAllTerminationESSWeb = (body) =>
    api.post("query/get.all.termination.ess.web", body);
  const getCountAllTermination = () =>
    api.get("query/get.count.all.termination");
  const getCountTerminationByName = (body) =>
    api.get("query/get.count.termination.by.employee.name/" + body);
  const getAllTerminationByName = (body) =>
    api.post("query/get.termination.by.employee.name", body);

  const getCountRoleByStatus = (body) =>
    api.get("/get.count.role.by.status/" + body);
  const getSppdByGradeES = (body) =>
    api.get(
      "/get.corporate.travel.expense.by.gradeid.esid.triptype.traveltype/" +
        body
    );
  const getSppdBIDDByGradeES = (body) =>
    api.get(
      "/get.corporate.travel.expense.bidd.by.gradeid.esid.triptype.traveltype/" +
        body
    );

  // training expense
  const getAllTrainingExpense = (body) =>
    api.post("query/get.all.training.expense", body);
  const getAllTrainingExpenseByTrnId = (body) =>
    api.post("query/get.all.training.expense.by.trainingid", body);
  const postTrainingExpense = (body) =>
    api.post("command/post.training.expense", body);
  const putTrainingExpense = (body) =>
    api.put("command/put.training.expense", body);
  const deleteTrainingExpense = (body) =>
    api.post("command/delete.training.expense", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // CNC
  const getCncTpl = (body) => api.post("get.cnc.tpl", body);
  const getCncById = (body) => api.get("get.cnc.tpl.by.id/" + body);
  const postCnc = (body) => api.post("post.cnc.tpl", body);
  const updateCnc = (body) => api.put("update.cnc.tpl", body);
  const postCncHeaderSection = (body) =>
    api.post("post.cnc.header.section", body);
  const updateCncHeaderSection = (body) =>
    api.put("update.cnc.header.section", body);
  const postCncSignageSection = (body) =>
    api.post("post.cnc.signage.section", body);
  const updateCncSignageSection = (body) =>
    api.put("update.cnc.signage.section", body);
  const updateCncAreaSection = (body) =>
    api.put("update.cnc.area.development.section", body);
  const updateCncFeedbackSection = (body) =>
    api.put("update.cnc.feedback.section", body);
  const deleteCncTpl = (body) =>
    api.post("delete.cnc.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // TNA Form
  const uploadDocTna = (body) => api.post("upload.document.tna.form", body);
  const getAllTnaForm = (body) => api.post("query/get.tna.form.all", body);
  const getAllTnaFormPaging = (body) =>
    api.post("query/get.tna.form.all.by.esid.and.search", body);
  const getCountAllTnaFormPaging = (body) =>
    api.post("query/count.tna.form.by.esid.and.search", body);
  const getTnaFormByName = (body) =>
    api.get("query/get.employee.tna.form.by.name/" + body);
  const getAllTnaFormByNameStatusInitiate = (body) =>
    api.get("query/get.employee.tna.form.by.name.and.status/" + body);
  const getAllTnaFormByNameStatusNotInitiate = (body) =>
    api.get("query/get.employee.tna.form.by.name.and.status/" + body);
  const getAllTnaFormNotPass = (body) =>
    api.post("query/get.tna.form.all.by.pass.status", body);
  const getAllTnaFormNotPassPaging = (body) =>
    api.post("query/get.tna.form.all.pass.by.esid.and.search", body);
  const getCountAllTnaFormNotPassPaging = (body) =>
    api.post("query/count.tna.form.pass.by.esid.and.search", body);
  const getAllTnaName = (body) =>
    api.get("query/get.list.tna.name.by.esid/" + body);
  const getCountAllTnaName = (body) =>
    api.get("query/get.count.list.tna.name.by.esid/" + body);
  const getTnaFormByID = (body) => api.get("query/get.tna.form.by.id/" + body);
  const postTnaForm = (body) => api.post("command/post.tna.form", body);
  const putTnaForm = (body) => api.put("command/update.tna.form", body);
  const deleteTnaForm = (body) =>
    api.post("command/delete.tna.form", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitTnaForm = (body) => api.post("submit.trn.diklat.report", body);
  const submitTnaFormBatch = (body) =>
    api.post("submit.trn.diklat.report.batch", body);
  const submitTnaFormLvl1 = (body) =>
    api.post("submit.approve.trn.diklat.report.eo.sdm.", body);
  const submitTnaFormLvl2 = (body) =>
    api.post("submit.approve.trn.diklat.report.dd.sdm", body);
  const submitTnaFormLvl3 = (body) =>
    api.post("submit.approve.trn.diklat.report.biro.direksi", body);
  const submitTnaFormBatchAll = (body) =>
    api.post("submit.trn.diklat.report.batch.all", body);
  const submitTnaFormLvl1Batch = (body) =>
    api.post("submit.approve.trn.diklat.report.eo.sdm.batch", body);
  const submitTnaFormLvl2Batch = (body) =>
    api.post("submit.approve.trn.diklat.report.dd.sdm.batch", body);
  const submitTnaFormLvl3Batch = (body) =>
    api.post("submit.approve.trn.diklat.report.biro.direksi.batch", body);
  const byPassStateStatusTna = (body) =>
    api.put("command/update.tna.form.state.and.status", body);

  // Training Attendance
  const getAllTrainingAttendance = (body) =>
    api.post("query/get.atttendance.all", body);
  const getTrainingAttendancePaging = (body) =>
    api.post("query/get.attendance.by.esid.and.search", body);
  const getCountTrainingAttendancePaging = (body) =>
    api.post("query/count.attendance.by.esid.and.search", body);
  const getTrainingAttendanceByID = (body) =>
    api.get("query/get.attendance.by.id/" + body);
  const postTrainingAttendance = (body) =>
    api.post("command/post.attendance", body);
  const putTrainingAttendance = (body) =>
    api.put("command/update.attendance", body);
  const deleteTrainingAttendance = (body) =>
    api.post("command/delete.attendance", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // Training Cert
  const getAllTrainingCert = (body) =>
    api.post("query/get.training.certificate.all", body);
  const getAllTrainingCertPaging = (body) =>
    api.post("query/get.training.certificate.by.esid.and.search", body);
  const getCountAllTrainingCertPaging = (body) =>
    api.post("query/count.training.certificate.by.esid.and.search", body);
  const getTrainingCertByID = (body) =>
    api.get("query/get.training.certificate.by.id/" + body);
  const postTrainingCert = (body) =>
    api.post("command/post.training.certificate", body);
  const putTrainingCert = (body) =>
    api.put("command/update.training.certificate", body);
  const uploadTrainingCert = (body, config) =>
    api.post("/api/training.cerfiticate.photo.post", body, config);
  const deleteTrainingCert = (body) =>
    api.post("command/delete.training.certificate", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // Training Scoring
  const getAllTrainingScoring = (body) =>
    api.post("query/get.trn.scoring.all", body);
  const getAllTrainingScoringPaging = (body) =>
    api.post("query/get.trn.scoring.by.esid.and.search", body);
  const getCountAllTrainingScoringPaging = (body) =>
    api.post("query/get.count.trn.scoring.by.esid.and.search", body);
  const getTrainingScoringByID = (body) =>
    api.get("query/get.trn.scoring.by.id/" + body);
  const postTrainingScoring = (body) =>
    api.post("command/post.trn.scoring", body);
  const putTrainingScoring = (body) =>
    api.put("command/update.trn.scoring", body);
  const deleteTrainingScoring = (body) =>
    api.post("command/delete.trn.scoring", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // Training Batch
  const getAllTrainingBatch = (body) =>
    api.post("query/get.training.batch.all", body);
  const getTrainingBatchPaging = (body) =>
    api.post("query/get.batch.by.esid.and.search", body);
  const getCountTrainingBatchPaging = (body) =>
    api.post("query/count.batch.by.esid.and.search", body);
  const getTrainingBatchByID = (body) =>
    api.get("query/get.training.batch.by.id/" + body);
  const postTrainingBatch = (body) =>
    api.post("command/post.training.batch", body);
  const putTrainingBatch = (body) =>
    api.put("command/update.training.batch", body);
  const deleteTrainingBatch = (body) =>
    api.post("command/delete.training.batch", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // Observation
  const getAllObservation = (body) =>
    api.post("query/get.observation.all", body);
  const getAllObservationPaging = (body) =>
    api.post("query/get.observation.by.esid.and.search", body);
  const getCountAllObservationPaging = (body) =>
    api.post("query/get.count.observation.by.esid.and.search", body);
  const getObservationByID = (body) =>
    api.get("query/get.observation.by.id/" + body);
  const postObservation = (body) => api.post("command/post.observation", body);
  const putObservation = (body) => api.put("command/update.observation", body);
  const deleteObservation = (body) =>
    api.post("command/delete.observation", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // TEMPLATE
  const postTemplateTrainingProcess = (body) =>
    api.post("template.document.process.training", body);
  const postTemplateLoanProcess = (body) =>
    api.post("template.document.process.loan", body);
  const postTemplateLoanInstallmentProcess = (body) =>
    api.post("template.document.process.loanevent.history", body);

  // FILTER
  const getEmpByEsidOuid = (body) =>
    api.post("query/get.employee.by.esid.and.ouid", body);
  const getCountEmpByEsidOuid = (body) =>
    api.get("query/get.count.employee.by.esid.and.ouid/" + body);
  const getEmpByEsidOuidEmpName = (body) =>
    api.post("query/get.employee.by.esid.and.ouid.and.employeename", body);
  const getCountEmpByEsidOuidEmpName = (body) =>
    api.get(
      "query/get.count.employee.by.esid.and.ouid.and.employeename/" + body
    );

  //TRAINING CATALOG
  const getTrainingCatalogAll = (body) =>
    api.post("query/get.catalog.all", body);
  const getTrainingCatalogByID = (body) =>
    api.get("query/get.catalog.by.id/" + body);
  const getTrainingCatalogByCategory = (body) =>
    api.get("query/get.catalog.by.category.key/" + body);
  const getTrainingCatalogAllOptimize = () =>
    api.post("query/get.catalog.all.optimize");
  const getTrainingCatalogAllSearch = (body) =>
    api.post("query/get.catalog.all.by.search", body);
  const getCountTrainingCatalogAllSearch = (body) =>
    api.post("query/get.count.catalog.all.by.search", body);
  const getCountTrainingCatalogAll = () => api.get("get.count.all.catalog");
  const postTrainingCatalog = (body) => api.post("command/post.catalog", body);
  const updateTrainingCatalog = (body) =>
    api.put("command/update.catalog", body);
  const deleteTrainingCatalog = (body) =>
    api.post("command/delete.catalog", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  // TRAINING CATALOG ITEM
  const getTrainingCatalogItemAll = (body) =>
    api.post("query/get.catalog.item.all", body);
  const postTrainingCatalogItem = (body) =>
    api.post("command/post.catalog.item", body);
  const updateTrainingCatalogItem = (body) =>
    api.put("command/update.catalog.item", body);
  const deleteTrainingCatalogItem = (body) =>
    api.post("command/delete.catalog.item", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  // TRAINING SYLABUS
  const getTrainingSylabusAll = (body) =>
    api.post("query/get.training.sylabus.all", body);
  const getCountTrainingSylabusAll = () => api.get("get.count.all.sylabus");
  const postTrainingSylabus = (body) =>
    api.post("command/post.training.sylabus", body);
  const updateTrainingSylabus = (body) =>
    api.put("command/update.training.sylabus", body);
  const deleteTrainingSylabus = (body) =>
    api.post("command/delete.training.sylabus", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  // TRAINING PROPOSAL
  const getTrainingProposalAll = (body) =>
    api.post("query/get.training.proposal.all", body);
  const getTrainingProposalPaging = (body) =>
    api.post("query/get.proposal.by.esid.and.search", body);
  const getTrainingProposalByStatusPaging = (body) =>
    api.post("query/get.proposal.by.esid.and.search.and.status", body);
  const getCountTrainingProposalByStatusPaging = (body) =>
    api.post("query/count.proposal.by.esid.and.search.and.status", body);
  const getCountTrainingProposalPaging = (body) =>
    api.post("query/count.proposal.by.esid.and.search", body);
  const getTrainingProposalByID = (body) =>
    api.get("query/get.training.proposal.by.id/" + body);
  const postTrainingProposal = (body) =>
    api.post("command/post.training.proposal", body);
  const uploadTrainingProposalDoc = (body, config) =>
    api.post("/upload.document.training.proposal", body, config);
  const updateTrainingProposal = (body) =>
    api.put("command/update.training.proposal", body);
  const deleteTrainingProposal = (body) =>
    api.post("command/delete.training.proposal", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitTrnProposalInternal = (body) =>
    api.post("submit.trn.proposal.internal", body);
  const submitTrnProposalLvl1Internal = (body) =>
    api.post("submit.approve.proposal.internal.eo.sdm", body);
  const submitTrnProposalLvl2Internal = (body) =>
    api.post("submit.approve.proposal.internal.dd.sdm", body);
  const submitTrnProposalLvl3Internal = (body) =>
    api.post("submit.approve.proposal.internal.biro.direksi", body);
  const submitTrnProposalExternal = (body) =>
    api.post("submit.trn.proposal.external", body);
  const submitTrnProposalStaffExternal = (body) =>
    api.post("submit.approve.proposal.external.stf.pelatihan", body);
  const submitTrnProposalLvl1External = (body) =>
    api.post("submit.approve.proposal.external.eo.diklat", body);
  const submitTrnProposalLvl2External = (body) =>
    api.post("submit.approve.proposal.external.dd.sdm", body);
  const submitTrnProposalLvl3External = (body) =>
    api.post("submit.approve.proposal.external.biro.direksi", body);

  //TRAINING SHEET
  const getTnaSheet = (body) => api.post("query/get.tna.sheet.all", body);
  const getTnaSheetPaging = (body) =>
    api.post("query/get.tna.sheet.by.esid.and.search", body);
  const getCountTnaSheetPaging = (body) =>
    api.post("query/count.tna.sheet.by.esid.and.search", body);
  const getTnaSheetByID = (body) =>
    api.get("query/get.tna.sheet.by.id/" + body);
  const postTnaSheet = (body) => api.post("command/post.tna.sheet", body);
  const updateTnaSheet = (body) => api.put("command/update.tna.sheet", body);
  const deleteTnaSheet = (body) =>
    api.post("command/delete.tna.sheet", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //TRAINING BUDGET PLAN
  const getTrainingBudgetPlanAll = (body) =>
    api.post("query/get.budget.plan.all.optimize", body);
  const getTrainingBudgetPlanByID = (body) =>
    api.get("query/get.budget.plan.by.id/" + body);
  const getTrainingBudgetPlanAllPaging = (body) =>
    api.post("query/get.budget.plan.all.by.esid.and.search", body);
  const getCountTrainingBudgetPlanAllPaging = (body) =>
    api.post("query/count.budget.plan.by.esid.and.search", body);
  const getTrainingBudgetPlanAllFull = (body) =>
    api.post("query/get.budget.plan.all", body);
  const postTrainingBudgetPlan = (body) =>
    api.post("command/post.budget.plan", body);
  const updateTrainingBudgetPlan = (body) =>
    api.put("command/update.budget.plan", body);
  const deleteTrainingBudgetPlan = (body) =>
    api.post("command/delete.budget.plan", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitTrainingBudgetPlan = (body) =>
    api.post("submit.trn.budget", body);
  const submitTrainingBudgetPlanLvl1 = (body) =>
    api.post("submit.approve.trn.budget.eo.sdm", body);
  const submitTrainingBudgetPlanLvl2 = (body) =>
    api.post("submit.approve.trn.budget.dd.sdm", body);
  const submitTrainingBudgetPlanLvl3 = (body) =>
    api.post("submit.approve.trn.budget.biro.direksi", body);
  const submitTrainingBudgetPlanLvl4 = (body) =>
    api.post("submit.approve.trn.budget.presdir", body);

  //TRAINING EXECUTION
  const getTrainingExecutionAll = (body) =>
    api.post("query/get.trn.execution.all.optimize", body);
  const getTrainingExecutionEmpYear = (body) =>
    api.get("query/get.trn.execution.by.emp.and.year/" + body);
  const getTrainingExecutionPaging = (body) =>
    api.post("query/get.trn.execution.by.esid.and.search", body);
  const getCountTrainingExecutionPaging = (body) =>
    api.post("query/count.trn.execution.by.esid.and.search", body);
  const getTrainingExecutionAllFull = (body) =>
    api.post("query/get.trn.execution.all", body);
  const getTrainingExecutionByID = (body) =>
    api.get("query/get.trn.execution.by.id/" + body);
  const postTrainingExecution = (body) =>
    api.post("command/post.trn.execution", body);
  const updateTrainingExecution = (body) =>
    api.put("command/update.trn.execution", body);
  const deleteTrainingExecution = (body) =>
    api.post("command/delete.trn.execution", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //SOCIALIZATION
  const getSocializationAll = (body) =>
    api.post("query/get.socialization.all", body);
  const getSocializationByID = (body) =>
    api.get("query/get.socialization.by.id/" + body);
  const getSocializationPaging = (body) =>
    api.post("query/get.socialization.by.esid.and.search", body);
  const getCountSocializationPaging = (body) =>
    api.post("query/count.socialization.by.esid.and.search", body);
  const getSocializationByEmpExecution = (body) =>
    api.post("query/get.socialization.by.emp.and.execution", body);
  const getCountSocializationByEmpExecution = (body) =>
    api.post("query/count.socialization.by.emp.and.execution", body);
  const postSocialization = (body) =>
    api.post("command/post.socialization", body);
  const uploadSocializationDoc = (body, config) =>
    api.post("/upload.document.socialization", body, config);
  const updateSocialization = (body) =>
    api.put("command/update.socialization", body);
  const deleteSocialization = (body) =>
    api.post("command/delete.socialization", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitSocialization = (body) =>
    api.post("submit.trn.socialization", body);
  const submitSocializationKpoSokl = (body) =>
    api.post("submit.approval.trn.socialization.kpo.sokl", body);
  const submitSocializationKpoEo = (body) =>
    api.post("submit.approval.trn.socialization.kpo.eo", body);
  const submitSocializationKpnoPresdir = (body) =>
    api.post("submit.approval.trn.socialization.kpno.presdir", body);
  const submitSocializationKpnoEo = (body) =>
    api.post("submit.approval.trn.socialization.kpno.eo", body);
  const submitSocializationKpnoDd = (body) =>
    api.post("submit.approval.trn.socialization.kpno.dd", body);
  const submitSocializationKpnoAssdir = (body) =>
    api.post("submit.approval.trn.socialization.kpno.assdir", body);
  const submitSocializationKkSokl = (body) =>
    api.post("submit.approval.trn.socialization.kk.sokl", body);
  const submitSocializationKcpSokl = (body) =>
    api.post("submit.approval.trn.socialization.kcp.sokl", body);
  const submitSocializationKcpEo = (body) =>
    api.post("submit.approval.trn.socialization.kcp.eo", body);
  const submitSocializationKciSokl = (body) =>
    api.post("submit.approval.trn.socialization.kci.sokl", body);
  const submitSocializationKciEo = (body) =>
    api.post("submit.approval.trn.socialization.kci.eo", body);

  //SETTLEMENT
  const getTrainingSettlementAll = (body) =>
    api.post("query/get.training.settlement.all.optimize", body);
  const getTrainingSettlementByID = (body) =>
    api.get("query/get.training.settlement.by.id/" + body);
  const getTrainingSettlementByPaging = (body) =>
    api.post("query/get.settlement.by.esid.and.search", body);
  const getCountTrainingSettlementByPaging = (body) =>
    api.post("query/count.settlement.by.esid.and.search", body);
  const getTrainingSettlementAllFull = (body) =>
    api.post("query/get.training.settlement.all", body);
  const postTrainingSettlement = (body) =>
    api.post("command/post.training.settlement", body);
  const uploadTrainingSettlementDoc = (body, config) =>
    api.post("/upload.document.training.settlement", body, config);
  const updateTrainingSettlement = (body) =>
    api.put("command/update.training.settlement", body);
  const deleteTrainingSettlement = (body) =>
    api.post("command/delete.training.settlement", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitTrainingSettlement = (body) =>
    api.post("submit.trn.budget.settlement", body);
  const submitTrainingSettlementLvl1 = (body) =>
    api.post("submit.approve.trn.budget.settlement.eo.sdm", body);
  const submitTrainingSettlementLvl2 = (body) =>
    api.post("submit.approve.trn.budget.settlement.dd.sdm", body);
  const submitTrainingSettlementLvl3 = (body) =>
    api.post("submit.approve.trn.budget.settlement.biro.direksi", body);
  const submitTrainingSettlementLvl4 = (body) =>
    api.post("submit.approve.trn.budget.settlement.presdir", body);

  //TRAINING EVALUATION
  const getTrainingEvaluationAll = (body) =>
    api.post("query/get.evaluation.all", body);
  const getTrainingEvaluationByID = (body) =>
    api.get("query/get.evaluation.by.id/" + body);
  const getTrainingEvaluationAllPaging = (body) =>
    api.post("query/get.evaluation.by.esid.and.search", body);
  const getCountTrainingEvaluationAllPaging = (body) =>
    api.post("query/count.evaluation.by.esid.and.search", body);
  const getTrainingEvaluationByEmpExecution = (body) =>
    api.post("query/get.evalution.by.emp.and.execution", body);
  const getCountTrainingEvaluationByEmpExecution = (body) =>
    api.post("query/count.evalution.by.emp.and.execution", body);
  const postTrainingEvaluationNew = (body) =>
    api.post("command/post.evaluation", body);
  const updateTrainingEvaluationNew = (body) =>
    api.put("command/update.evaluation", body);
  const deleteTrainingEvaluationNew = (body) =>
    api.post("command/delete.evaluation", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  const submitTrainingEvaluation = (body) =>
    api.post("submit.trn.evaluation", body);
  const submitTrainingEvaluationLvl1 = (body) =>
    api.post("submit.approve.trn.evaluation.stf.pelatihan", body);
  const submitTrainingEvaluationLvl2 = (body) =>
    api.post("submit.approve.trn.evaluation.eo.diklat", body);

  //TRAINING BIDD
  const getTrainingBidd = (body) => api.get("get.bidd/" + body);
  const getTrainingBiddAll = (body) => api.post("get.bidd.all", body);
  const postTrainingBidd = (body) => api.post("post.training.bidd", body);
  const updateTrainingBidd = (body) => api.put("update.training.bidd", body);
  const deleteTrainingBidd = (body) =>
    api.post("delete.training.bidd", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //TRAINING BIDD NEW

  const getTrainingBiddNew = (body) =>
    api.get("query/get.training.new.bidd.by.id/" + body);
  const getTrainingBiddAllNew = (body) =>
    api.post("query/get.training.new.bidd.all", body);
  const getCountTrainingBiddSearch = (body) =>
    api.post("query/count.training.new.bidd.by.search", body);
  const getTrainingBiddSearch = (body) =>
    api.post("query/get.training.new.bidd.by.search", body);
  const postTrainingBiddNew = (body) =>
    api.post("command/post.training.new.bidd", body);
  const updateTrainingBiddNew = (body) =>
    api.put("command/update.training.new.bidd", body);
  const deleteTrainingBiddNew = (body) =>
    api.post("command/delete.training.new.bidd", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //TRAINING BIDD TPL
  const getTrainingBiddTplAll = (body) =>
    api.post("get.all.bidd.training.tpl", body);
  const getTrainingBiddTplPaging = (body) =>
    api.post("/get.all.bidd.training.tpl.by.esid.and.search", body);
  const getCountTrainingBiddTplPaging = (body) =>
    api.post("/count.all.bidd.tpl.by.esid.and.search", body);
  const postTrainingBiddTpl = (body) =>
    api.post("post.bidd.training.tpl", body);
  const updateTrainingBiddTpl = (body) =>
    api.put("update.bidd.training.tpl", body);
  const deleteTrainingBiddTpl = (body) =>
    api.post("delete.bidd.training.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //TRAINING MEMO
  const getTrainingMemoAll = (body) => api.post("query/get.memo.all", body);
  const getTrainingMemoPaging = (body) =>
    api.post("query/get.memo.by.esid.and.search", body);
  const getTrainingMemoByID = (body) => api.get("query/get.memo.by.id/" + body);
  const getCountTrainingMemoPaging = (body) =>
    api.post("query/count.memo.by.esid.and.search", body);
  const postTrainingMemo = (body) =>
    api.post("command/post.training.memo", body);
  const updateTrainingMemo = (body) =>
    api.put("command/update.training.memo", body);
  const deleteTrainingMemo = (body) =>
    api.post("command/delete.training.memo", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  //TRAINING MEMO PROPOSAL
  const getTrainingMemoProposalAll = (body) =>
    api.post("query/get.memo.proposal.all", body);
  const getTrainingMemoProposalPaging = (body) =>
    api.post("query/get.memo.proposal.by.esid.and.search", body);
  const getTrainingMemoProposalByID = (body) =>
    api.get("query/get.memo.proposal.by.id/" + body);
  const getCountTrainingMemoProposalPaging = (body) =>
    api.post("query/count.memo.proposal.by.esid.and.search", body);
  const postTrainingMemoProposal = (body) =>
    api.post("command/post.training.memo.proposal", body);
  const updateTrainingMemoProposal = (body) =>
    api.put("command/update.training.memo.proposal", body);
  const deleteTrainingMemoProposal = (body) =>
    api.post("command/delete.training.memo.proposal", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const submitLoanDdSdm = (body) =>
    api.post("/submit.approve.loan.dd.sdm", body);
  const submitLoanEoDiklat = (body) =>
    api.post("/submit.approve.loan.eo.diklat", body);
  const submitLoanEoKompensasi = (body) =>
    api.post("/submit.approve.loan.eo.kompensasi", body);
  const submitLoanStfPinjaman = (body) =>
    api.post("/submit.approve.loan.stf.pinjaman.karyawan", body);
  const submitLoanEmpHead = (body) =>
    api.post("/submit.approve.loan.emp.head", body);
  const submitLoanDir = (body) => api.post("/submit.approve.loan.dir", body);
  const submitLoanDirSdm = (body) =>
    api.post("/submit.approve.loan.dir.sdm", body);
  const submitLoanStfPinjamanFinal = (body) =>
    api.post("/submit.approve.loan.stf.pinjaman.karyawan.final.approve", body);

  // SHIFT TIME UNIT
  const getShiftTimeUnit = (body) =>
    api.post("/get.shift.time.unit.for.web", body);
  const postShiftTimeUnit = (body) => api.post("/post.shift.time.unit", body);
  const updateShiftTimeUnit = (body) => api.put("/put.shift.time.unit", body);
  const deleteShiftTimeUnit = (body) =>
    api.post("/delete.shift.time.unit", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // SHIFT TPL
  const getShiftTpl = (body) =>
    api.post("/get.all.shift.template.for.monitoring", body);
  const postShiftTpl = (body) => api.post("/post.shift.template", body);
  const updateShiftTpl = (body) => api.put("/update.shift.template", body);
  const deleteShiftTpl = (body) =>
    api.post("/delete.shift.template", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // SHIFT TRX
  const getShiftBatchByID = (body) =>
    api.get("/query/get.shift.new.by.batch.shift.id/" + body);
  const updateShiftByBatchID = (body) =>
    api.put("/command/put.shift.new.by.batch.shift.id", body);
  const getShiftNew = (body) =>
    api.post("/query/get.all.shift.new.monitoring", body);
  const postShiftNew = (body) => api.post("/command/post.shift.new", body);
  const updateShiftNew = (body) => api.put("/command/put.shift.new", body);
  const deleteShiftNew = (body) =>
    api.post("/delete.shift.new", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getPositionNew = (body) =>
    api.get("/get.es.detail.children.eo.flat.by.id/" + body);

  // Training Participant TPL
  const getParticipantTpl = (body) =>
    api.post("/get.all.participant.tpl", body);
  const getParticipantTplByID = (body) =>
    api.get("/get.participant.tpl.by.id/" + body);
  const postParticipantTpl = (body) => api.post("/post.participant.tpl", body);
  const updateParticipantTpl = (body) =>
    api.put("/update.participant.tpl", body);
  const deleteParticipantTpl = (body) =>
    api.post("/delete.participant.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  // IDP ROLE GROUP
  const getRoleGroupByStatus = (body) =>
    api.post("get.all.role.group.by.status", body);
  const countGetRoleGroupByStatus = (body) =>
    api.get("/get.count.role.group.by.status/" + body);
  const postRoleGroup = (body) => api.post("/post.role.group", body);
  const updateRoleGroup = (body) => api.put("/update.role.group", body);
  const deleteRoleGroup = (body) =>
    api.post("/delete.role.group", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getReqCertificate = (body) =>
    api.post("query/get.request.certificate.by.employee.id", body);
  const getReqCertificateByID = (body) =>
    api.get("query/get.request.certificate.by.id/" + body);
  const postReqCertificate = (body) =>
    api.post("command/post.request.certificate", body);
  const putReqCertificate = (body) =>
    api.put("command/put.request.certificate", body);
  const deleteReqCertificate = (body) =>
    api.post("command/delete.request.certificate", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const submitCertificate = (body) =>
    api.post("submit.request.certificate.skk", body);
  const submitCertificateHead = (body) =>
    api.post("submit.approval.request.certificate.skk.employee.head", body);
  const submitCertificateStaff = (body) =>
    api.post("submit.approval.request.certificate.skk.staff.bpo", body);
  const submitCertificateEo = (body) =>
    api.post("submit.approval.request.certificate.skk.eo.sdm", body);
  const submitCertificateDd = (body) =>
    api.post("submit.approval.request.certificate.skk.dd.sdm", body);
  const submitCertificatePresdir = (body) =>
    api.post("submit.approval.request.certificate.skk.presdir", body);

  const getEvaluationParticipantByEmployeeName = (body) =>
    api.get(
      "/query/get.evaluation.participant.by.employee.and.name.and.execution/" +
        body
    );

  const getTrainingEvaluationTpl = (body) =>
    api.post("get.all.evaluation.tpl", body);
  const getTrainingEvaluationTplByID = (body) =>
    api.get("get.evaluation.tpl.by.id/" + body);
  const postTrainingEvaluationTpl = (body) =>
    api.post("post.evaluation.tpl", body);
  const putTrainingEvaluationTpl = (body) =>
    api.put("update.evaluation.tpl", body);
  const deleteTrainingEvaluationTpl = (body) =>
    api.post("delete.evaluation.tpl", body, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

  const getTrainingNEH = (body) => api.post("get.event.source.all", body);
  const getTrainingNEHPaging = (body) =>
    api.post("query/get.event.source.by.search", body);
  const getCountTrainingNEHPaging = (body) =>
    api.post("query/count.event.source.by.search", body);
  const getTrainingRemainingBudget = (body) =>
    api.get("get.remaining.budget/" + body);
  const getTrainingRemainingBudgetBidd = (body) =>
    api.get("get.remaining.budget.bidd/" + body);

  const getTrainingObservationByObIDExecutionSearch = (body) =>
    api.post("/query/get.observation.by.obid.and.execution.and.search", body);

  const postChangePassword = (body) =>
    api.post("UserAuthentication/changePassword", body);
  const getUserProfile = (body) => api.post("Employee/getUserProfile", body);

  const logout = (body) => api.post("/api/security/logout", body);
  const findUserById = (id) => api.get("Employee/findByUserId/" + id);

  const printStockOpname = (body) =>
    api.post("StockOpname/stockOpnamePrint", body);
  const getInvoicePenagihanLeasing = (body) =>
    api.post("CetakanLeasingPayment/generateInvoice", body);
  const getLetterCoverPenagihanLeasing = (body) =>
    api.post("CetakanLeasingPayment/generateCetakanLetterCoverNote", body);
  const updatePrintCountLetterCoverPenagihanLeasing = (id) =>
    api.put("LeasingPayment/updatePrintCount?leasingBillingId=" + id);
  const generateCetakanPengajuanSamsat = (body) =>
    api.post("TransactionSamsat/generateCetakanPengajuan", body);
  const generateCetakanPenyerahanBBNLeasing = (body) =>
    api.post("Bbn/generateTemplateHandOverBpkbLeasing", body);

  const getPrintCount = (body) => api.post("PrintCount/getPrintCount", body);
  const updatePrintCount = (body) =>
    api.post("PrintCount/updatePrintCount", body);

  // master service
  const masterServiceMainPage = (body) =>
    api.post("MasterService/main-page", body);
  const masterServiceDetail = (id) => api.get("MasterService/detail" + id);
  const masterServiceUpdateStatus = (body) =>
    api.post("MasterService/update-status", body);
  const masterServiceDelete = (id) => api.delete("MasterService/delete" + id);
  const masterServiceSubmit = (body) =>
    api.post("MasterService/submit-service", body);
  const masterServiceDownloadExcel = () =>
    api.get("MasterService/generate-excel");
  const masterServiceUploadExcel = (body) =>
    api.post("MasterService/upload-excel", body);
  const masterServiceDownloadLogError = (body) =>
    api.get("MasterService/download-log-excel", body);

  const salesOrderUpdateStatus = (body) =>
    api.post("SalesOrder/updateStatus", body);
  const checkPOUnitExist = (params) =>
    api.get("POUnit/checkPOUnitExists", params);
  const getVerifyStockOpname = (stockOpnameType, kodeCabang, kodeLocation) =>
    api.get(
      `StockOpname/verifyStockOpname?stockOpnameType=${stockOpnameType}&kodeCabang=${kodeCabang}&kodeLocation=${kodeLocation}`
    );
  const downloadReceivingKSUExcel = (body) =>
    api.post("ReceivingKsu/exportReceivingKSUToExcel", body);
  const downloadReceivingUnitNOSExcel = (body) =>
    api.post("ReceivingUnit/exportReceivingUnitNosToExcel", body);
  const downloadReceivingUnitDGIExcel = (body) =>
    api.post("ReceivingUnit/exportReceivingUnitToExcel", body);

  // Management Approval
  const getAllManagementApproval = (body) =>
    api.post("Approval/getMainPage", body);
  const getDetailManagementApproval = (id) =>
    api.get(`Approval/getDetail?idApproval=${id}`);
  const submitManagementApproval = (body) =>
    api.post("Approval/submitApproval", body);

  const printBBKRealizationReport = (body) =>
    api.post("PaymentBank/generatePaymentBankWithdrawalSummary", body);
  const printBBMRealizationReport = (body) =>
    api.post("PaymentBank/generateReportBBM", body);
  const printBKKRealizationReport = (body) =>
    api.post("PaymentCash/printLaporanPengeluaranCash", body);
  const printBKMRealizationReport = (body) =>
    api.post("PaymentCash/printLaporanPenerimaanCash", body);
  const downloadInventoryUnitExcel = (body) =>
    api.post("Inventory/Unit/exportExcelReportMainPage", body);
  const exportPOUnitDetailToExcel = (body) =>
    api.post(`POUnit/exportPOUnitDetailToExcel`, body);
  const getAllMenuForApproval = () =>
    api.get("MasterMenu/getAllMenuForApproval");
  const exportToExcelApproval = (body) =>
    api.post("Approval/exportToExcel", body);

  // Management NFRS
  const getAllManagementNRFS = (body) =>
    api.post("TransactionUnit/getListNRFSUnit", body);
  const updateNRFSUnit = (body) =>
    api.post("TransactionUnit/updateNRFSUnit", body);

  const checkPrintQRKSUApproval = (body) =>
    api.post("ApprovalPrint/checkPrintBarcode", body);
  const createApprovalPrint = (body) =>
    api.post("ApprovalPrint/createApprovalPrint", body);

  const checkApprovalPrintBKK = (body) =>
    api.post("ApprovalPrint/checkPrintPayment", body);
  // Master COA
  const getAllMasterCOA = (body) => api.post("MasterCoa/findAll", body);
  const updateStatusMasterCOA = (body) =>
    api.post("MasterCoa/updateStatus", body);
  const deleteMasterCOA = (id) => api.delete(`MasterCoa/delete?coaId=${id}`);
  const generateMasterCOAId = (body) => api.get("MasterCoa/generateCoaId");
  const getMasterCOAById = (body) => api.get("MasterCoa/findById" + body);
  const saveMasterCOA = (body) => api.post("MasterCoa/saveUpdate", body);
  const findDetailCoaPayment = (body) =>
    api.get("MasterCoa/findDetailCoaPayment" + body);

  // Master Sopir
  const getMasterSopirData = (body) =>
    api.post("MasterDriver/findMainPage", body);
  const updateStatusSopir = (id) =>
    api.put(`MasterDriver/updateStatus?id=${id}`);
  const deleteSopirById = (id) =>
    api.delete(`MasterDriver/deleteById?id=${id}`);
  const getDetailSopirByDriverId = (body) =>
    api.get("MasterDriver/findByDriverId", body);
  const getEmployeeForDriver = (body) =>
    api.get("Employee/getEmployeeForDriver", body);
  const saveUpdateMasterSopir = (body) =>
    api.post("MasterDriver/saveUpdate", body);
  const getAllUserForMasterDriver = () =>
    api.get("MasterUser/getAllUserForMasterDriver");
  const getAllIdUserDriver = () => api.get("MasterDriver/findAllIdUserDriver");
  const getMasterUserById = (id) => api.get(`MasterUser/getByIdUser/${id}`);
  const findEmployeeByUserId = (id) =>
    api.get(`Employee/findEmployeeByUserId/${id}`);
  const getCabangByIdUser = (id) =>
    api.get(`Employee/getProfileUser?idUser=${id}`);

  const getDriverForEkspedisi = (kodeCabang) =>
    api.get(`MasterDriver/getDriverForExpedisi/${kodeCabang}`);
  const checkApprovalPrintTransaction = (body) =>
    api.post("ApprovalPrint/checkPrintPayment", body);

  const cetakInventoryMainPage = (body) =>
    api.post("Inventory/KSU/exportExcelReportMainPage", body);

  const getBBNPhotoById = (body) => api.post("Bbn/getPhotoByIdDetail", body);

  const manualTriggerGetFJDgi = (body) =>
    api.post("SalesOrderDGI/fetchManualDGI", body);

  const updateSuperAccess = (body) =>
    api.put("MasterRole/updateSuperAccess", body);

  const getMainDealerForSalesOrderDGI = (body) =>
    api.post("mstSupplier/getMainDealerForSalesOrderDGI", body);

  const findCabangForSalesOrderDGI = (body) =>
    api.post("MasterCabang/findCabangForSalesOrderDGI", body);

  const getDropDownListMenuForMasterUser = (body) =>
    api.get("MasterRole/dropDownListForMasterUser", body);

  const cetakExcelPenagihanLeasing = (body) =>
    api.post("LeasingPayment/generateLeasingPaymentReport", body);

  // Master Booking
  const getAllMasterBooking = (body) =>
    api.post("MasterBooking/findMainPage", body);
  const saveMasterBooking = (body) =>
    api.post("MasterBooking/saveUpdate", body);
  const deleteMasterBooking = (id) =>
    api.delete(`MasterBooking/delete?bookingId=${id}`);

  //master mekanik
  const getAllMasterMechanic = (body) =>
    api.post("Mechanic/getDataMechanicMainPage", body);
  const getEmployeeForMechanic = (body) =>
    api.get("Employee/getEmployeeForMechanic", body);
  const createMechanic = (body) => api.post("Mechanic/submitMechanic", body);
  const deleteMechanic = (body) => api.delete("Mechanic/deleteMechanic", body);

  //master acuan stock
  const createMasterAcuanStock = (body) =>
    api.post("MasterAcuanStock/submitdata", body);
  const getMasterAcuanStock = (body) =>
    api.post("MasterAcuanStock/getMainPage", body);
  const getDetailMasterAcuanStock = (body) =>
    api.get("MasterAcuanStock/getDetail", body);
  const deleteMasterAcuan = (body) =>
    api.delete("MasterAcuanStock/deletedata", body);
  const getCopyMasterAcuanStock = (body) =>
    api.get("MasterAcuanStock/getCopyData", body);

  //master harga jasa
  const getMainPageMasterHargaJasa = (body) =>
    api.post("MasterServicePrice/getDataMainPage", body);
  const createMasterHargaJasa = (body) =>
    api.post("MasterServicePrice/saveUpdate", body);
  const getDetailMasterHargaJasa = (body) =>
    api.get("MasterServicePrice/getDetail", body);
  const downloadTemplateExcelMasterHargaJasa = (body) =>
    api.get("MasterServicePrice/exportTemplate", body);
  const uploadExcelMasterHargaJasa = (body) =>
    api.post("MasterServicePrice/uploadExcelData", body);
  const updateStatusMasterHargaJasa = (body) =>
    api.post("MasterServicePrice/updateStatus", body);
  const downloadLogExcelMasterHargaJasa = () =>
    api.get("MasterServicePrice/downloadLogExcel");

  // Master Harga Part
  const getAllMasterPartPrice = (body) =>
    api.post("MasterPartPrice/findMainPage", body);
  const getMasterPartPriceById = (id) =>
    api.get(`MasterPartPrice/findByPartPriceId?partPriceId=${id}`);
  const getQrFormatWithoutCabang = (body) =>
    api.get("GenericSeq/getQrFormatWithoutCabang", body);
  const createMasterPartPrice = (body) =>
    api.post("MasterPartPrice/saveUpdate", body);
  const deleteMasterPartPrice = (id) =>
    api.delete(`MasterPartPrice/deleteByPartPriceId?partPriceId=${id}`);
  const getCabangbyMainDealer = (id) =>
    api.get(`mstSupplier/getByKodeSupplier?kodeSupplier=${id}`);
  const getTemplateExcelMasterPartPrice = () =>
    api.get("MasterPartPrice/getTemplateExcelMasterPartPrice");
  const uploadTemplateMasaterPartPrice = (body) =>
    api.post("MasterPartPrice/uploadExcelData", body);
  const getDownloadLogErrorPartPrice = (body) =>
    api.post("MasterPartPrice/downloadErrorLog", body);

  // Master Promo H23
  const getMainPagePromoH23 = (body) =>
    api.post("MasterPromoH2/getMainPage", body);
  const getPreviewIdMasterPromoH23 = () =>
    api.get("MasterPromoH2/previewIdPromo");
  const getDetailMasterPromoH23 = (body) =>
    api.get("MasterPromoH2/getDetail" + body);
  const createMasterPromoH23 = (body) =>
    api.post("MasterPromoH2/saveAndUpdate", body);
  const deleteMasterPromoH2 = (id) =>
    api.delete(`MasterPromoH2/deleteData?id=${id}`);
  const getCopyDataPromoH2 = (body) =>
    api.post("MasterPromoH2/getCopyData" + body);
  const getServicePromoH23 = (body) =>
    api.post("MasterService/get-list-for-promo", body);
  const findAllByListKey = (body) => api.post("MasterBizpar/findAllByListKey", body);

  //management mekanik
  const getDataMechanicManagementMainPage = (body) =>
    api.post("MechanicManagement/getDataMechanicManagementMainPage", body);
  const submitMechanicManagement = (body) =>
    api.post("MechanicManagement/submitMechanicManagement", body);
  const getDetailMechanicManagement = (body) =>
    api.get("MechanicManagement/getDetailMechanicManagement", body);
  const checkMonthMechanicManagement = (body) =>
    api.post("MechanicManagement/checkMonth", body);

  //management booking
  const getDataManagementBooking = (body) =>
    api.post("ManagementBooking/findMainPage", body);
  const getDetailManagementBooking = (body) =>
    api.get("ManagementBooking/findByManagementBookingId", body);
  const submitManagementBooking = (body) =>
    api.post("ManagementBooking/saveUpdate", body);
  const printExcelManagementBooking = (body) =>
    api.post("ManagementBooking/exportMainPageToExcel", body);
  const getTimeForManagementBooking = (body) =>
    api.post("MasterBooking/getListForManagementBooking", body);

  // Receiving Other Items
  const getMainPageReceivingOtherItem = (body) =>
    api.post("ReceivingOtherItem/findDataMainPage", body);
  const submitReceivingOtherItem = (body) =>
    api.post("ReceivingOtherItem/saveAndUpdate", body);
  const getDetailReceivingOtherItem = (body) =>
    api.get("ReceivingOtherItem/findBySpblNo" + body);
  const checkQtyOtherItem = (body) =>
    api.post("ReceivingOtherItem/checkToUpdateQtyOtherItem", body);
  const downloadReceivingItemsExcel = (body) =>
    api.post("ReceivingOtherItem/exportMainPageReceivingOtherToExcel", body);
  const updateNumberOfPrintQRCodeItems = (body) =>
    api.put("ReceivingOtherItem/updateNumbersOfPrintsBarcode", body);
  const deleteReceivingOtherItem = (body) =>
    api.delete("ReceivingOtherItem/delete" + body);

  // Master Package H23
  const getDataMainPagePackageH2 = (body) =>
    api.post("PackageH2/getDataMainPage", body);
  const generateMasterPackageH2Id = (body) => api.get("PackageH2/previewId");
  const getMasterPackageH2ById = (body) =>
    api.get("PackageH2/getDetail" + body);
  const getVariantBySegmentId = (body) =>
    api.get("Variant/getVariantBySegment" + body);
  const updateStatusMasterPackageH2 = (body) =>
    api.put(`PackageH2/updateStatus` + body);
  const copyMasterPackageH2 = (body) => api.post("PackageH2/copy", body);
  // const getServiceForPackage = () =>
  //   api.get("MasterService/getServiceForPackage");
  const getServiceForPackage = (params) =>api.get("MasterService/getServiceForPackage" + params);
  const getPartForPackage = () => api.get("Part/getPartForPackage");
  const saveMasterPackageH2 = (body) => api.post("PackageH2/submit", body);

  // Receiving Part H23
  const getAllReceivingPartNOSByParam = (body) =>
    api.post("TransactionReceivingPart/getMainPage", body);
  const getReceivingPartNOSById = (body) =>
    api.get("TransactionReceivingPart/getById" + body);
  const submitReceivingPartNOS = (body) =>
    api.post("TransactionReceivingPart/saveAndUpdate", body);
  const deleteReceivingPartNOS = (body) =>
    api.delete("TransactionReceivingPart/deleteById" + body);
  const getAllReceivingPartDGI = (body) =>
    api.post("ReceivingPart/getMainPage", body);
  const getAllReceivingPartDGIBy = (body) =>
    api.get("ReceivingPart/getById" + body);
  const updateReceivingPartDGI = (body) =>
    api.put("ReceivingPart/getProcess", body);
  const checkNonQrCanUpdate = (body) =>
    api.post("TransactionPartMoving/checkNonQrCanUpdate", body);
  const updateNumberOfPrintQRCodePartNOS = (body) =>
    api.put("TransactionPartMoving/updatePrintBarcode", body);
  const generateExcelPart = (body) =>
    api.post("Excel/generateFromPayload", body);
  const generateExcelFromPayload = (body) =>
    api.post("Excel/generateFromPayload", body);
  const generateAdvancedExcelFromPayload = (body) =>
    api.post("Excel/generateAdvanced", body);

  // Receiving Gift
  const submitReceivingGift = (body) => api.post("ReceivingGift/submit", body);
  const getDataMainPageReceivingGit = (body) =>
    api.post("ReceivingGift/getDataMainPage", body);
  const getDetailReceivingGift = (body) =>
    api.get("ReceivingGift/getDetail", body);
  const checkQtyGift = (body) =>
    api.post("ReceivingGift/checkToUpdateQtyGift", body);
  const deleteReceivingGift = (body) =>
    api.delete("ReceivingGift/delete", body);
  const downloadReceivingGiftExcel = (body) =>
    api.post("ReceivingGift/exportExcel", body);
  const updateNumberOfPrintsReceivingGift = (body) =>
    api.put("ReceivingGift/updateNumberOfPrints", body);

  //Mutasi Part
  const getAllMutationPart = (body) => api.post("MutationH3/getMainPage", body);
  const getMutationPartById = (id) => api.get(`MutationH3/getDetail?id=${id}`);
  const deleteMutationPart = (body) =>
    api.delete(`MutationH3/deleteData?id=${body}`);
  const submitDataMutationPart = (body) =>
    api.post("MutationH3/submitData", body);
  const processMutationPart = (body) =>
    api.put("MutationH3/processMutationIn", body);
  const findBarcodePartMutation = (body) =>
    api.post("MutationH3/findBarcodePart", body);
  const rejectAllMutationPart = (id) =>
    api.put(`MutationH3/rejectAll?id=${id}`);
  const generatePrintMutationPart = (body) =>
    api.post("MutationPartReport/generatePrintMutationPart", body);
  const generatePrintExcelMutationPart = (body) =>
    api.post("MutationH3/exportExcel", body);

  //dashboard kacab tab indent
  const getLaporanInden = (body) => api.post("Dashboard/getLaporanInden", body);

  const getGiftForStockOpname = (body) =>
    api.post("StockOpnameGift/getDataForStockOpname", body);
  const getPartForStockOpname = (body) =>
    api.post("StockOpnamePart/getDataForStockOpnamePart", body);
  const getDetailStockOpnamePart = (body) =>
    api.get("StockOpnamePart/getStockOpnamePartByStockOpnameId" + body);

  const getSalesDropdownForDashboard = (body) =>
    api.get("Employee/salesDropDownListForDashboard", body);

  const getTLByEmployeeId = (body) =>
    api.get("Employee/getTLByEmployeeId", body);

  const getStockOpnameGiftDetail = (body) =>
    api.get("StockOpnameGift/getStockOpnameGiftDetail" + body);

  const getOtherItemForStockOpname = (body) =>
    api.post("StockOpnameOtherItem/getStockOpnameOtherItem", body);

  const getStockOpnameOtherItemDetail = (body) =>
    api.get("StockOpnameOtherItem/getByStockOpnameNo" + body);
  const submitProcessStockOpnameOtherItem = (body) =>
    api.post("StockOpnameOtherItem/saveUpdate", body);

  //management claim
  const getManagementClaimMainPage = (body) =>
    api.post("ManagementClaim/getMainPage", body);
  const getDetailManagementClaim = (body) =>
    api.get("ManagementClaim/getDetail", body);
  const getListBBMManagementClaim = (body) =>
    api.post("ManagementClaim/getListBBM", body);
  const getListBKKBBKManagementClaim = (body) =>
    api.get("ManagementClaim/getListBbkBkk", body);
  const checkUnitManagementClaim = (body) =>
    api.post("ManagementClaim/checkUnitForManagementClaim", body);
  const getNamaPelaporManagementClaim = (body) =>
    api.get("Employee/reporterForDropDownList", body);
  const getPartManagementClaim = (body) =>
    api.post("Part/findByParamForManagementClaim", body);
  const saveUpdateManagementClaim = (body) =>
    api.post("ManagementClaim/saveUpdate", body);
  const updateStatusManagementClaim = (body) =>
    api.post("ManagementClaim/updateStatus", body);

  //inventory part
  const getExcelReportMainPageInventoryPart = (body) =>
    api.post("InventoryH3/exportExcelReportMainPage", body);
  const getInventoryPartMainPage = (body) =>
    api.post("InventoryH3/getMainPage", body);
  const getDetailInventoryPart = (body) =>
    api.get("InventoryH3/getDetailPartWithQr", body);
  const getBarcodeHistoryInventoryPart = (body) =>
    api.get("InventoryH3/getHistoryFromBarcode", body);
  const getStockInventoryPart = (body) =>
    api.post("InventoryH3/getCardStock", body);
  const getStockHistoryInventoryPartWithQR = (body) =>
    api.post("InventoryH3/getSpecificDateHistoryPartWithQr", body);
  const getStockHistoryInventoryPartNonQR = (body) =>
    api.post("InventoryH3/getSpecificDateHistoryPartWithoutQr", body);
  const findBarcodePartInventory = (body) =>
    api.get("InventoryH3/findBarcodePartInventory", body);

  //fjb
  const getMechanicNameFjb = (body) =>
    api.post("Employee/getMechanicByCabangList", body);
  const getDetailNosinFjb = (body) =>
    api.get("TransactionUnit/getByNosin", body);
  const getDataClaimFjb = (body) =>
    api.get("ManagementClaim/getByCustomerNameAndKodeCabangAndClaimType", body);
  const getUserProfileByNoSin = (body) =>
    api.get("CustomerProfile/getByNosin", body);
  const getLocatorDataTransactionFjb = (body) =>
    api.post("MasterLocation/getAllLocationsByListKodeCabang", body);
  const getDataPackageFjb = (body) =>
    api.get("PackageH2/getByKodeVariantAndKodeCabangAndServiceDate", body);
  const getJasaFjb = (body) => api.post("MasterService/getByFJBParams", body);
  const getPartFJB = (body) => api.post("Part/getByParam", body);
  const getFJBNOSMainPage = (body) =>
    api.post("OrderServicePart/getByFJBParams", body);
  const submitFjbNOS = (body) => api.post("OrderServicePart/submit", body);
  const getPromoFjb = (body) => api.post("MasterPromoH2/getByFJBParams", body);
  const getHeaderFjbNos = (body) => api.get("OrderServicePart/getById", body);
  const getTabDataUnitNos = (body) =>
    api.get("OrderServicePart/getUnitByOrderServicePartId", body);
  const getTabDataPemilikNos = (body) =>
    api.get("OrderServicePart/getCustomerOwnerByOrderServicePartId", body);
  const getTabDataPembawaNos = (body) =>
    api.get("OrderServicePart/getCustomerCarrierByOrderServicePartId", body);
  const getTabDataAnalisaNos = (body) =>
    api.get("OrderServicePart/getAnalysisByOrderServicePartId", body);
  const getTabTransaksiNos = (body) =>
    api.get("OrderServicePart/getTransactionDataByOrderServicePartId", body);
  const getTabTambahanNos = (body) =>
    api.get("OrderServicePart/getAdditionalInfoByOrderServicePartId", body);
  const getTabKeteranganNos = (body) =>
    api.get("OrderServicePart/getNoteByOrderServicePartId", body);
  const getPartAndJasaByPackageId = (body) =>
    api.get("PackageH2/getPartAndJasaByPackageId", body);
  const updateStatusFJB = (body) =>
    api.post("OrderServicePart/updateStatus", body);
  const getReferenceFJB = (body) => api.post("OrderServicePart/getReferenceFJB", body);
  const getPromoDetailFjb = (body) => api.get("MasterPromoH2/getDetail", body);

  const getFJBgiMainPage = (body) =>
    api.post("DGIWorkOrder/getByFJBParams", body);
  const getFJBDgiManualy = (body) =>
    api.post("DGIWorkOrder/fetchManualDGI", body);
  const getHeaderFJBDgi = (body) => api.get("DGIWorkOrder/getById", body);
  const getTabDataUnitDgi = (body) =>
    api.get("DGIWorkOrder/getUnitByNoWO", body);
  const getTabDataPemilikDgi = (body) =>
    api.get("DGIWorkOrder/getCustomerOwnerByNoWO", body);
  const getTabDataPembawaDgi = (body) =>
    api.get("DGIWorkOrder/getCustomerCarrierByNoWO", body);
  const getTabDataAnalisaDgi = (body) =>
    api.get("DGIWorkOrder/getAnalysisByNoWO", body);
  const getTabDataTransaksiDgi = (body) =>
    api.get("DGIWorkOrder/getTransactionDataByNoWO", body);
  const getTabDataTambahanDgi = (body) =>
    api.get("DGIWorkOrder/getAdditionalInfoByNoWO", body);
  const getTabDataKeteranganDgi = (body) =>
    api.get("DGIWorkOrder/getNoteByNoWO", body);
  const getStockAndPartsByLocatorFjb = (body) =>
    api.post("TransactionPart/getStockByPartsAndLocator", body);
  const generateExcelMonitoringFJb = (body) =>
    api.post("OrderServicePart/generateExcelMonitoringWorkOrder", body);
  const scanBarcodeFjb = (body) => api.get("PartQR/getByPartBarcode", body);
  const printNotaFjb = (body) =>
    api.get("OrderServicePartPrint/printOrderServicePart", body);
  const getFjbBookingNo = (body) =>
    api.get("ManagementBooking/getByCustomerNameAndKodeCabang", body);
  const getClaimPartByManagementId = (body) =>
    api.get("ManagementClaim/getClaimManagementPartByClaimManagementId", body);
  const getDealerAhmByKodeCabang = (body) => api.post("MasterCabang/findDealerAhmByListKodeCabang", body)

  // Inventory Hadiah
  const getAllInventoryGiftByParam = (body) =>
    api.post("Inventory/Gift/getDataMainPage", body);
  const getDetailInventoryGift = (body) =>
    api.post("Inventory/Gift/getInventoryGiftDetailQr", body);
  const getDetailHistoryInventoryGift = (body) =>
    api.get("Inventory/Gift/getHistoryGiftQr" + body);
  const getGiftStockCard = (body) =>
    api.post("Inventory/Gift/getStockCardGift", body);
  const getGiftStockCardDetailQR = (body) =>
    api.post("Inventory/Gift/getStockCardDetailQr", body);
  const getGiftStockCardDetailNonQR = (body) =>
    api.post("Inventory/Gift/getStockCardDetailNonQr", body);
  const generateReportExcelInventoryGift = (body) =>
    api.post("Inventory/Gift/generateReportExcel", body);

  // Inventory Barang Lain
  const getAllInventoryOtherItemByParam = (body) =>
    api.post("Inventory/others/getInventoryOthers", body);
  const getDetailInventoryOtherItem = (body) =>
    api.post("Inventory/others/getViewInventoryBarcodes", body);
  const getDetailHistoryInventoryOtherItem = (body) =>
    api.get("Inventory/others/getHistoryBarcodes" + body);
  const getOtherItemStockCard = (body) =>
    api.post("Inventory/others/getInventoryDetailOthers", body);
  const getOtherItemStockCardDetailBarcode = (body) =>
    api.post("Inventory/others/getInventoryStockDetailBarcode", body);
  const getOtherItemStockCardDetailNonBarcode = (body) =>
    api.post("Inventory/others/getInventoryStockDetailNonBarcode", body);
  const generateReportExcelInventoryOtherItem = (body) =>
    api.post("Inventory/others/generateExcelInventoryOthers", body);

  //po part
  const getPoPartMainPage = (body) =>
    api.post("PoPart/getAllPOMainPageData", body);
  const getPoPartTem = (body) => api.post("PoPart/getTem", body);
  const getPoPartListByListCategory = (body) =>
    api.post("Part/findAllPartByListCategoryPartCode", body);
  const getTemporaryDataForPOEdit = (body) =>
    api.post("PoPart/getTemporaryDataForPOEdit", body);
  const getRankingForPOPartDTO = (body) =>
    api.post("PoPart/getRankingForPOPartDTO", body);
  const checkPoPart = (body) => api.get("PoPart/checkPOPartExists", body);
  const getPoPartById = (body) => api.get("PoPart/getDetailPOPart", body);
  const deletePoPart = (body) => api.delete("PoPart/deletePoPart", body);
  const printPoPart = (body) => api.post("PoPart/exportPOPartFixToExcel", body);
  const submitPoPart = (body) => api.post("PoPart/saveUpdate", body);

  //list mechanic for dashboard h23
  const getMechanicForDropDownListDashboard = (body) => api.post("Mechanic/getMechanicForDropDownListDashboard", body) 

  //dashboard kabeng kacab crm
  const getLaporanProspectStatistikToday = (body) => api.post("Dashboard/CRMH23/getLaporanProspectStatistikToday", body)
  const getLaporanAppointmentProspect = (body) => api.post("Dashboard/CRMH23/getLaporanAppointmentProspect", body)
  const getLaporanStatistikProspectCabang = (body) => api.post("Dashboard/CRMH23/getLaporanStatistikProspectCabang", body)
  const getLaporanStatistikAsalProspek = (body) => api.post("/Dashboard/CRMH23/getLaporanStatistikAsalProspek", body)
  const getLaporanStatistikDrop = (body) => api.post("Dashboard/CRMH23/getLaporanStatistikDrop", body)
  const getLaporanStatistikKPB = (body) => api.post("Dashboard/CRMH23/getLaporanStatistikKPB", body)

  //dashboard level Mekanik dan SA
  const getLaporanJualan3TahunTerakhirH23 = (body) => api.post("Dashboard/H23/getLaporanJualPartLastThreeYear", body);
  const getLaporanPartHarianH23 = (body) => api.post("Dashboard/H23/getLaporanPartHarian", body);
  const getLaporanHarianPartByMekanik= (body) => api.post("Dashboard/H23/getLaporanPartHarianPerCabangMekanik", body); 
  const getLaporanPartEmployeeSalesMTD= (body) => api.post("Dashboard/H23/getLaporanPartEmployeeSalesMTD", body);
  const getLaporanSalesPartMTD= (body) => api.post("Dashboard/H23/getLaporanSalesPartMTD", body);
  
  //dashboard kabeng keatas
  const getLaporanServisHarianH23 = (body) => api.post("Dashboard/H23/getLaporanServisHarian", body)
  const getLaporanUnitEntryHarianByMekanikH23 = (body) => api.post("Dashboard/H23/getLaporanUnitEntryHarianByMekanik", body)
  const getLaporanJualan3TahunTerakhirByCabangH23 = (body) => api.post("Dashboard/H23/getLaporanJualPartLastThreeYearByCabang", body); 
  const getLaporanUnitServiceHarianByMekanikH23 = (body) => api.post("Dashboard/H23/getLaporanUnitServiceHarianByMekanik", body)
  const getLaporanServisMTDH23 = (body) => api.post("Dashboard/H23/getLaporanServisMTD", body)
  const getLaporanUnitEntriMTDByCabangH23 = (body) => api.post("Dashboard/H23/getLaporanUnitEntriMTDByCabang", body)
  const getLaporanLast3YearUnitServiceH23 = (body) => api.post("Dashboard/H23/getLaporanLast3YearUnitService", body)
  const getLaporanUnitServiceMTDByMechanicH23 = (body) => api.post("Dashboard/H23/getLaporanUnitServiceMTDByMechanic", body)
  const getLaporanUnitEntriMTDByMekanikH23 = (body) => api.post("Dashboard/H23/getLaporanUnitEntriMTDByMekanik", body)
  const getLaporanServiceYTDH23 = (body) => api.post("Dashboard/h23/getLaporanServiceYTD", body) //-> api ini h nya kecil, hati-hati salah, karna yang lain hnya kapital
  const getLaporanUnitEntryLastThreeYearH23 = (body) => api.post("Dashboard/h23/getLaporanUnitEntryLastThreeYear", body) //-> api ini h nya kecil, hati-hati salah, karna yang lain hnya kapital
  const getLaporanJualPartYTDByMechanicH23 = (body) => api.post("Dashboard/H23/getLaporanJualPartYTDByMechanic", body);
  const getLaporanJualPartYearToDateByCabangH23 = (body) => api.post("Dashboard/H23/getLaporanJualPartYearToDateByCabang", body); 
  const getLaporanStatistikBooking = (body) => api.post("Dashboard/H23/getLaporanStatistikBooking", body); 
  const getLaporanFJBByTypeYTD = (body) => api.post("Dashboard/H23/getLaporanFJBByTypeYTD", body); 
  const getLaporanPendapatanJobHarian = (body) => api.post("Dashboard/H23/getLaporanPendapatanJobHarian", body); 
  const getLaporanPartsInOutYearToDate = (body) => api.post("Dashboard/H23/getLaporanPartsInOutYearToDate", body); 
  const getLaporanSalesAbilityYTD = (body) => api.post("Dashboard/H23/getLaporanSalesAbilityYTD", body); 
  const getLaporanJualJobYearToDate = (body) => api.post("Dashboard/H23/getLaporanJualJobYearToDate", body); 
  const getLaporanFjbByPaket = (body) => api.post("Dashboard/H23/getLaporanFjbByPaket", body); 
  const getLaporanFjbByPromo = (body) => api.post("Dashboard/H23/getLaporanFjbByPromo", body); 
  const getLaporanPartBranchSalesMTD = (body) => api.post("Dashboard/H23/getLaporanPartBranchSalesMTD", body); 
  const getLaporanUnitServisNonKpbMTD = (body) => api.post("Dashboard/H23/getLaporanUnitServisNonKpbMTD", body); 
  const getLaporanUnitServisNonKpbLastThreeYear = (body) => api.post("Dashboard/H23/getLaporanUnitServisNonKpbLastThreeYear", body); 

  return {
    logout,

    getTemplateMasterdataVendor,
    postTemplateMasterdataVendor,
    getTemplateOutsourceAssignment,
    postTemplateOutsourceAssignment,
    getTemplateOutsource,
    postTemplateOutsource,
    forgotPass,
    userAuth,
    userRefreshToken,
    getUserAll,
    getUserByID,
    postUser,
    updateUser,
    updateUserMCP,
    updateUserPassword,
    updateUserPassword2,
    deleteUser,
    getRoleAll,
    getRoleByStatus,
    getRoleByName,
    getPrivilegeAll,
    // getBizparByCategory,
    getBizparByParentKey,
    getBizparByStatus,
    getCountBizparByParentKey,
    getEmployeeByStatus,
    getEmployeeBiodata,
    getEmpZodiac,
    putEmployee,
    putEmployeePGP,
    putEmployeeAbility,
    putEmployeWeakness,
    getAllMpp,
    getMppByEs,
    postMpp,
    updateMpp,
    deleteMpp,
    getCountryMasterByCountryStatus,
    getInstituteByStatus,
    getPosistion,
    getPostByLvlEs,
    getRecruitmentWeb,
    getRecruitmentReqAll,
    getRecruitmentReqAllFinal,
    getRecReqVac,
    getRecReqById,
    putRecReq,
    putRecReqPos,
    putRecReqQua,
    putRecReqDoc,
    putRecReqSel,
    postRecReq,
    updateMedicalCheckup,
    getApplicantAll,
    postApplicant,
    updateApplicant,
    deleteApplicant,
    getNotification,
    getBlacklistPerDivision,
    getEmployeeTerminationPerDivision,
    getEmployeeMovementPerDivision,
    getMovementByType,
    getTotalAttendance,
    getEmployeeNotPresent,
    getWorkflowSum,
    getWorkflowPerEmp,
    getWorkflowPerDiv,
    getWorkflowPerTask,

    getAllLeave,
    getNewAllLeave,
    getCountAllLeave,
    getLeaveByEmpName,
    getCountLeaveByEmpName,

    getAllSppd,
    getNewAllSppd,
    getDetaseringPersonal,
    getSppdRes,
    getCountSppdRes,
    getAllOvertime,
    getNewAllOvertime,
    getCountAllOvertime,
    getOvertimeByEmp,
    getCountOvertimeByEmp,

    getAllTimesheet,
    getNewAllTimesheet,
    getCountAllTimesheet,
    getAllTSByEMP,
    getCountAllTSByEMP,

    getTimesheetByID,
    postInstitute,
    updateInstitute,
    deleteInstitute,
    deleteRole,
    updateRole,
    postRole,
    postBizpar,
    updateBizpar,
    deleteBizpar,
    createAndUpdate,
    applicantPhotoPost,
    updateApplicantEmergencyContact,
    updateApplicantOrgExp,
    updateApplicantSocialMedia,
    updateApplicantDocument,
    updateApplicantFileDocument,
    updateApplicantWorkExperience,
    updateApplicantFormalEducation,
    updateApplicantInformalEducation,
    updateApplicantReference,
    updateApplicantWeekness,
    updateApplicantAbility,
    updateApplicantLanguageSkill,
    getAddressByRefObjectID,
    getCountAddressByRefObjectID,
    getProvinceByStatus,
    getProvinceByCountryID,
    getKabKotByProvinceID,
    getKabKotByCountryID,
    getKecamatanByKabKotID,
    getKelurahanByKecID,
    postAddress,
    deleteAddress,
    updateEmployeeWorkExperience,
    updateEmployeeFormalEducation,
    updateEmployeeInformalEducation,
    updateAddress,
    updateEmployeeDocument,
    updateEmployeeEmergencyContact,
    updateEmployeeSocialMedia,
    updateEmployeeLicense,
    updateEmployeeReference,
    updateEmployeeOrgExp,
    updateEmployeeLanguSkill,
    employeePhotoPost,
    employeeFamPhotoPost,
    getAllEmployee,
    generateUsername,
    modifyEmployee,
    updateEmployeeStatus,
    deleteEmployee,
    getEmployeeById,
    createAndUpdateFam,
    getAllLoan,
    postLoan,
    putLoan,
    putLoanComplete,
    deleteLoan,
    submitLoan,
    getAllLoanStatistic,
    getAllLoanStatisticByEmpid,
    postCountry,
    getCorporateOrgStructureTplById,
    getVisualCorporateOrgStructureTplById,
    getDropdownOrgParent,
    updateCountry,
    deleteCountry,
    getEducationByStatus,
    getInstituteByTypeAndLevel,
    getDepartmentByTypeAndLevel,
    postEducation,
    uploadDocument,
    getTplJson,
    getMppByPosition,
    getSearchMPP,
    getCompanyAll,
    postCompGeneral,
    updateCompGeneral,
    getAddressByStatus,
    uploadCompanyDoc,
    deleteCompany,
    updateEducation,
    deleteEducation,
    postProvince,
    getProvince,
    updateProvince,
    getKabkotByStatus,
    getCountKabkotByStatus,
    postKabupatenkota,
    updateKabupatenkota,
    postKecamatan,
    updateKecamatan,
    postKelurahan,
    updateKelurahan,
    deleteProvince,
    deleteKabupatenkota,
    deleteKecamatan,
    deleteKelurahan,
    getEducationByEduID,
    getEsByOuid,
    getAllTimeSheetTask,
    postUserRole,
    postUserRoleList,
    deleteUserRoleList,
    deleteUserRole,
    getCorporateHolidayByStatus,
    getCorporateHolidayByESID,
    getCountHolidayByESID,
    getAllCorporateHoliday,
    getCorporateOfficeHourByStatus,
    getCorporateOfficeHourByESID,
    getCountCorpOfficeHourByESID,
    getAllCorporateOfficeHour,
    getPersonelOfficeHourByStatus,
    getPersonelOfficeHourByESID,
    getCountPersonalOfficeHourByESID,
    getAllPersonelOfficeHour,
    getOfficeShiftHourByStatus,
    getOfficeShiftHourByESID,
    getCountShiftHourByESID,
    updateCorporateHoliday,
    postCorporateHoliday,
    deleteCorporateHoliday,
    postPhotoCorporateHoliday,
    updateCorporateOfficeHour,
    postCorporateOfficeHour,
    deleteCorporateOfficeHour,
    postPersonalOfficeHour,
    updatePersonalOfficeHour,
    deletePersonalOfficeHour,
    postOfficeShiftHour,
    updateOfficeShiftHour,
    deleteOfficeShiftHour,
    postPhotoCorporateOfficeHour,
    updateEmployeeInsurance,
    updateEmployeeFacility,
    updateEmployeeAppreciation,
    updateEmployeePayment,
    getAllMovement,
    getNewAllMovement,
    postMovement,
    deleteMovement,
    updateMovement,
    uploadMovementDoc,
    updateMovementDataDoc,
    deleteMovementDoc,
    getEmpBySubDir,
    getEmployee360ById,
    uploadDocumentAppreciation,
    addPrivilege,
    deletePrivilege,
    getMppByID,
    putRecReqOth,
    getAllBlacklistWeb,
    getAllBlacklist,
    getCountAllBlacklist,
    getBlByEmpName,
    getBlCountByEmpName,
    postBlacklist,
    putBlacklist,
    deleteBlacklist,
    getTermExtSickByID,
    getTermExtSickWeb,
    postTermExtSick,
    updateTermExtSick,
    uploadTermExtSick,
    deleteTermExtSick,
    getAllTermination,
    postTermination,
    getAttendanceByEmpIDandDate,
    getCalculateAttendaceEmployeeByMonthAndYear,
    submitAttendance,
    postAttendance,
    putAttendance,
    uploadAttendance,
    deleteAttendance,
    deletePersonalTask,
    postPersonalTask,
    putPersonalTask,
    updateTermination,
    deleteTermination,
    uploadTerminationDoc,
    updateTerminationDataDoc,
    deleteTerminationDoc,
    getLeaveByStatus,
    getLeaveByTypeDateNew,
    getCalcLeaveByID,
    getLeavePeriodByType,
    postLeaveEss,
    getLeaveByEmployeeId,
    getLeaveAllApproved,
    getCountLeaveByEmployeeId,
    getLeaveBystartDate,
    getCountLeaveBystartDate,
    updateLeaveEss,
    deleteLeaveEss,
    uploadLeaveDoc,
    getAbsLetterByEmployeeId,
    getAbsLetterCountByEmpId,
    postAbsLetter,
    updateAbsLetter,
    deleteAbsLetter,
    uploadAbsLetter,
    postTax,
    updateTax,
    getBizparByParentKeyAndCategory,
    getBizparByValue,
    deleteTax,
    postPhotoTax,
    getAllTax,
    getAllCorporateTravelExpense,
    getCorporateTravelExpenseByEs,
    getCorporateTravelExpenseWeb,
    postCorporateTravelExpense,
    updateCorporateTravelExpense,
    deleteCorporateTravelExpense,
    getCorpTravExpBIDDWeb,
    postCorpTravExpBIDD,
    updateCorpTravExpBIDD,
    deleteCorpTravExpBIDD,
    getCorporateDetaseringByEs,
    getCorporateDsWeb,
    postCorporateDetasering,
    updateCorporateDetasering,
    deleteCorporateDetasering,
    getCorpDsBIDDWeb,
    postCorpDsBIDDWeb,
    updateCorpDsBIDDWeb,
    deleteCorpDsBIDDWeb,
    getEmployeeHead,

    getAllTaxPPH,
    getPayrollByEmployeeId,
    getCountPayrollByEmployee,
    getAllPayrollByEmployeeIdAndYear,
    getCountAllPayrollByEmployeeIdAndYear,

    getAllReqCertificate,
    getAllReqCertificateByID,
    getRequestByType,
    getCountAllRequestByType,
    getRequestByDateBetween,
    getCountRequestByDateBetween,
    uploadHcisReq,

    getDsByMovID,
    getDsFacility,
    getDsBIDDFacility,
    getDetaseringByEmpId,
    getCountDsByEmpId,
    getDsByStartDate,
    getCountDsByStartDate,
    postDs,
    updateDs,
    updateMemo,
    updateSK,
    deleteDs,
    uploadDsDoc,
    getDsByID,
    postDsSettlement,
    updateDsSettlement,
    deleteDsSettlement,
    uploadDsSettlementDoc,

    postTimesheet,
    updateTimesheet,
    deleteTimesheet,
    getEsByLevel,
    getAllPayroll,
    getAllPayrollTpl,
    getPayrollWeb,
    getAllCoaCategory,
    getCountAllCoaCategory,
    postPayroll,
    updatePayroll,
    deletePayroll,
    getAllOrg,
    postOrg,
    deleteOrg,
    postPhotoPayroll,
    postPhotoOrg,
    updateOrg,
    getCorporateLeaveTypeByEsid,
    getCountCorporateLeaveTypeByEsid,
    getCorporateLeavePlafonByEsid,
    postCorporateLeaveType,
    updateCorporateLeaveType,
    deleteCorporateLeaveType,
    postCorporateLeavePlafon,
    updateCorporateLeavePlafon,
    deleteCorporateLeavePlafon,
    getBlacklistbyEmployeeId,
    getCountBlacklistbyEmployeeId,
    getTrainingRequestById,
    getSppdRef,
    getSppdWebESS,
    postSppd,
    updateSppd,
    deleteSppd,
    deleteSppdRes,
    uploadSppdDoc,
    uploadSppdResDoc,
    getTrainingByStatus,
    postTrainingReq,
    getOvertimeByEMPID,
    getOvertimeByID,
    getSPKLWebPersonel,
    getCountOvertimeByID,
    getOvertimeByCurrentDate,
    getCountOverByCurrentDate,
    postOvertime,
    updateOvertime,
    updateOvertimeRes,
    deleteOvertime,
    getParentOrgStruct,
    getCorporateOrgStructByIdPaging,
    getCountCorporateOrgStruct,
    getCorporateOrgStructByPost,
    uploadOvertimeDoc,
    uploadOvertimeResDoc,
    getRKLWeb,
    getRKLWebPersonel,
    getRKLByID,
    postRKL,
    updateRKL,
    deleteRKL,
    uploadRKLDoc,
    getCorporatePresenceByStatus,
    getAllCorpPresencePointWeb,
    getCorporatePresenceWeb,
    getCountCorpPresenceByStatus,
    getAllCorporatePresence,
    postCorporatePresence,
    updateCorporatePresence,
    getEsByStatus,
    getEsById,
    getEsEMP,
    deleteCorporatePresence,
    getCorporateOrgStructDetail,
    getEmployeeByEsid,
    getNewEmployeeByEs,
    getEmployeeByPPG,
    getStatusPPG,
    getAllEmployeeTraining,
    getEsByName,
    getEsByNameGrid,
    getCountCorporatebyName,
    getCountCompanyByStatus,
    getCompanyByStatus,
    getAllOrgTpl,
    getAllRecruitmentVacancy,
    getNewAllRecruitmentVacancy,
    getNewAllRecVacancy,
    getNewCountAllRecVacancy,
    getVacByID,
    postVacancy,
    updateVacancy,
    deleteVacancy,
    getCountRecruitmentVacancy,
    getRecVacancyByPosition,
    getCountRecVacancyByPosition,
    postJobVacany,
    getRecruitmentPsikotestByAppNumber,
    getCountRecruitmentPsikotestByAppNumber,
    getCorporateCnbTplByEsId,
    getCountCorporateCnbTplByEsId,
    postCorporateCnbTpl,
    updateCorporateCnbTpl,
    deleteCorporateCnbTpl,
    postPhotoCorporateCnb,
    getCorporateFacilityTplByEsId,
    getCountCorporateFacilityTplByEsId,
    postCorporateFacilityTpl,
    updateCorporateFacilityTpl,
    deleteCorporateFacilityTpl,
    postPhotoCorporateFacilityTpl,
    getCorporateOvertimeByEsId,
    getCorporateOvertimeWeb,
    getCountCorporateOvertimeByEsId,
    getAllBizparByParentKey,
    getAllLoanRule,
    getLoanRuleByStatus,
    getCountLoanRuleByStatus,
    getLoanRuleDummy,
    postLoanRule,
    updateLoanRule,
    deleteLoanRule,
    uploadDocLoan,
    uploadDocLoanFinalOffering,
    postCorporateOvertimeType,
    updateCorporateOvertimeType,
    deleteCorporateOvertimeType,
    postDocumentPsikotest,
    getRecPsikotestById,
    getRecInterviewByInterviewId,

    submitSPPDBIDD,
    submitSPPDBIDDKKSOKL,
    submitSPPDBIDDKCPSOKL,
    submitSPPDBIDDKCPEO,
    submitSPPDBIDDKCISOKL,
    submitSPPDBIDDKCIEO,
    submitSPPDBIDDKPOSOKL,
    submitSPPDBIDDKPOEO,
    submitSPPDBIDDKPNOEO,
    submitSPPDBIDDKPNODD,
    submitSPPDBIDDKPNOSTFPEMBUKUAN,
    submitSPPDBIDDKPNORESDIR,
    submitSPPDBIDDKPNODEPPRESDIR,
    submitSPPDBIDDKPNOASSDIR,
    submitSPPDBIDDKPNODIR,
    submitSPPDBIDDKPNOASSDIRDIR,
    submitSPPDBIDDKPNOEOPAYROLL,
    submitSPPDBIDDKPNOBIRODIR,
    submitSPPDSET,
    submitSPPDSETKKSOKL,
    submitSPPDSETKCPSOKL,
    submitSPPDSETKCPEO,
    submitSPPDSETKCISOKL,
    submitSPPDSETKCIEO,
    submitSPPDSETKPOSOKL,
    submitSPPDSETKPOEO,
    submitSPPDSETKPNOEO,
    submitSPPDSETKPNODD,
    submitSPPDSETKPNOSTFPEMBUKUAN,
    submitSPPDSETKPNORESDIR,
    submitSPPDSETKPNODEPPRESDIR,
    submitSPPDSETKPNOASSDIR,
    submitSPPDSETKPNODIR,
    submitSPPDSETKPNOASSDIRDIR,
    submitSPPDSETKPNOEOPAYROLL,
    submitSPPDSETKPNOBIRODIR,
    submitSPPDApproval,
    submitSPPDApprovalLvl2,
    submitSPPDApprovalLvl3,
    submitSPPDApprovalLvl4,
    submitSPPDSetApproval,
    submitSPPDSetApprovalLvl2,
    submitTrainingApproval,
    getAllFacility,
    getAllCNB,
    getEmployeeByName,
    getEmployeeTerm,
    getNewEmployee,
    getCountEmployee,
    getCountAllEmployee,
    submitBlacklist,
    submitBlacklistAppEmp,
    submitBlacklistAppDD,
    submitBlacklistAppDDSDM,
    submitBlacklistDocUpload,
    submitTraining,
    submitTimesheet,
    getNewApplicant,
    getNewCandidate,
    getApplicantByName,
    getCountApplicantName,
    getCountApplicant,
    getMovementByID,
    getMovByEmpCats,
    getCheckMovementStatus,
    resubmitAbsence,
    resubmitBlacklist,
    resubmitLeave,
    resubmitMovement,
    resubmitOvertime,
    resubmitSPPD,
    resubmitTermination,
    getTerminationByID,
    resubmitTraining,
    getTrainingByID,
    getAllTrainingPlan,
    postTrainingPlan,
    putTrainingPlan,
    deleteTrainingPlan,
    getLeaveByID,
    getCheckRemainingDaysOff,
    getAbsenceByID,
    getBlacklistByID,
    uploadDocBlacklist,
    getOvertimeByOVID,
    getSppdByID,
    getAllBatchPayroll,
    getCountAllBatchPayroll,
    postBatchPayroll,
    putBatchPayroll,
    calculateBatchPayroll,
    getBatchPayrollWeb,
    getBatchPayrollWebFilter,
    getBatchPayrollById,
    submitPayrollBatch,
    submitPayrollBatchApproval,
    getAverageLeaveBalance,
    getStaffPerformance,
    getTotalCostPerHire,
    getTotalEmployeePerHire,
    getStatusEmployee,
    getCorporateLeavePlafonByStatus,
    getCorporateLeavePlafonByESID,
    getCountLeavePlafonByESID,
    getAllCorporateLeavePlafon,
    postBankCorporate,
    putBankCorporate,
    getBankCorporateById,
    getTplById,
    getTPlDemosi,
    getTPlPromosi,
    getTPlRotasi,
    getAgeDemographicPerDepartment,
    getOpenPositionByDepartment,
    getEmployeeScore,
    getAverageLeaveBalanceDays,
    getIncomeBreakdown,
    getAverageCostHire,
    getBudgetPlanning,
    getApplicantDivision,
    getAverageTimeDuration,
    getMaxTime,
    getEmployeeWorkflow,
    getAveragePayroll,
    getExecutedPayroll,
    getAverageTax,
    getExecutedTax,
    getAverageCom,
    getExecutedCom,
    getAverageBenefit,
    getExecutedBenefit,
    getEksadStrategyMatrix,
    getTotalEmployee,
    getEksadAverageSpendPerHire,
    getDashboard,
    getTotalEmployeeGenderPerDivision,
    getEmployeeOvertimePerDivision,
    getEmployeeBusinessTrip,
    getAverageBiztripPerEmployee,
    getTotalEmployeeDashboard,
    getAllEmployeeOnBirthday,
    getCurrentTraining,
    getCanceledTraining,
    getEmployeeTraining,
    getAverageCorporate,
    getEmployeeComply,
    getConstanta,
    getConstantaByStatus,
    getRegistryWeb,
    getRegistryByID,
    postConstanta,
    updateConstanta,
    deleteConstanta,
    getAveragePerformance,
    getAverageLoan,
    getAvailableTraining,
    getCandidateDivision,
    getProcessingApplicant,
    getPosistionDepartment,
    getLateEmployee,
    getCommitedLoan,
    getAverageBiztripPerDivision,
    getEmployeeNotComply,
    getEmployeeStatus,
    getEmployeeMovement,
    getEmployeeTermination,
    getEmployeeBlacklist,
    getListTask,
    getRemainingDays,
    getAvgAmount,
    getEmployeeByAge,
    getLeavePerDivision,
    getGenderPerDivision,
    getTotalEmployeeGender,
    getTimesheetTaskById,
    getTaxByStatus,
    getTaxWeb,
    getCountTaxByStatus,
    getFacilityByStatus,
    getGradeByPosition,
    getCNBbyStatus,
    getAllClaimWeb,
    getAllClaim,
    getCountAllClaim,
    getClaimDocument,
    postClaimDocument,
    getComponentClaimByEmpCompPosition,
    getMedicalHistoryByEmp,
    getClaimByEmpIdTypeYear,
    submitClaim,
    submitClaimApproval,
    getClaimById,
    getPayrollCorrectionWeb,
    getPayrollCorrectionRoleWeb,
    getAllPayrollCorrectionByStatus,
    getAllCorrectionPayrollByGroupId,
    postPayrollCorrection,
    notifyPayrollCorrection,
    putPayrollCorrection,
    deletePayrollCorrection,
    getClaimMonitoring,
    getEmpClaim,
    getAllClaimSearch,
    getListClaimIDs,
    postClaimMonitoring,
    putClaimMonitoring,
    deleteClaimMonitoring,
    getClAllowanceWEB,
    getDataClaimBatchStartEndDate,
    getMassSalaryWeb,
    getMassSalaryByID,
    uploadMassSalary,
    postMassSalaryWeb,
    putMassSalaryWeb,
    deleteMassSalaryWeb,
    getClAllowanceByEmpID,
    getClAllowanceByID,
    getClAllowanceTypeYear,
    postClAllowance,
    putClAllowance,
    deleteClaimAllowence,
    uploadClAllowance,
    getPDLWEB,
    postPDL,
    putPDL,
    deletePDL,
    getTimesheetTaskByIdDate,
    getCountTimesheetTaskByIdDate,
    getEmployeeKseCheckByEmpId,
    submitTerminationChecklist,
    resubmitClaim,
    resubmitRequest,
    getUserByName,
    getUserByEmployeeName,
    getUserByEmployeeID,
    getCountUserByEmployeeName,
    getCountUser,
    getCountAllUser,
    getCountEmployeeByEsid,
    getApplicantById,
    getTaxByID,
    getPayrollByID,
    postSppdResponsibility,
    updateSppdResponsibility,
    getSppdResponsibilityByID,
    getCorporateHolidayByID,
    getCorporateOfficeHourByID,
    getCNBbyID,
    getFacilityByID,
    getCountBizparByValue,
    getCountBizparByStatus,
    getGovernmentByStatus,
    getGovernmentWeb,
    getAllGovernment,
    postGovernment,
    updateGovernment,
    deleteGovernment,
    getCountRoleAll,
    getCountRoleName,
    getLoanFinished,
    getCountCorporateHolidayByStatus,
    getCountCorporateHolidayByName,
    getCountFacilityByIdAndName,
    getCountFacilityByStatus,
    getCountAllFacility,
    getFacilityByIdAndName,
    getCountCNBbyIdAndName,
    getCNBByIdAndName,
    getCountCNBByStatus,
    getCountAllCNB,
    getCountHolidayByStatus,
    getCountAllHoliday,
    getCountHolidayByName,
    getHolidayByName,
    getHolidayWeb,
    getCountCountryByStatus,
    getCountCountryByName,
    getCountInstituteByStatus,
    getCountInstituteByName,
    getCountryByName,
    getInstituteByName,
    getCountAllMovement,
    getCountMovementByName,
    getAllMovementByStatus,
    getCountMovementByStatus,
    getAllMovementByCategory,
    getCountAllMovementByCategory,
    getMovementByEmpIDByCategoryByStatus,
    getAllMovementByName,
    getAllMovementSKWEB,
    getAllMovementSKESS,
    getAllMovementMemoWEB,
    getCountAllTermination,
    getAllTerminationWeb,
    getAllTerminationESSWeb,
    getCountTerminationByName,
    getAllTerminationByName,
    getCountRoleByStatus,
    getSppdByGradeES,
    getSppdBIDDByGradeES,
    getCountCorpOfficeHourByStatus,
    getAllCountCorpOfficeHour,
    getCountCorpOfficeHourByName,
    getAllCorpOfficeHourByName,
    getCountPersonalOfficeHourByStatus,
    getAllCountPersonalOfficeHour,
    getAllPersonalOfficeHourByStatusAndName,
    getCountPersonalOfficeHourByStatusAndName,
    getCountShiftHourByStatus,
    getCountShiftHourByStatusAndName,
    getAllCountShiftHour,
    getAllShiftHourByStatusAndName,
    getAllShiftHour,
    getCountCorpPayrollByStatus,
    getAllCountCorpPayroll,
    getAllCorpPayrollByStatusAndName,
    getCountCorpPayrollByStatusAndName,
    getCountLeavePlafonByStatus,
    getAllCountLeavePlafon,
    getCountLeavePlafonByIdAndName,
    getAllLeavePlafonByIdAndName,
    getCountLeaveTypeByStatus,
    getCountLeaveTypeByStatusES,
    getCountLeaveTypeByIdAndName,
    getAllLeaveTypeByIdAndName,
    getCountEducationByStatus,
    getCountEducationByLevel,
    getAllEducationByLevel,
    getCorGlobalByStatus,
    getAllCorGlobalPolicy,
    getGlobalPolicyByEs,
    getGlobalPolicyWeb,
    getGlobalPolicyType,
    getCountGlobalPolicyByEs,
    postCorGlobal,
    updateCorGlobal,
    deleteCorGlobal,
    getGroupProc,
    getGroupProcWeb,
    getGroupProcByEmpID,
    getCountGroupProc,
    postGroupProc,
    updateGroupProc,
    updateGroupProcMove,
    deleteGroupProc,
    getAllVendorByStatus,
    postVendor,
    putVendor,
    deleteVendor,
    getAllOutsourceAssignment,
    postOutsourceAssignment,
    getAllOutsource,
    deleteOutsourceAssignment,
    getOutsourceByVendorID,
    postOutsource,
    putOutsource,
    deleteOutsource,
    putOutsourceAssignment,
    getTrainingBudget,
    deleteTrainingBudget,
    postTrainingBudget,
    putTrainingBudget,
    getAllTrainingExpense,
    postTrainingExpense,
    putTrainingExpense,
    deleteTrainingExpense,
    getAllTrainingRegis,
    getAllBank,
    getCountAllBank,
    postBank,
    putBank,
    deleteBank,
    getCountryByIDCountry,
    getProvinceByIDProvince,
    getKabKotByIDKabKot,
    getCncById,
    postCnc,
    getIppTplById,
    getCountCorpOSbyStatus,
    deleteBankCorp,
    getCorpOrgbyName,
    getCountOrgbyStatusAndName,
    updateBankAccount,
    postIppTplComponentHeader,
    putIppTplComponentHeader,
    postIppTplComputeSection,
    putIppTplComputeSection,
    putIppTplProcessCriteria,
    resubmitMPP,
    getAllComponentAllowance,
    getCountAllComponentAllowance,
    putComponentAllowance,
    postComponentAllowance,
    putRequestMethodology,

    getKPKByID,
    putPKWTNumber,

    deleteComponentAllowance,
    getCorpBankTrf,
    postCorpBankTrf,
    putCorpBankTrf,
    deleteCorpBankTrf,
    getAllPaymentGroup,
    getAllPaymentGroupFilter,
    getAllBPRole,
    getAllPaymentGroupCreatedByRole,
    getCountAllPaymentGroup,
    getPaymentByID,
    getAllPaymentType,
    putIppTplSignageSection,
    putIppTplOutputCriteria,
    putIppTplAssignment,
    putIppTplDisipline,
    putIppTplPeople,
    putIppTplMovement,
    getCncTpl,
    deleteCncTpl,
    updateCnc,
    postCncHeaderSection,
    updateCncHeaderSection,
    postCncSignageSection,
    updateCncSignageSection,
    getAllComponentAllowanceByStatus,
    getComponentAllowanceByName,
    getComponentAllowanceWeb,
    getCountComponentAllowanceByStatus,
    getCountComponentAllowanceByName,
    getAllCnBComponentAllowance,
    getCountMppByName,
    uploadDocMPP,
    getPositionMPP,
    getMppByName,
    getMppByPositionName,
    getCountMppByPositionName,
    getCountAllMpp,
    getOrg,
    getAllBizpar,
    saveAllBizpar,
    getAllMasterParamConfigByCategory,
    getCountBizparByCategory,
    deleteRecReq,
    getCountRecruitmentReqAll,
    getRecruitmentReqBy,
    getRecruitmentReqByName,
    getCountRecruitmentReqBy,
    getCountRecruitmentReqByName,
    updateCncAreaSection,
    updateCncFeedbackSection,
    getAllIPP,
    postIppTpl,
    putIppTpl,
    deleteIppTpl,
    getCountAllSppd,
    getSppdByName,
    getCountSppdByName,
    getCorporateTalentByID,
    postCorporateTalent,
    putCorporateTalent,
    deleteCorporateTalent,
    getAllCorporateTalent,
    submitPKWT,
    submitOfferingLetter,
    submitKPKEO,
    submitKPKDDSDM,
    submitKPKDIR,
    submitKPKDEPPRESDIR,
    submitKPKPRESDIR,
    getPayrollByEmployeeIdAndYear,
    submitLoanApproval,
    getIppEssAll,
    postIppEss,
    updateIppEss,
    deleteIppEss,
    getCncEssAll,
    postCncEss,
    updateCncEss,
    deleteCncEss,
    getTalentEssAll,
    postTalentEss,
    updateTalentEss,
    deleteTalentEss,
    uploadMedicalDoc,
    getAllTrainingEvaluation,
    postTrainingEvaluation,
    putTrainingEvaluation,
    deleteTrainingEvaluation,
    getAllTrainingEvaluationTrainer,
    postTrainingEvaluationTrainer,
    putTrainingEvaluationTrainer,
    deleteTrainingEvaluationTrainer,
    getAllTrainingByStatus,
    getLoanInstallment,
    postTemplateLoanInstallment,
    postTemplateLoan,
    postTemplateTraining,
    submitTrainingBudget,
    submitTrainingBudgetApproval,
    resubmitTrainingBudget,
    submitTrainingPlan,
    submitTrainingPlanApproval,
    resubmitTrainingPlan,
    getMidFullYearIppTrx,
    getIppTrxByID,
    getTrainingBudgetById,
    getTrainingPlanById,
    getBizparByCategoryChild,
    getBizparWeb,
    getCncTrxByID,
    getTalentTrxAll,
    postTalentTrx,
    updateTalentTrx,
    deleteTalentTrx,
    ippApproval,
    submitIPP,
    postOutsourceDocument,
    getParentByEsID,
    getDirByEsid,
    submitTrainingExecution,
    submitTrainingExecutionApproval,
    submitClAllowance,
    submitClAllowanceKPNOEMPHead,
    submitClAllowanceKPNOStfPayroll,
    submitClAllowanceKPNOEOPayroll,
    resubmitClAllowance,

    submitBiodata,
    submitApprovalKKSO,
    submitApprovalKCPSO,
    submitApprovalKCPEO,
    submitApprovalKCIEO,
    submitApprovalKCISO,
    submitApprovalKPOEO,
    submitApprovalKPOSO,
    submitApprovalKPNOSTAFF,
    submitApprovalKPNOEO,
    submitApprovalKPNODD,
    submitApprovalKPNOASSDIR,
    submitApprovalKPNOPRESDIR,

    submitSKAK,
    submitSKAKKKSOKL,
    submitSKAKKKSDM,
    submitSKAKKCIEO,
    submitSKAKKCISOKL,
    submitSKAKKCISDM,
    submitSKAKKCPEO,
    submitSKAKKCPSOKL,
    submitSKAKKCPSDM,
    submitSKAKKPOEO,
    submitSKAKKPOSOKL,
    submitSKAKKPOSDM,
    submitSKAKKPNOEO,
    submitSKAKKPNODD,
    submitSKAKKPNOSTAFFHI,
    submitSKAKKPNOASSDIR,
    submitSKAKKPNOPRESDIR,

    submitFPTK,
    submitFPTKKCISOKL,
    submitFPTKKCIEO,
    submitFPTKKCPEO,
    submitFPTKKPNOEO,
    submitFPTKKPNODEP,
    submitFPTKKPNODD,
    submitFPTKKPNOASSDIR,
    submitFPTKKPNODEPPRESDIR,
    submitFPTKKPNOPRESDIR,
    submitFPTKKPNOSTFSDM,
    submitFPTKKPNOEODIKLAT,
    submitFPTKKPNOEOREC,
    submitFPTKKPNODDSDM,

    submitDsMemo,
    submitDsMemoEO,
    submitDsMemoSTFBPO,
    submitDsMemoDDSDM,

    submitDsSTL,
    submitDsNewSTL,
    submitDsSTLKKSOKL,
    submitDsSTLKCPSOKL,
    submitDsSTLKCPEO,
    submitDsSTLKCISOKL,
    submitDsSTLKCIEO,
    submitDsSTLKPNOEO,
    submitDsSTLKPNODD,
    submitDsSTLKPNOASSDIRDIR,
    submitDsSTLKPNOSTFPEMBUKUAN,
    submitDsSTLKPNOEOPAYROLL,
    submitDsSTLKPNOBIRODIR,
    submitDsSTLKPNOASSDIR,
    submitDsSTLKPNODIR,
    submitDsSTLKPNOPRESDIR,
    submitDsSTLKPNODEPUTYPRESDIR,

    submitDs,
    submitDsKKSOKL,
    submitDsKCPSOKL,
    submitDsKCPEO,
    submitDsKCISOKL,
    submitDsKCIEO,
    submitDsKPNOEO,
    submitDsKPNODD,
    submitDsKPNOASSDIRDIR,
    submitDsKPNOSTFPEMBUKUAN,
    submitDsKPNOEOPAYROLL,
    submitDsKPNOBIRODIR,
    submitDsKPNOASSDIR,
    submitDsKPNODIR,
    submitDsKPNOPRESDIR,
    submitDsKPNODEPUTYPRESDIR,

    submitCNBPayroll,
    submitCNBKPNOEOPayroll,
    submitCNBKPNODDSDM,

    submitCNBClaimMedical,
    submitCNBClaimBatch,
    submitCNBCMKCPEO,
    submitCNBCMKCIEO,
    submitCNBCMKPNOEO,
    submitCNBCMKPNOSTFMEDICAL,
    submitCNBCMKPNOSOBenefit,
    submitCNBCMKPNOEOPayroll,
    submitCNBCMKPNODDSDM,
    submitCNBCMKPNOSTFPEMBUKUAN,

    submitMassSalary,
    submitMSSTFPayroll,
    submitMSKPNODDSDM,
    submitMSKPNOEOPAYROLL,

    submitPerformanceKPNOBIRODIREKSI,
    submitPerformanceKPNODEPUTYPRESDIR,
    submitPerformanceKPNOPRESDIR,
    submitPerformanceKPNODIR,

    //way
    postGetTaxOffice,
    postGetCompany,
    postGetDistrict,
    postSaveTaxOffice,
    postGetOrgStructureTemplate,
    postSaveOrgStructureTemplate,
    postGetOrgStructure,
    postSaveOrgStructure,
    postGetOrgStructureDetail,
    postSaveOrgStructureDetail,
    postGetOrgStructureDetailJob,
    postSaveOrgStructureDetailJob,
    postGetOrgParentStructureDdl,
    postGetOrgParentSubStructureDdl,
    postExportOrganizationTemplate,
    postGetOrganizationStructureTemplate,

    postGetLeaveTypeDdl,
    postAuthGetButtonAccess,
    postTrxAttendanceGetLeave,
    postTrxAttendanceGetBusinessTrip,
    postTrxPersonGetMovement,
    postTrxPersonGetOffense,
    postGetVendor,
    postSaveVendor,
    getPeriodDdl,
    getPeriodAttDdl,
    postGetWorkShiftDdl,
    postGetExcelGenerator,
    postGetOrgUnitDdl,
    postTrxTasklistGetTaskList,
    postGetCoa,
    postCnbCoaSave,
    postGetCoaParentDdl,
    postGetCnbComponent,
    postCnbComponentSave,
    postGetCnbComponentPercent,
    postCnbComponentPercentSave,
    postGetCnbComponentDdl,
    postGetCnbComponentAmount,
    postCnbComponentAmountSave,
    postGetCnbProcess,
    postCnbProcessSave,
    postGetCnbProcessComponent,
    postCnbProcessComponentSave,
    postGetCnbCutOff,
    postCnbCutOffSave,
    postGetWorkTimeType,
    postWorkTimeTypeSave,
    postGetWorkShift,
    postWorkShiftSave,
    postGetWorkShiftDtl,
    postGetWorkShiftAssignment,
    postWorkShiftAssignmentSave,
    postGetWorkShiftSchedule,
    postWorkShiftScheduleSave,
    postGetWorkShiftScheduleDtl,
    postGetLevelDdl,
    postGetApprovalFlow,
    postGetApproval,
    postApprovalMakerSave,
    postGetApprovalMaker,
    postGetApprovalMakerReq,
    postGetApprovalApprover,
    postApprovalMakerReqSave,
    postApprovalApproverSave,
    postTrxCombenGetPayrollData,
    postTrxCombenGetPayrollDataDtl,
    postGetWorkShiftScheduleTemp,
    postWorkShiftScheduleNewSave,
    postGetBpmTrack,
    postTemplateGetOrg,
    postTemplateGetWorkShiftSchedule,
    postUploadWorkshiftScheduleSave,
    postEmplGetPhoto,
    postWorkflowGetAppRequest,
    postGetReportNameDdl,
    postCreateInstanceNonPersonal,
    postUploadOrgSave,
    getFlowTypeDdl,
    postGetMovement,
    getPeriodMonthDdl,
    getPeriodYearDdl,
    postTemplateGetCoa,
    postUploadCoaSave,
    postCreateInstanceNonPersonalBatch,
    postTemplateGetCnbComponentAmount,
    postUploadCnbComponentSave,
    postPersonGetMovement,
    postClaimTask,
    postCompleteTask,
    postReportOffense,
    postReportAttendance,
    postTrxPersonGetEmplBatchUpdate,
    postBatchUpdateSave,
    postCombenGetProcessTransaction,
    postCombenCnbApProcessSave,
    postCombenGetBpmTrack,
    postGetProcessTrxDdl,
    postGetPeriodTrxDdl,
    postGetPayrollDataHist,
    postGetJobLocationDdl,
    postCombenGetProcessTransactionDtl,
    postGetAttLocationPoint,
    postGetAttLocationPointDtl,
    postAttPointSave,
    postAttPointDtlSave,
    postGetOrgPosition,
    postTemplateGetPosition,
    postPositionSave,
    postGetRuleDdl,
    postGetOrgLevel,
    postOrgStructureLevelSave,
    postGetOrgLevelDdl,
    postGetEmplCnbComponent,
    postEmplCnbComponentSave,
    postGetOffenseTypeDdl,
    postReportPkwt,
    postReportMvStatusChangePerm,
    postReportMvLevelPromotion,
    postGetOrgTemplateLevel,
    postOrgTemplateLevelSave,
    postTemplateGetOrgTemplateUnit,
    postUploadOrgTemplateUnitSave,
    postGetOrgTemplateUnit,
    postGetOrgTemplateUnitJob,
    postGetOrgTemplateUnitPosition,
    postOrgTemplateUnitDelete,
    postOrgTemplateUnitJobDelete,
    postOrgTemplateUnitPositionDelete,
    postTemplateGetOrgTemplateJob,
    postTemplateGetOrgTemplatePosition,
    postUploadOrgTemplateUnitJobSave,
    postUploadOrgTemplateUnitPositionSave,
    postReportMvRotation,
    postReportMvDemotion,
    postCombenGetPayrollDataSalaryHist,
    postCombenPrcApCalcSave,
    postCombenPrcApPublishSave,
    getBatchNpwp,
    getBatchAccount,
    getBatchBpjsTk,
    getBatchBpjsKs,
    getBatchOtherInsurance,
    postUploadBatchUpdateSave,
    postUploadBatchAccountSave,
    postUploadBatchBpjsTkSave,
    postUploadBatchBpjsKsSave,
    postUploadBatchOtherInsuranceSave,
    postTemplateGetChangeRequest,
    postUploadPayrollChangeRequestSave,
    postCombenGetPayrollBatchHead,
    postCombenGetPayrollBatchDtl,
    postReportPkwtt,
    postReportPaklaring,
    postGetRoleUser,
    postTemplateGetMovement,
    postUploadMovementSave,
    postPersonGetMovementBatchData,
    postGetBpmStartPrinting,
    postCreateBpmStartPrinting,
    postOrgTemplateUnitSave,
    postGetSeqLevelOrgDdl,
    postGetTemplateUnitDdl,
    postGetOrgTemplateUnitByParentCode,
    postOrgTemplateUnitJobSave,
    postGetOrgTemplateJobDdl,
    postGetOrgTemplateJobLevelDdl,
    postOrgTemplateUnitPositionSave,
    postGetOrgPositionJobDdl,
    postGetOrgPositionLevelDdl,
    postGetOrgPositionLocationDdl,
    postReportBankSeal,
    getTemplateGetBatchEmail,
    postUploadBatchEmailSave,
    postTrxTasklistGetTaskListFc,
    getTemplateGetBatchEmailOutsource,
    postUploadBatchEmailOutsourceSave,
    postGetTaskListCnb,
    postClaimTaskCnb,
    postCompleteTaskCnb,
    postCreateInstanceNonPersonalBatchCnb,
    postGetJsonRequestCnb,
    getPeriodCompHistDdl,
    postGetEmplPayrollHist,
    postGetParamByEmpl,
    postGetExcelGeneratorByCompany,
    postGetCancelTypeDdl,
    postGetCancellationData,
    postGetCancellation,
    postCancellationSave,
    postGetEmplCnbComponentCalc,
    postGetStatusCalc,
    postCnbApClosingCalc,
    postGetPayslipAdmin,
    getApprovalSum,
    postReportMvActing,
    postGetCnbReimburseQuota,
    postReimburseQuotaSave,
    postGetCnbReimburseQuotaEmpl,
    postGetCompanyBilling,
    postGetCompanyBillingDtl,
    postPayrollReferenceSave,
    postGetEmplListAll,
    postPersonMovementBatchDelete,
    getBillingApp,
    postGetReimburseEmplHist,
    getTemplateBatchCard,
    getTemplateBatchAddress,
    getTemplateBatchInactiveEmplOutsource,
    getTemplateBatchPositionUpdateOutsource,
    postUploadBatchCardSave,
    postUploadBatchAddressSave,
    postUploadBatchInactiveOutsourceSave,
    postUploadBatchPositionUpdateOutsourceSave,
    postUploadBatchBpjsFlagSave,
    postGetIdpDuration,
    postDurationSave,
    postGetIdpCompetence,
    postCompetenceSave,
    postgetIdpJobCompetence,
    postJobCompetenceSave,
    getTemplateBatchBpjsFlag,
    postGetIdpJobCompetenceDtl,
    postGetIdpActivityDev,
    postActivityDevSave,
    postGetIdpJobCompetenceDdl,
    postGetIdpCharacterDev,
    postCharacterDevSave,
    postGetJournalTemplate,
    postJournalTemplateSave,
    postGetJournal,
    postGetLocationTypeDdl,
    postGetCoaDetailDdl,
    postJournalSave,

    //Aryo
    getLeaveHistory,
    postGetLevel,
    postSaveJobLocation,
    getLeavemaster,
    postLeavemaster,
    postGetJobDocumentDetail,
    postSaveJobDocument,
    postGetJobDocument,
    postSaveJobLevel,
    postGetJobLevel,
    postGetGrade,
    postSaveGrade,
    postGetJob,
    postGetPosition,
    postGetJobDetail,
    postSaveJob,
    postSaveJobPos,
    postGetJobDdl,
    postGetLocationDdl,
    postSaveJobPosUpload,
    postSavePositionUpload,
    postGetJobTemplete,
    postGetPositionTemplete,
    getCostCenter,
    getCostTemplate,
    getCostCenterDdl,
    getCostTemplateDtl,
    getJobPositionDdl,
    getLevelDdljob,
    getCostTemplateDtlPosition,
    postCostCenterSave,
    postCostTemplateSave,
    postCostTemplateDtlSave,
    postCostTemplateDtlPositionSave,
    postLeadout,
    postDocumentout,
    getEmploutdtl,
    getEmploutdirectlead,
    getEmploutdocument,
    getEmploutdocumentDtl,
    getEmploutsource,
    postEmplout,
    getVendor,
    getVendorDdl,
    getOrganizationunit,
    postOrganizationunit,
    postLeveljob,
    getLeavequota,
    getLeavequotaDtl,
    getPeriodyear,
    getLeavetypeddl,
    postLeavequota,
    getAttSummary,
    getAttSummaryReq,
    getAttSummaryReqESS,
    postGetAttendanceReqWf,
    getAttDaily,
    postAttendancesave,
    postEssAttendancesave,
    postEssAttGetDoc,
    postAttGetDoc,
    postEssAttGetDocDtl,
    postAttGetDocDtl,
    postEssAttDocSave,
    postAttDocSave,
    getAttDailyEss,
    getTemplateCost,
    postUploadTemplateCost,

    //akbar
    postGetCompanyGroup,
    postGetCompany2,
    postGetCountry,
    postGetAdmCountry,
    postGetAdmProvince,
    postGetAdmKabkot,
    postGetAdmKecamatan,
    postGetAdmKelurahan,
    postGetParamValue,
    postGetCompanyGroupDdl,
    postGetCompanyDocument,
    postGetHoliday,
    postGetHolidayLocation,
    postGetBizparCategoryDdl,
    postGetBizparDtl,
    postGetBizparHu,
    postGetEmplList,
    postGetGeneralInfo,
    postGetPtkp,
    postGetLoginInfo,
    postChangePass,
    postGet,
    postGetCareerTransition,
    postGetBpjsKetenagakerjaan,
    postGetBpjsKesehatan,
    postGetOtherInsurance,
    postGetOffense,
    postGetAppreciation,
    postGetIdentity,
    postGetAddress,
    postGetFamily,
    postGetLeaveReduceDdl,
    postGetWorkExperience,
    postGetLanguageSkill,
    postGetOrgExperience,
    postGetFormalEducation,
    postGetInformalEducation,
    postGetInstituteDdl,
    postGetMajorDdl,
    postGetAbility,
    postGetDeficiency,
    postGetReference,
    postGetEmergencyContact,
    postGetPersonalCard,
    postGetSocialMedia,
    postGetTrainingSertification,
    postGetDocument,
    postGetDocumentDtl,
    postGetBigReport,
    postGetEssReq,
    postGetCompanyDocumentDetail,
    postGetPersonnelReq,
    postGetBusinessFacility,
    postGetJsonRequest,
    postGetBpmDocumentDtl,
    postGetCv,
    postGetGradeDdl,
    postGetCareTaker,
    postGetPersonnelDataChange,
    postGetPersonnelReqWf,
    postGetPhoto,
    postGetCnbSchedule,
    postGetLoanSimulation,
    postGetCnbScheduleDtl,
    postGetLoanDocument,
    postGetLoanDocumentDtl,
    getLoanTypeDdl,
    postGetApprover,
    postGetNumbering,
    postGetNumberingDtl,
    postGetNumberingPreview,
    postGetCnbComponentTemplate,
    postGetLeaveCriteria,
    postGetCnbComponentTemplateDtl,
    postGetReportConfig,
    postGetReportHeader,
    postGetFormDdl,
    postGetReportTemplate,
    postGetPositionJobDdl,
    postGetPositionLevelDdl,
    postGetPositionLocationDdl,
    postGetReportNameCustomDdl,
    postGetBusinessTripSet,
    postGetBusinessNeedSet,
    postTemplateGetEmpl,
    postGetNotifBell,
    postGetPeriodByFormDdl,
    postGetEduLevel,
    postGetEduInstitute,
    postGetEduMajor,
    postGetEduLevelDdl,
    postGetReportNameAllDdl,
    postGetOrgStructureEmpl,
    postGetEduInstitutionDdl,
    postGetEduMajorDdl,
    postGetEmplDocument,
    postGetEmplDocumentDtl,
    postGetPersonnelDocReq,
    postGetAppPositionTemplate,
    postGetAppPosition,
    postGetAppPositionDtl,
    postGetAdmParamTax,
    postGetTasklistPrf,
    postGetClaimTaskPrf,
    postGetBpmTrackPrf,
    postGetJsonRequestPrf,
    postGetOrgTemplateJobSuperiorDdl,
    postGetCycleTemplateDdl,
    postGetRepaymentCalculate,
    postRepayment,
    postGetFacility,
    postGetEmplOutsource,
    postGetTrainingExp,
    postGetTraining,
    postGetTrainingDtl,
    postGetCnbReimburseType,
    postGetCnbReimburseAmount,
    postGetReimburseTypeDdl,
    postGetReimburse,
    postGetJsonRequestReimburse,
    postGetReimburseItem,
    postGetReimburseItemDdl,
    postGetOvertimeSetting,
    postGetOvertimeCriteria,
    postGetOvertimeRounding,
    postGetOvertime,
    postGetEmplWorkshiftDaily,
    postGetThrDate,
    postGetIdpRatingQuestion,
    postGetIdpCompetenceDdl,
    postGetIdpIndicator,
    postGetIdpRating,
    postGetIdpScore,
    postGetIdpScoreDtl,
    postGetIdpTemplate,
    postGetIdpTemplateQuest,
    postGetIdpTemplateValidation,
    postGetIdpIndicatorValidation,
    postGetIdpAssessment,
    postGetIdpAssessmentCompetence,
    postGetIdpJobCompetenceGroup,
    postGetIdpAssessmentCompDtl,
    postGetBpmIdpDocument,
    postGetBpmIdpDocumentDtl,
    postGetIdpReviewerDtl,
    postGetIdpReviewerList,
    postGetIdpReviewer,
    postGetIdpBpmTrack,
    postGetTaskListIdp,
    postGetAttDailyPhoto,
    postGetIdpPlan,
    postGetIdpMentor,
    postGetIdpMentoring,
    postGetIdpMentoringDtl,
    postGetIdpMentoringActPlan,
    postGetIdpBpmTrackMentoring,
    postGetTaskListIdpReviewer,

    postSaveCompanyGroup,
    postSaveCompany,
    postSaveCompanyDocument,
    postSaveHoliday,
    postSaveHolidayLocation,
    postSaveBizpar,
    postSaveBizparDtl,
    postForgotPass,
    postPassVerify,
    postPassFinal,
    postSaveAppreciation,
    postSaveBpjsTk,
    postSaveBpjsKs,
    postSaveOtherInsurance,
    postSaveGeneralInfo,
    postSavePtkp,
    postSaveIdentity,
    postSaveAddress,
    postSaveFamily,
    postSaveWorkExp,
    postSaveLanguageSkill,
    postSaveOrgExp,
    postSaveEducationFormal,
    postSaveEducationInformal,
    postSaveAbility,
    postSaveDeficiency,
    postSaveReference,
    postSaveEmergencyContact,
    postSavePersonalCard,
    postSaveSosmed,
    postSaveTraining,
    postSaveDocument,
    postSavePersonnelReq,
    postCreateInstancePersonal,
    postCreateInstanceAttendance,
    postSaveBusinessFacility,
    postSaveEmplSave,
    postSaveCareTaker,
    postSavePhoto,
    postSaveCnbApSched,
    postSaveCnbApSchedDtl,
    postSaveLoanDocument,
    postSaveNumbering,
    postSaveNumberingCfg,
    postSaveNumberingDtl,
    postSaveLeaveCriteria,
    postSaveCnbComponentTemplate,
    postSaveCnbComponentTemplateDtl,
    postSaveReportConfig,
    postSaveUploadEmpl,
    postNotifUserSeenSave,
    postSaveProvince,
    postSaveKabkot,
    postSaveKecamatan,
    postSaveKelurahan,
    postSaveEduLevel,
    postSaveEduMajor,
    postSaveEduInstitute,
    postSaveCountry,
    postSavePersonnelDocReq,
    postSaveAppPositionTemplate,
    postSaveAppPosition,
    postSaveAppPositionDtl,
    postCompleteTaskPrf,
    postUpdateCnbApSchedDtl,
    postSaveFacility,
    postSaveEmplOutsource,
    postSaveTrainingExp,
    postSaveTrainingDtl,
    postSaveCnbReimburseSave,
    postSaveCnbReimburseAmountSave,
    postCreateInstancePersonalReimburse,
    postSaveCnbReimburseItemSave,
    postSaveReimburseValidation,
    postSaveOvertimeSetting,
    postSaveOvertimeCriteria,
    postSaveOvertimeRounding,
    postSaveCnbThrDate,
    postSavePrfIdpRatingQuestion,
    postSavePrfIdpIndicator,
    postSavePrfIdpRating,
    postSavePrfIdpScore,
    postSavePrfIdpTemplate,
    postCreateInstanceNonPersonalIdp,
    postSavePrfIdpAssessmentComp,
    postCreateBpmIdpDocument,
    postSavePrfIdpReviewer,
    postSavePrfIdpReviewerDtl,
    postCompleteTaskIdp,
    postSaveIdpMentor,
    postSavePrfIdpMentoringActPlan,

    //ricky
    postSaveLocation,
    postSaveLocationGroupTemplate,
    postSaveLocationGroup,
    postSaveLocationGroupDetail,
    postSaveLocationGroupExcel,
    postSaveUser,
    postSaveRole,
    postSaveRoleCompanyAllowed,
    postSaveRoleCompanyBanned,
    postSaveRoleMenuAllowed,
    postSaveRoleMenuBanned,
    postSaveRoleFormAllowed,
    postSaveRoleFormBanned,
    postSaveRoleDataAllowed,
    postSaveRoleDataBanned,
    postSaveRoleMemberJob,
    postSaveRoleMemberUser,
    postCreateBpmDocument,

    postGetLocationTemplate,
    postGetLocation,
    postGetLocationDetail,
    postGetCompanyDdl,
    postGetLocationGroupDdl,
    postGetBizpar,
    postGetProvince,
    postGetCity,
    postGetDistrict_,
    postGetSubDistrict,
    postGetTaxOfficeDdl,
    postGetLocationGroupTemplate,
    postGetLocationGroup,
    postGetLocationGroupDetail,
    postGetReportLocation,
    postGetRole,
    postGetRoleMemberJob,
    postGetRoleMemberUser,
    postGetRoleCompanyAllowed,
    postGetRoleCompanyBanned,
    postGetRoleMenuAllowed,
    postGetRoleMenuBanned,
    postGetRoleFormAllowed,
    postGetRoleFormBanned,
    postGetRoleDataAllowed,
    postGetRoleDataBanned,
    postGetJobRoleDdl,
    postGetRoleUserDdl,
    postGetUserRole,
    postGetEmplOutList,
    postGetBpmDocument,

    //willy
    getUnit,
    getBank,
    getCabang,
    getPart,
    getDelivery,
    getSeries,
    postGetUser,
    postCreateSeries,
    postGetReportStatus,
    downloadBigReportExcel,
    postTest,

    //Nadya
    getPayslip,
    getPayslipESS,
    getPayslipReport,
    getUserAuth,
    getPph1721,
    getPph1721Ess,
    getPph1721Report,
    postGetSppd,
    getQuestionType,
    getPph1721NonEmpl,

    getPerfQuestion,
    getIndicator,
    getRating,
    postSavePerfQuestion,
    postSaveIndicator,
    postSaveRating,
    getIndicatorValidation,

    getTplIPP,
    getTemplateWeightValidation,
    getTemplateQuest,
    postSaveIPPTpl,

    getCycleAssignment,
    getCAAssigneeCriteria,
    postCycleAssignment,
    getAssignee,
    postAssignEmpl,
    postAssignposting,
    postAssignUnposting,
    postAssignEmplUnposting,
    getAssigneeEmplRev,
    postAssignRev,
    getReviewer,
    postTemplateGetAsgn,
    postSaveUploadAsgn,
    postAssigneeEmplRevPostingSave,

    getCycleEvaluation,
    getAssigneeEvaluation,
    getProcessEvaluationDtl,
    getProcessEvaluationSum,

    getIpp,
    getQuestionByEmplId,
    getIppRating,
    postIppRating,
    getIppTarget,
    postIppTarget,
    postBpmIppTarget,
    postBpmIppRating,
    getBpmIpp,
    getPrfBpmIppRating,
    getPrfBpmIppTarget,
    postCreateInstancePersonalPrf,
    getSubmitValidation,
    getIppReview,

    getSetting,
    postSaveSetting,

    getNewDashboard,
    getMonthlyAttMonitoring,

    getAllMasterUser,

    // 4-Nov-2024 Safei: Implement Home & Login
    postChangePassword,
    getUserProfile,

    getAllProvince,
    getProvinceById,
    getAllCity,
    getCityById,
    getAllKecamatan,
    getKecamatanById,
    getAllKelurahan,
    getKelurahanById,

    // Master Cabang
    getAllMasterCabang,
    findAllMasterCabang,
    createMasterCabang,
    updateMasterCabang,
    deleteMasterCabang,
    getMasterCabangById,

    getAllMasterSupplier,
    getMasterSupplierById,
    createMasterSupplier,
    updateMasterSupplier,
    updateStatusMasterSupplier,
    deleteMasterSupplier,

    // Auth
    getAllMasterRole,
    getPagingMasterRole,
    createMasterRole,
    deleteMasterRole,
    createRoleMenu,

    getAllMasterMenu,
    getMasterMenuById,
    getMasterRoleMenuById,

    getAllHirarki,
    getByIdHirarki,
    saveHirarki,
    updateHirarki,
    deleteHirarki,

    getAllSegmen,
    getAllSegmenPaging,
    saveOrUpdateSegmen,
    updateStatusSegmen,
    deleteSegmen,

    getAllSubSegmen,
    getAllSubSegmenByParam,
    getAllSubSegmenPaging,
    getSubSegmenById,
    saveSubSegmen,
    updateSubSegmen,
    updateStatusSubSegmen,
    deleteSubSegmen,

    getAllSeries,
    getAllSeriesByParam,
    getAllSeriesPaging,
    getSeriesById,
    saveSeries,
    updateSeries,
    updateStatusSeries,
    deleteSeries,

    getAllType,
    getAllTypeByParam,
    getAllTypePaging,
    getTypeById,
    saveType,
    updateStatusType,
    deleteType,

    getAllVariant,
    getAllVariantPaging,
    getVariantById,
    saveVariant,
    updateVariant,
    updateStatusVariant,
    deleteVariant,

    getAllWarna,
    getAllWarnaByParam,
    getAllWarnaByListKodeVariant,
    getAllWarnaPaging,
    getWarnaById,
    saveWarna,
    updateWarna,
    updateStatusWarna,
    deleteWarna,
    downloadTemplateVariant,
    downloadErrorLogVariant,
    uploadExcelVariant,
    getVariantByCabang,

    getAllMasterKas,
    getMasterKasById,
    createMasterKas,
    updateMasterKas,
    deleteMasterKas,
    downloadTemplateWarna,
    downloadErrorLogWarna,
    uploadExcelWarna,

    getAllKSU,
    getAllKSUPagingByParam,
    getKSUById,
    saveKSU,
    updateKSU,
    updateStatusKSU,
    deleteKSU,

    getAllHadiah,
    getAllHadiahPagingByParam,
    getHadiahById,
    saveHadiah,
    updateHadiah,
    updateStatusHadiah,
    deleteHadiah,

    getAllOtherItem,
    getAllOtherItemPagingByParam,
    getOtherItemById,
    saveOtherItem,
    updateOtherItem,
    updateStatusOtherItem,
    deleteOtherItem,

    getAllBizparByParam,

    getAllMasterLocation,
    getAllMasterLocationPagingByParam,
    getMasterLocationById,
    saveMasterLocation,
    deleteMasterLocation,

    getAllInventoryUnitByParam,
    getInventoryUnitDetailByParam,
    getInventoryUnitDetailHistory,

    getAllInventoryKSUByParam,
    getDetailInventoryKSU,
    getDetailHistoryInventoryKSU,
    getHistoryUnitInventory,
    getCardStockInventory,
    getCardStockInventoryDetail,
    getKSUStockCard,
    getKSUStockCardDetail,

    getAllStockOpnameByParam,
    deleteStockOpname,
    getDetailStockOpnameUnit,
    getDetailStockOpnameKSU,
    submitAddDataDetailUnit,
    submitAddDataDetailKSU,
    submitProcessStockOpnameUnit,
    submitProcessStockOpnameKSU,
    reportSO,
    dataKelebihanSO,
    dataKekuranganSO,
    saveKelebihanSO,
    submitResolving,
    getListDataPartByQrCode,
    getListDropdownOtherItemSO,
    printStockOpnameReportSO,
    printStockOpnameReportKelebihan,
    printStockOpnameReportKekurangan,
    printStockOpnameReportSummary,

    getAllReceivingUnitNOSByParam,
    getDetailReceivingUnitNOS,
    submitReceivingUnitNOS,
    deleteReceivingUnitNOS,
    generateQRReceivingUnitNOS,
    updateNumberOfPrintQRCodeUnitNOS,
    checkingValidUnitNOS,

    getAllSupplierMainDealer,
    getSupplierMainDealerBySourceCode,
    getAllSupplierExpedition,
    getSupplierNotExpedition,

    getAllMasterLeasing,
    getMasterLeasingById,
    updateMasterLeasingStatus,
    deleteMasterLeasing,
    modifyMasterLeasing,

    getAllMasterSamsat,
    getMasterSamsatById,
    updateMasterSamsatStatus,
    deleteMasterSamsat,
    modifyMasterSamsat,

    getAllReceivingDGI,
    updateReceivingDGI,
    getReceivingDGIDetail,
    validateReceivingDGIDetail,

    getAllReceivingKSUByParam,
    getDetailBarcodeReceivingKSU,
    getDetailReceivingKSU,
    submitReceivingKSU,
    generateQRReceivingUnitKSU,
    updateNumberOfPrintQRCodeKSU,
    deleteReceivingKSU,

    getAllMasterBank,
    saveMasterBank,
    updateStatusMasterBank,
    deleteMasterBank,
    getMasterBankById,

    getAllMutation,
    getMutationById,
    deleteMutation,
    createMutation,
    submitMutation,
    rejectAllMutation,
    getUnitList,
    findBarcodeUnitMutation,
    findBarcodeKsuBrlHdhMutation,
    getNoSinByEncryptedBarcode,

    getAllPOUnit,
    getPOUnitById,
    getTempPOUnit,
    createPOUnit,
    deletePOUnit,

    getAllMasterPart,
    submitPart,
    getByKodePart,
    updateStatusPart,
    deletePart,
    downloadTemplateMasterPart,
    downloadErrorLogMasterPart,
    uploadMasterPart,

    getAllMasterApprovalFindByParam,
    getMasterApprovalById,
    saveMasterApproval,
    updateStatusMasterApproval,
    deleteMasterApproval,

    findAllClaimC1,
    findByClaimNo,
    submitClaimC1,
    deleteClaimC1,

    testAPIError,
    getGenSeqWithoutSave,
    getEngineNumberByKodeLocator,
    getUnitDetailByEngineNumber,
    generateSeqWithoutSave,

    getAllMasterUnitPrice,
    getMasterUnitPriceById,
    createMasterUnitPrice,
    deleteMasterUnitPrice,
    downloadTemplateMasaterUnitPrice,
    uploadTemplateMasaterUnitPrice,
    downloadLogErrorTemplateMasaterUnitPrice,

    getPreviewBarcode,

    getBizparCategoryByParam,
    deleteAllBizparByCategory,

    generateMasterPackageId,
    getAllMasterPackageFindByParam,
    getMasterPackageById,
    saveMasterPackage,
    updateStatusMasterPackage,
    copyMasterPackage,

    getAllSSU,
    getSubmissionSSU,
    getReceivedSSU,
    getReceivedSSUByPeriod,
    createSSU,
    deleteSSU,
    getSSUById,
    uploadSSUPhoto,

    getAllMasterSales,
    getMasterSalesById,
    getMasterSalesByteam,
    createMasterSales,
    findSalesNotInSalesLead,
    findSalesNotInSalesTeam,
    deleteSalesLead,
    deleteSales,

    findAllBeforeSubmissionSamsat,
    findAllOnSubmissionSamsat,
    findDetailOnSubmissionSamsat,
    getDraftForSubmission,
    saveSubmission,
    exportToExcelSubmission,
    findAllReceivingSamsat,
    findDetailReceivingSamsat,
    saveReceivingSamsatSTNK,
    saveReceivingSamsatLembarPajak,
    saveReceivingSamsatBPKB,
    saveReceivingSamsatPlatKendaraan,

    findAllPenyerahanBBNIndividu,
    findDetailPenyerahanBBNIndividu,
    savePenyerahanBBNIndividu,
    printBbnIndividu,

    findAllPenyerahanBBNLeasing,
    findDetailPenyerahanBBNLeasing,
    findBPKBReady,
    savePenyerahanBBNLeasing,
    exportToExcelBBNLeasing,

    getAllMasterBBN,
    getDetailMasterBBN,
    saveMasterBBN,
    deleteMasterBBN,
    downloadTemplateBBN,
    uploadTemplateBBN,
    downloadLogErrorBBN,

    getDeliveryData,
    submitDeliveryData,
    getDeliveryDetail,
    uploadDeliveryImage,
    updateDeliveryStatus,

    getAllPDI,
    getAllDonePDI,
    getPDIById,
    modifyPDI,
    refreshPDIAndExpedition,
    checkPDIToDeliveryItem,
    checkStatusBarcodeBulk,

    getAllIndentUnit,
    cancelIndentUnit,
    getIndentUnitDetail,
    modifyIndentUnit,
    getIndentProspect,
    getIndentCustomer,

    getAllLeasingPayment,
    getDetailLeasing,
    submitLeasingPayment,
    getEmployeeForDDLLeasingPayment,
    getBBMForPaymentLeasing,

    getBKKData,
    getPaymentCashStatus,
    getBKKDetail,
    submitPaymentCash,
    printBKK,
    getBKMData,
    getBKMDetail,
    printBKM,
    getPaymentCashCancel,
    cancelPaymentCash,
    updatePrintCountAndStatusCash,

    getPaymentBankStatus,
    submitPaymentBank,
    getBBMData,
    getBBKData,
    getBBMDetail,
    getBBKDetail,
    getReferenceFJ,
    getReferenceSO,
    getPaymentBankCancel,
    cancelPaymentBank,
    printBBK,
    printBBM,
    updatePrintCountAndStatusBank,
    verifyPoNumberLeasing,
    printMainPageSalesOrderNos,

    getAllEkspedisi,
    getDetailEkspedisi,
    prosesEkspedisi,
    cetakBASTDealer,
    cetakBASTMainDealer,
    cetakBASTBukuService,
    cetakBASTTemplate,
    getDataForEkspedisi,
    getDataForEkspedisiPart,

    getAllCDB,
    getDetailCDB,
    getDataCabangHistoryCDB,
    getDetailHistoryServiceCDB,
    updateSpecialNoteCDB,
    uploadProfilePictureCDB,
    getCustomerNonUUID,

    getListSalesOrderNOS,
    getListUnitForSalesOrder,
    getListCustomerForSalesOrder,
    getDataHeaderSalesOrderNOS,
    getDetailBuyerSalesOrder,
    getDetailOwnerSalesOrder,
    getDetailPhotoSalesOrder,
    getDetailUnitSalesOrder,
    getDetailPackageSalesOrder,
    getListPackageSalesOrder,
    getDetailTransactionSalesOrder,
    getDetailDeliverySalesOrder,
    getDetailReferralSalesOrder,
    getDetailNoteSalesOrder,
    submitSalesOrder,
    checkNIKSalesOrder,
    getProspectForSalesOrder,
    getIndentForSalesOrder,
    getPriceUnitSalesOrder,
    getMasterPromoSalesOrder,
    getMasterPromoCreditSalesOrder,
    getDropDownListSalesForSalesOrder,
    printSalesOrder,

    getListMasterPromo,
    getByIdMasterPromo,
    getPreviewIdMasterPromo,
    getTemplateExcelMasterPromo,
    uploadExcelDataMasterPromo,
    copyMasterPromo,
    deleteMasterPromo,
    saveAndUpdateMasterPromo,

    getDataTabAssignProspect,
    getDetailProspect,
    assignProspect,
    getEmployeeForCRM,

    getTabMasterVoucher,
    getByVoucherId,
    deleteByVoucherId,
    saveAndUpdateVoucher,
    checkExistingVoucherName,

    getDataForCreateProspect,
    getDetailCDBManagement,
    getDetailRequestUpdateCDBManagement,
    getDetailRequestUpdateById,
    submitToH1CDBManagement,
    getDataForRequestUpdate,
    processToCustomerProfileCDMManagement,
    submitRequestUpdateCDMManagement,
    updateStatusRequestUpdateCDMManagement,
    processFromRequestUpdateCDBManagement,
    checkEligibleNIKForProspect,

    findAllTypeByListKodeSeries,
    findAllVariantByListKodeType,
    findAllWarnaByListKodeVariant,
    getLaporanIndentMothly,
    getLaporanStrukturCSSalesmanLastThreeYear,
    getLaporanKontribusiFincoyPerCabangLastThreeYear,
    getLaporanStatistikCabang,
    getLaporanStatistikTeamLead,
    getLaporanStatistikSalesCS,
    getLaporanIndenCabang,
    getLaporanGrowthFincoyMTDPercabang,
    getLaporanKomposisiCashCredit3TahunTerakhir,
    getLaporanKomposisiCashCreditTahunBerjalan,
    getLaporanStrukturCSSalesmanTahunBerjalan,
    getLaporanKomposisiFincoyTigaTahunTerakhir,
    getLaporanKomposisiFincoyYTD,
    getLaporanJualan3TahunTerakhir,
    getLaporanStrukturDanKomposisiJualPerCabang,
    getLaporanPenjualanYTDMetodePembayaranDanLeasing,
    getLaporanPenjualanMTD,
    getLaporanJualanMTDSalesmanCS,
    getLaporanJualanHarianPerCabang,
    getLaporanJualanHarian,
    getLaporanStatistikROCrossSellingYTDXOH21p,

    deleteFollowUpProspect,
    checkFUProspect,
    findAllDataFU,
    saveFUProspect,
    getDetailFU,
    checkNIKForFU,

    getDataNotificationTabCustomer,
    getDetailNotification,
    submitNotificationCustomer,
    getDataNotificationTabSystem,
    uploadExcelNotificationListCustomer,
    deleteNotification,

    getDataSalesOrderDGI,
    submitDataSalesOrderDGI,
    getDataOwnerSODGI,
    getDataUnitSODGI,
    getDataBuyerSODGI,

    getCashierDailyCash,
    getCashierDailyBank,
    getMonitoringBBMCashier,
    getMonitoringBBKCashier,
    getMonitoringBKMCashier,
    getMonitoringBKKCashier,
    getCashierTotal,

    getDataProfitUnitDailyAccounting,
    getDataProfitUnitMonthlyAccounting,

    getLaporanPenjualanPerVariantKacab,
    getLaporanPenjualanPerTypeKacab,
    getLaporanPenjualanPerSeriesKacab,
    getLaporanPenjualanPerSubSegmentKacab,

    getLaporanPenjualanPerTypeYTD,
    getLaporanPenjualanPerVariantYTD,
    getLaporanPenjualanPerSeriesYTD,
    getLaporanPenjualanPerSubSegmentYTD,
    findUserById,

    getLaporanStatistikToday,
    getLaporanAppointmentFUToDay,
    getLaporanAppointmentOverdue,

    getLaporanStatistikROCrossSelling,
    getLaporanStatistikROCrossSellingYTDROH1,
    getLaporanStatistikROCrossSellingYTDROH23,
    getLaporanStatistikROCrossSellingYTDXOH21,

    getListDataMotorByMemberId,
    printStockOpname,
    exportToExcelManagementCDB,
    getInvoicePenagihanLeasing,
    getLetterCoverPenagihanLeasing,
    updatePrintCountLetterCoverPenagihanLeasing,
    generateCetakanPengajuanSamsat,
    generateCetakanPenyerahanBBNLeasing,

    getPrintCount,
    updatePrintCount,

    masterServiceMainPage,
    masterServiceDetail,
    masterServiceUpdateStatus,
    masterServiceDelete,
    masterServiceSubmit,
    masterServiceDownloadExcel,
    masterServiceUploadExcel,
    salesOrderUpdateStatus,
    checkPOUnitExist,
    getVerifyStockOpname,
    getAllManagementApproval,
    getDetailManagementApproval,
    submitManagementApproval,
    downloadReceivingKSUExcel,
    printBBKRealizationReport,
    printBBMRealizationReport,
    printBKKRealizationReport,
    printBKMRealizationReport,
    downloadReceivingUnitNOSExcel,
    downloadReceivingUnitDGIExcel,
    downloadInventoryUnitExcel,
    exportPOUnitDetailToExcel,
    getAllMenuForApproval,
    exportToExcelApproval,
    getAllManagementNRFS,
    updateNRFSUnit,
    checkPrintQRKSUApproval,
    createApprovalPrint,
    checkApprovalPrintBKK,
    submitProcessMutationOut,
    getAllMasterCOA,
    updateStatusMasterCOA,
    deleteMasterCOA,
    generateMasterCOAId,
    getMasterCOAById,
    saveMasterCOA,
    findDetailCoaPayment,
    getMasterSopirData,
    updateStatusSopir,
    deleteSopirById,
    getDetailSopirByDriverId,
    getEmployeeForDriver,
    saveUpdateMasterSopir,
    getAllUserForMasterDriver,
    getAllIdUserDriver,
    getMasterUserById,
    findEmployeeByUserId,
    getCabangByIdUser,
    getDriverForEkspedisi,
    checkApprovalPrintTransaction,
    cetakInventoryMainPage,
    getBBNPhotoById,
    manualTriggerGetFJDgi,
    updateSuperAccess,
    getMainDealerForSalesOrderDGI,
    findCabangForSalesOrderDGI,
    getDropDownListMenuForMasterUser,
    cetakExcelPenagihanLeasing,
    getAllMasterBooking,
    saveMasterBooking,
    deleteMasterBooking,
    getAllMasterMechanic,
    getEmployeeForMechanic,
    createMechanic,
    deleteMechanic,
    createMasterAcuanStock,
    getMasterAcuanStock,
    getDetailMasterAcuanStock,
    deleteMasterAcuan,
    getAllMasterPartPrice,
    getMasterPartPriceById,
    getQrFormatWithoutCabang,
    createMasterPartPrice,
    deleteMasterPartPrice,
    getCabangbyMainDealer,
    getTemplateExcelMasterPartPrice,
    uploadTemplateMasaterPartPrice,
    getDownloadLogErrorPartPrice,
    getCopyMasterAcuanStock,
    masterServiceDownloadLogError,
    updateStatusMasterHargaJasa,
    uploadExcelMasterHargaJasa,
    downloadTemplateExcelMasterHargaJasa,
    getDetailMasterHargaJasa,
    createMasterHargaJasa,
    getMainPageMasterHargaJasa,
    getMainPagePromoH23,
    getPreviewIdMasterPromoH23,
    getDetailMasterPromoH23,
    createMasterPromoH23,
    deleteMasterPromoH2,
    getCopyDataPromoH2,
    getServicePromoH23,
    findAllByListKey,
    getDataMechanicManagementMainPage,
    downloadLogExcelMasterHargaJasa,
    submitMechanicManagement,
    getDetailMechanicManagement,
    checkMonthMechanicManagement,
    getDataManagementBooking,
    getDetailManagementBooking,
    submitManagementBooking,
    printExcelManagementBooking,
    getTimeForManagementBooking,
    getMainPageReceivingOtherItem,
    submitReceivingOtherItem,
    getDetailReceivingOtherItem,
    checkQtyOtherItem,
    downloadReceivingItemsExcel,
    updateNumberOfPrintQRCodeItems,
    deleteReceivingOtherItem,
    getDataMainPagePackageH2,
    generateMasterPackageH2Id,
    getMasterPackageH2ById,
    getVariantBySegmentId,
    updateStatusMasterPackageH2,
    copyMasterPackageH2,
    getServiceForPackage,
    getPartForPackage,
    saveMasterPackageH2,
    getAllReceivingPartNOSByParam,
    getReceivingPartNOSById,
    submitReceivingPartNOS,
    deleteReceivingPartNOS,
    getAllReceivingPartDGI,
    getAllReceivingPartDGIBy,
    updateReceivingPartDGI,
    checkNonQrCanUpdate,
    updateNumberOfPrintQRCodePartNOS,
    generateExcelPart,
    submitReceivingGift,
    getDataMainPageReceivingGit,
    getDetailReceivingGift,
    checkQtyGift,
    deleteReceivingGift,
    downloadReceivingGiftExcel,
    updateNumberOfPrintsReceivingGift,
    checkQtyMutasiHadiahDanBarangLain,
    getLaporanInden,
    followUpWa,
    getAllMutationPart,
    getMutationPartById,
    deleteMutationPart,
    submitDataMutationPart,
    processMutationPart,
    getLaporanInden,
    getGiftForStockOpname,
    getPartForStockOpname,
    getDetailStockOpnamePart,
    findBarcodePartMutation,
    rejectAllMutationPart,
    generatePrintMutationPart,
    generatePrintExcelMutationPart,
    getLaporanInden,
    getSalesDropdownForDashboard,
    getTLByEmployeeId,
    submitToH23CDBManagement,
    submitProcessStockOpnameGIFT,
    submitProcessStockOpnamePart,
    getStockOpnameGiftDetail,
    getOtherItemForStockOpname,
    submitProcessStockOpnameOtherItem,
    getStockOpnameOtherItemDetail,
    getAllInventoryGiftByParam,
    getDetailInventoryGift,
    getListBBMManagementClaim,
    getListBKKBBKManagementClaim,
    checkUnitManagementClaim,
    getManagementClaimMainPage,
    getNamaPelaporManagementClaim,
    getPartManagementClaim,
    saveUpdateManagementClaim,
    getDetailManagementClaim,
    getDetailHistoryInventoryGift,
    getGiftStockCard,
    getGiftStockCardDetailQR,
    getGiftStockCardDetailNonQR,
    generateReportExcelInventoryGift,
    updateStatusManagementClaim,
    getInventoryPartMainPage,
    getDetailInventoryPart,
    getBarcodeHistoryInventoryPart,
    getExcelReportMainPageInventoryPart,
    getStockInventoryPart,
    getStockHistoryInventoryPartWithQR,
    getStockHistoryInventoryPartNonQR,
    getMechanicNameFjb,
    getDetailNosinFjb,
    getDataClaimFjb,
    getUserProfileByNoSin,
    getLocatorDataTransactionFjb,
    getDataPackageFjb,
    getJasaFjb,
    getPartFJB,
    getFJBNOSMainPage,
    submitFjbNOS,
    getPromoFjb,
    getHeaderFjbNos,
    getTabDataUnitNos,
    getTabDataPemilikNos,
    getTabDataPembawaNos,
    getTabDataAnalisaNos,
    getTabTransaksiNos,
    getTabTambahanNos,
    getTabKeteranganNos,
    getFJBgiMainPage,
    getFJBDgiManualy,
    getHeaderFJBDgi,
    getTabDataUnitDgi,
    getTabDataPemilikDgi,
    getTabDataPembawaDgi,
    getTabDataAnalisaDgi,
    getTabDataTransaksiDgi,
    getTabDataTambahanDgi,
    getTabDataKeteranganDgi,
    getAllInventoryOtherItemByParam,
    getPartAndJasaByPackageId,
    updateStatusFJB,
    getReferenceFJB,
    getPromoDetailFjb,
    getStockAndPartsByLocatorFjb,
    generateExcelMonitoringFJb,
    scanBarcodeFjb,
    printNotaFjb,
    getDetailInventoryOtherItem,
    getDetailHistoryInventoryOtherItem,
    getOtherItemStockCard,
    getOtherItemStockCardDetailBarcode,
    getOtherItemStockCardDetailNonBarcode,
    generateReportExcelInventoryOtherItem,
    getPoPartMainPage,
    getPoPartTem,
    getPoPartListByListCategory,
    getTemporaryDataForPOEdit,
    getFjbBookingNo,
    getClaimPartByManagementId,
    getRankingForPOPartDTO,
    checkPoPart,
    getPoPartById,
    deletePoPart,
    printPoPart,
    submitPoPart,
    getDealerAhmByKodeCabang,
    findBarcodePartInventory,
    getLaporanProspectStatistikToday,
    getLaporanAppointmentProspect,
    getLaporanStatistikProspectCabang,
    getDataCabangForManagementClaim,
    getLaporanJualan3TahunTerakhirH23,
    getLaporanServisHarianH23,
    getLaporanUnitEntryHarianByMekanikH23,
    getLaporanJualan3TahunTerakhirByCabangH23,
    getLaporanUnitServiceHarianByMekanikH23,
    getLaporanServisMTDH23,
    getMechanicForDropDownListDashboard,
    getLaporanUnitEntriMTDByCabangH23,
    getLaporanLast3YearUnitServiceH23,
    getLaporanUnitServiceMTDByMechanicH23,
    getLaporanUnitEntriMTDByMekanikH23,
    getLaporanServiceYTDH23,
    getLaporanUnitEntryLastThreeYearH23,
    getLaporanJualPartYTDByMechanicH23,
    getLaporanPartHarianH23,
    getLaporanJualPartYearToDateByCabangH23,
    getLaporanStatistikBooking,
    getLaporanFJBByTypeYTD,
    getLaporanPendapatanJobHarian,
    getLaporanPartsInOutYearToDate,
    getLaporanSalesAbilityYTD,
    getLaporanJualJobYearToDate,
    getLaporanFjbByPaket,
    getLaporanFjbByPromo,
    getLaporanHarianPartByMekanik,
    getLaporanPartEmployeeSalesMTD,
    getLaporanSalesPartMTD,
    generateExcelFromPayload,
    generateAdvancedExcelFromPayload,
    getLaporanPartBranchSalesMTD,
    getLaporanUnitServisNonKpbMTD,
    getLaporanUnitServisNonKpbLastThreeYear,
    getLaporanStatistikDrop,
    getLaporanStatistikAsalProspek,
    getLaporanStatistikKPB,
    getMasterPromoWilayahByUserId,
    downloadLogErrorMasterPromo,
    downloadWarnaSegmentExcel,
    downloadVariantSegmenExcel,
    printPDFIndentUnit,
    generateExcelIndentUnit,
    checkDeleteMasterRole,
    cancelOrderFJ
  };
};

export default { create };
